// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.35.0
// source: triggers.proto
/* eslint-disable */
import { BinaryReader, BinaryWriter } from '@bufbuild/protobuf/wire'

import {
  ChartTimeframe,
  chartTimeframeFromJSON,
  chartTimeframeToJSON,
  Exchange,
  exchangeFromJSON,
  exchangeToJSON,
  OptionType,
  optionTypeFromJSON,
  optionTypeToJSON,
  PriceReference,
  priceReferenceFromJSON,
  priceReferenceToJSON,
  TradeVenue,
  tradeVenueFromJSON,
  tradeVenueToJSON,
} from './common/types'

export const protobufPackage = 'triggers'

/**
 * Discriminator for the `Condition` oneof — one value per variant. Used only for
 * plan-tier entitlement gating (which condition kinds a tier may register); the
 * wire trigger still carries the full `Condition`. Keep in sync with the oneof.
 */
export enum TriggerConditionType {
  TRIGGER_CONDITION_TYPE_UNSPECIFIED = 0,
  TRIGGER_CONDITION_TYPE_PRICE = 1,
  TRIGGER_CONDITION_TYPE_SCHEDULE = 2,
  TRIGGER_CONDITION_TYPE_ACTION_EVENT = 3,
  TRIGGER_CONDITION_TYPE_AND = 4,
  TRIGGER_CONDITION_TYPE_OR = 5,
  TRIGGER_CONDITION_TYPE_TECHNICAL_INDICATOR = 6,
  TRIGGER_CONDITION_TYPE_RETURNS = 7,
  TRIGGER_CONDITION_TYPE_CANDLE = 8,
  TRIGGER_CONDITION_TYPE_PORTFOLIO_METRIC = 9,
  TRIGGER_CONDITION_TYPE_POSITION_METRIC = 10,
  TRIGGER_CONDITION_TYPE_OPTION_IV = 11,
  TRIGGER_CONDITION_TYPE_DB_NEWS = 12,
  TRIGGER_CONDITION_TYPE_RISK_METRIC = 13,
  TRIGGER_CONDITION_TYPE_POLYMARKET = 14,
  UNRECOGNIZED = -1,
}

export function triggerConditionTypeFromJSON(object: any): TriggerConditionType {
  switch (object) {
    case 0:
    case 'TRIGGER_CONDITION_TYPE_UNSPECIFIED':
      return TriggerConditionType.TRIGGER_CONDITION_TYPE_UNSPECIFIED
    case 1:
    case 'TRIGGER_CONDITION_TYPE_PRICE':
      return TriggerConditionType.TRIGGER_CONDITION_TYPE_PRICE
    case 2:
    case 'TRIGGER_CONDITION_TYPE_SCHEDULE':
      return TriggerConditionType.TRIGGER_CONDITION_TYPE_SCHEDULE
    case 3:
    case 'TRIGGER_CONDITION_TYPE_ACTION_EVENT':
      return TriggerConditionType.TRIGGER_CONDITION_TYPE_ACTION_EVENT
    case 4:
    case 'TRIGGER_CONDITION_TYPE_AND':
      return TriggerConditionType.TRIGGER_CONDITION_TYPE_AND
    case 5:
    case 'TRIGGER_CONDITION_TYPE_OR':
      return TriggerConditionType.TRIGGER_CONDITION_TYPE_OR
    case 6:
    case 'TRIGGER_CONDITION_TYPE_TECHNICAL_INDICATOR':
      return TriggerConditionType.TRIGGER_CONDITION_TYPE_TECHNICAL_INDICATOR
    case 7:
    case 'TRIGGER_CONDITION_TYPE_RETURNS':
      return TriggerConditionType.TRIGGER_CONDITION_TYPE_RETURNS
    case 8:
    case 'TRIGGER_CONDITION_TYPE_CANDLE':
      return TriggerConditionType.TRIGGER_CONDITION_TYPE_CANDLE
    case 9:
    case 'TRIGGER_CONDITION_TYPE_PORTFOLIO_METRIC':
      return TriggerConditionType.TRIGGER_CONDITION_TYPE_PORTFOLIO_METRIC
    case 10:
    case 'TRIGGER_CONDITION_TYPE_POSITION_METRIC':
      return TriggerConditionType.TRIGGER_CONDITION_TYPE_POSITION_METRIC
    case 11:
    case 'TRIGGER_CONDITION_TYPE_OPTION_IV':
      return TriggerConditionType.TRIGGER_CONDITION_TYPE_OPTION_IV
    case 12:
    case 'TRIGGER_CONDITION_TYPE_DB_NEWS':
      return TriggerConditionType.TRIGGER_CONDITION_TYPE_DB_NEWS
    case 13:
    case 'TRIGGER_CONDITION_TYPE_RISK_METRIC':
      return TriggerConditionType.TRIGGER_CONDITION_TYPE_RISK_METRIC
    case 14:
    case 'TRIGGER_CONDITION_TYPE_POLYMARKET':
      return TriggerConditionType.TRIGGER_CONDITION_TYPE_POLYMARKET
    case -1:
    case 'UNRECOGNIZED':
    default:
      return TriggerConditionType.UNRECOGNIZED
  }
}

export function triggerConditionTypeToJSON(object: TriggerConditionType): string {
  switch (object) {
    case TriggerConditionType.TRIGGER_CONDITION_TYPE_UNSPECIFIED:
      return 'TRIGGER_CONDITION_TYPE_UNSPECIFIED'
    case TriggerConditionType.TRIGGER_CONDITION_TYPE_PRICE:
      return 'TRIGGER_CONDITION_TYPE_PRICE'
    case TriggerConditionType.TRIGGER_CONDITION_TYPE_SCHEDULE:
      return 'TRIGGER_CONDITION_TYPE_SCHEDULE'
    case TriggerConditionType.TRIGGER_CONDITION_TYPE_ACTION_EVENT:
      return 'TRIGGER_CONDITION_TYPE_ACTION_EVENT'
    case TriggerConditionType.TRIGGER_CONDITION_TYPE_AND:
      return 'TRIGGER_CONDITION_TYPE_AND'
    case TriggerConditionType.TRIGGER_CONDITION_TYPE_OR:
      return 'TRIGGER_CONDITION_TYPE_OR'
    case TriggerConditionType.TRIGGER_CONDITION_TYPE_TECHNICAL_INDICATOR:
      return 'TRIGGER_CONDITION_TYPE_TECHNICAL_INDICATOR'
    case TriggerConditionType.TRIGGER_CONDITION_TYPE_RETURNS:
      return 'TRIGGER_CONDITION_TYPE_RETURNS'
    case TriggerConditionType.TRIGGER_CONDITION_TYPE_CANDLE:
      return 'TRIGGER_CONDITION_TYPE_CANDLE'
    case TriggerConditionType.TRIGGER_CONDITION_TYPE_PORTFOLIO_METRIC:
      return 'TRIGGER_CONDITION_TYPE_PORTFOLIO_METRIC'
    case TriggerConditionType.TRIGGER_CONDITION_TYPE_POSITION_METRIC:
      return 'TRIGGER_CONDITION_TYPE_POSITION_METRIC'
    case TriggerConditionType.TRIGGER_CONDITION_TYPE_OPTION_IV:
      return 'TRIGGER_CONDITION_TYPE_OPTION_IV'
    case TriggerConditionType.TRIGGER_CONDITION_TYPE_DB_NEWS:
      return 'TRIGGER_CONDITION_TYPE_DB_NEWS'
    case TriggerConditionType.TRIGGER_CONDITION_TYPE_RISK_METRIC:
      return 'TRIGGER_CONDITION_TYPE_RISK_METRIC'
    case TriggerConditionType.TRIGGER_CONDITION_TYPE_POLYMARKET:
      return 'TRIGGER_CONDITION_TYPE_POLYMARKET'
    case TriggerConditionType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum ComparisonOperator {
  COMPARISON_OPERATOR_UNSPECIFIED = 0,
  COMPARISON_OPERATOR_GREATER_THAN = 1,
  COMPARISON_OPERATOR_GREATER_THAN_OR_EQUAL = 2,
  COMPARISON_OPERATOR_LESS_THAN = 3,
  COMPARISON_OPERATOR_LESS_THAN_OR_EQUAL = 4,
  COMPARISON_OPERATOR_EQUAL = 5,
  COMPARISON_OPERATOR_NOT_EQUAL = 6,
  /**
   * COMPARISON_OPERATOR_CROSS_ABOVE - Edge operators are strict on the current sample and inclusive on the
   * previous sample: CROSS_ABOVE fires only when previous <= target and current
   * > target; CROSS_BELOW fires only when previous >= target and current < target.
   */
  COMPARISON_OPERATOR_CROSS_ABOVE = 7,
  COMPARISON_OPERATOR_CROSS_BELOW = 8,
  UNRECOGNIZED = -1,
}

export function comparisonOperatorFromJSON(object: any): ComparisonOperator {
  switch (object) {
    case 0:
    case 'COMPARISON_OPERATOR_UNSPECIFIED':
      return ComparisonOperator.COMPARISON_OPERATOR_UNSPECIFIED
    case 1:
    case 'COMPARISON_OPERATOR_GREATER_THAN':
      return ComparisonOperator.COMPARISON_OPERATOR_GREATER_THAN
    case 2:
    case 'COMPARISON_OPERATOR_GREATER_THAN_OR_EQUAL':
      return ComparisonOperator.COMPARISON_OPERATOR_GREATER_THAN_OR_EQUAL
    case 3:
    case 'COMPARISON_OPERATOR_LESS_THAN':
      return ComparisonOperator.COMPARISON_OPERATOR_LESS_THAN
    case 4:
    case 'COMPARISON_OPERATOR_LESS_THAN_OR_EQUAL':
      return ComparisonOperator.COMPARISON_OPERATOR_LESS_THAN_OR_EQUAL
    case 5:
    case 'COMPARISON_OPERATOR_EQUAL':
      return ComparisonOperator.COMPARISON_OPERATOR_EQUAL
    case 6:
    case 'COMPARISON_OPERATOR_NOT_EQUAL':
      return ComparisonOperator.COMPARISON_OPERATOR_NOT_EQUAL
    case 7:
    case 'COMPARISON_OPERATOR_CROSS_ABOVE':
      return ComparisonOperator.COMPARISON_OPERATOR_CROSS_ABOVE
    case 8:
    case 'COMPARISON_OPERATOR_CROSS_BELOW':
      return ComparisonOperator.COMPARISON_OPERATOR_CROSS_BELOW
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ComparisonOperator.UNRECOGNIZED
  }
}

export function comparisonOperatorToJSON(object: ComparisonOperator): string {
  switch (object) {
    case ComparisonOperator.COMPARISON_OPERATOR_UNSPECIFIED:
      return 'COMPARISON_OPERATOR_UNSPECIFIED'
    case ComparisonOperator.COMPARISON_OPERATOR_GREATER_THAN:
      return 'COMPARISON_OPERATOR_GREATER_THAN'
    case ComparisonOperator.COMPARISON_OPERATOR_GREATER_THAN_OR_EQUAL:
      return 'COMPARISON_OPERATOR_GREATER_THAN_OR_EQUAL'
    case ComparisonOperator.COMPARISON_OPERATOR_LESS_THAN:
      return 'COMPARISON_OPERATOR_LESS_THAN'
    case ComparisonOperator.COMPARISON_OPERATOR_LESS_THAN_OR_EQUAL:
      return 'COMPARISON_OPERATOR_LESS_THAN_OR_EQUAL'
    case ComparisonOperator.COMPARISON_OPERATOR_EQUAL:
      return 'COMPARISON_OPERATOR_EQUAL'
    case ComparisonOperator.COMPARISON_OPERATOR_NOT_EQUAL:
      return 'COMPARISON_OPERATOR_NOT_EQUAL'
    case ComparisonOperator.COMPARISON_OPERATOR_CROSS_ABOVE:
      return 'COMPARISON_OPERATOR_CROSS_ABOVE'
    case ComparisonOperator.COMPARISON_OPERATOR_CROSS_BELOW:
      return 'COMPARISON_OPERATOR_CROSS_BELOW'
    case ComparisonOperator.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum ActionEventType {
  ACTION_EVENT_TYPE_UNSPECIFIED = 0,
  ACTION_EVENT_TYPE_PLACED = 1,
  ACTION_EVENT_TYPE_FILLED = 2,
  ACTION_EVENT_TYPE_PARTIALLY_FILLED = 3,
  ACTION_EVENT_TYPE_CANCELLED = 4,
  ACTION_EVENT_TYPE_FAILED = 5,
  UNRECOGNIZED = -1,
}

export function actionEventTypeFromJSON(object: any): ActionEventType {
  switch (object) {
    case 0:
    case 'ACTION_EVENT_TYPE_UNSPECIFIED':
      return ActionEventType.ACTION_EVENT_TYPE_UNSPECIFIED
    case 1:
    case 'ACTION_EVENT_TYPE_PLACED':
      return ActionEventType.ACTION_EVENT_TYPE_PLACED
    case 2:
    case 'ACTION_EVENT_TYPE_FILLED':
      return ActionEventType.ACTION_EVENT_TYPE_FILLED
    case 3:
    case 'ACTION_EVENT_TYPE_PARTIALLY_FILLED':
      return ActionEventType.ACTION_EVENT_TYPE_PARTIALLY_FILLED
    case 4:
    case 'ACTION_EVENT_TYPE_CANCELLED':
      return ActionEventType.ACTION_EVENT_TYPE_CANCELLED
    case 5:
    case 'ACTION_EVENT_TYPE_FAILED':
      return ActionEventType.ACTION_EVENT_TYPE_FAILED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ActionEventType.UNRECOGNIZED
  }
}

export function actionEventTypeToJSON(object: ActionEventType): string {
  switch (object) {
    case ActionEventType.ACTION_EVENT_TYPE_UNSPECIFIED:
      return 'ACTION_EVENT_TYPE_UNSPECIFIED'
    case ActionEventType.ACTION_EVENT_TYPE_PLACED:
      return 'ACTION_EVENT_TYPE_PLACED'
    case ActionEventType.ACTION_EVENT_TYPE_FILLED:
      return 'ACTION_EVENT_TYPE_FILLED'
    case ActionEventType.ACTION_EVENT_TYPE_PARTIALLY_FILLED:
      return 'ACTION_EVENT_TYPE_PARTIALLY_FILLED'
    case ActionEventType.ACTION_EVENT_TYPE_CANCELLED:
      return 'ACTION_EVENT_TYPE_CANCELLED'
    case ActionEventType.ACTION_EVENT_TYPE_FAILED:
      return 'ACTION_EVENT_TYPE_FAILED'
    case ActionEventType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum PriceOffsetUnit {
  PRICE_OFFSET_UNIT_UNSPECIFIED = 0,
  PRICE_OFFSET_UNIT_QUOTE_VALUE = 1,
  PRICE_OFFSET_UNIT_BPS = 2,
  PRICE_OFFSET_UNIT_PERCENT = 3,
  PRICE_OFFSET_UNIT_TICKS = 4,
  UNRECOGNIZED = -1,
}

export function priceOffsetUnitFromJSON(object: any): PriceOffsetUnit {
  switch (object) {
    case 0:
    case 'PRICE_OFFSET_UNIT_UNSPECIFIED':
      return PriceOffsetUnit.PRICE_OFFSET_UNIT_UNSPECIFIED
    case 1:
    case 'PRICE_OFFSET_UNIT_QUOTE_VALUE':
      return PriceOffsetUnit.PRICE_OFFSET_UNIT_QUOTE_VALUE
    case 2:
    case 'PRICE_OFFSET_UNIT_BPS':
      return PriceOffsetUnit.PRICE_OFFSET_UNIT_BPS
    case 3:
    case 'PRICE_OFFSET_UNIT_PERCENT':
      return PriceOffsetUnit.PRICE_OFFSET_UNIT_PERCENT
    case 4:
    case 'PRICE_OFFSET_UNIT_TICKS':
      return PriceOffsetUnit.PRICE_OFFSET_UNIT_TICKS
    case -1:
    case 'UNRECOGNIZED':
    default:
      return PriceOffsetUnit.UNRECOGNIZED
  }
}

export function priceOffsetUnitToJSON(object: PriceOffsetUnit): string {
  switch (object) {
    case PriceOffsetUnit.PRICE_OFFSET_UNIT_UNSPECIFIED:
      return 'PRICE_OFFSET_UNIT_UNSPECIFIED'
    case PriceOffsetUnit.PRICE_OFFSET_UNIT_QUOTE_VALUE:
      return 'PRICE_OFFSET_UNIT_QUOTE_VALUE'
    case PriceOffsetUnit.PRICE_OFFSET_UNIT_BPS:
      return 'PRICE_OFFSET_UNIT_BPS'
    case PriceOffsetUnit.PRICE_OFFSET_UNIT_PERCENT:
      return 'PRICE_OFFSET_UNIT_PERCENT'
    case PriceOffsetUnit.PRICE_OFFSET_UNIT_TICKS:
      return 'PRICE_OFFSET_UNIT_TICKS'
    case PriceOffsetUnit.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum TechnicalIndicatorType {
  TECHNICAL_INDICATOR_TYPE_UNSPECIFIED = 0,
  TECHNICAL_INDICATOR_TYPE_SMA = 1,
  TECHNICAL_INDICATOR_TYPE_EMA = 2,
  UNRECOGNIZED = -1,
}

export function technicalIndicatorTypeFromJSON(object: any): TechnicalIndicatorType {
  switch (object) {
    case 0:
    case 'TECHNICAL_INDICATOR_TYPE_UNSPECIFIED':
      return TechnicalIndicatorType.TECHNICAL_INDICATOR_TYPE_UNSPECIFIED
    case 1:
    case 'TECHNICAL_INDICATOR_TYPE_SMA':
      return TechnicalIndicatorType.TECHNICAL_INDICATOR_TYPE_SMA
    case 2:
    case 'TECHNICAL_INDICATOR_TYPE_EMA':
      return TechnicalIndicatorType.TECHNICAL_INDICATOR_TYPE_EMA
    case -1:
    case 'UNRECOGNIZED':
    default:
      return TechnicalIndicatorType.UNRECOGNIZED
  }
}

export function technicalIndicatorTypeToJSON(object: TechnicalIndicatorType): string {
  switch (object) {
    case TechnicalIndicatorType.TECHNICAL_INDICATOR_TYPE_UNSPECIFIED:
      return 'TECHNICAL_INDICATOR_TYPE_UNSPECIFIED'
    case TechnicalIndicatorType.TECHNICAL_INDICATOR_TYPE_SMA:
      return 'TECHNICAL_INDICATOR_TYPE_SMA'
    case TechnicalIndicatorType.TECHNICAL_INDICATOR_TYPE_EMA:
      return 'TECHNICAL_INDICATOR_TYPE_EMA'
    case TechnicalIndicatorType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum CandleField {
  CANDLE_FIELD_UNSPECIFIED = 0,
  CANDLE_FIELD_OPEN = 1,
  CANDLE_FIELD_HIGH = 2,
  CANDLE_FIELD_LOW = 3,
  CANDLE_FIELD_CLOSE = 4,
  CANDLE_FIELD_VOLUME_BASE = 5,
  CANDLE_FIELD_VOLUME_QUOTE = 6,
  CANDLE_FIELD_VWAP = 7,
  CANDLE_FIELD_TWAP = 8,
  UNRECOGNIZED = -1,
}

export function candleFieldFromJSON(object: any): CandleField {
  switch (object) {
    case 0:
    case 'CANDLE_FIELD_UNSPECIFIED':
      return CandleField.CANDLE_FIELD_UNSPECIFIED
    case 1:
    case 'CANDLE_FIELD_OPEN':
      return CandleField.CANDLE_FIELD_OPEN
    case 2:
    case 'CANDLE_FIELD_HIGH':
      return CandleField.CANDLE_FIELD_HIGH
    case 3:
    case 'CANDLE_FIELD_LOW':
      return CandleField.CANDLE_FIELD_LOW
    case 4:
    case 'CANDLE_FIELD_CLOSE':
      return CandleField.CANDLE_FIELD_CLOSE
    case 5:
    case 'CANDLE_FIELD_VOLUME_BASE':
      return CandleField.CANDLE_FIELD_VOLUME_BASE
    case 6:
    case 'CANDLE_FIELD_VOLUME_QUOTE':
      return CandleField.CANDLE_FIELD_VOLUME_QUOTE
    case 7:
    case 'CANDLE_FIELD_VWAP':
      return CandleField.CANDLE_FIELD_VWAP
    case 8:
    case 'CANDLE_FIELD_TWAP':
      return CandleField.CANDLE_FIELD_TWAP
    case -1:
    case 'UNRECOGNIZED':
    default:
      return CandleField.UNRECOGNIZED
  }
}

export function candleFieldToJSON(object: CandleField): string {
  switch (object) {
    case CandleField.CANDLE_FIELD_UNSPECIFIED:
      return 'CANDLE_FIELD_UNSPECIFIED'
    case CandleField.CANDLE_FIELD_OPEN:
      return 'CANDLE_FIELD_OPEN'
    case CandleField.CANDLE_FIELD_HIGH:
      return 'CANDLE_FIELD_HIGH'
    case CandleField.CANDLE_FIELD_LOW:
      return 'CANDLE_FIELD_LOW'
    case CandleField.CANDLE_FIELD_CLOSE:
      return 'CANDLE_FIELD_CLOSE'
    case CandleField.CANDLE_FIELD_VOLUME_BASE:
      return 'CANDLE_FIELD_VOLUME_BASE'
    case CandleField.CANDLE_FIELD_VOLUME_QUOTE:
      return 'CANDLE_FIELD_VOLUME_QUOTE'
    case CandleField.CANDLE_FIELD_VWAP:
      return 'CANDLE_FIELD_VWAP'
    case CandleField.CANDLE_FIELD_TWAP:
      return 'CANDLE_FIELD_TWAP'
    case CandleField.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum PortfolioMetric {
  PORTFOLIO_METRIC_UNSPECIFIED = 0,
  /**
   * PORTFOLIO_METRIC_EQUITY - Equity in the row's own currency units (BTC for a Deribit BTC row).
   * Set PortfolioMetricCondition.currency to choose the row.
   */
  PORTFOLIO_METRIC_EQUITY = 1,
  /**
   * PORTFOLIO_METRIC_TOTAL_EQUITY_USD - Legacy: the first matching row's total_equity_usd, whose meaning varies
   * by venue (account total on Bybit/Deribit cross, one component on HL).
   * Prefer ACCOUNT_VALUE_USD.
   */
  PORTFOLIO_METRIC_TOTAL_EQUITY_USD = 2,
  /**
   * PORTFOLIO_METRIC_ACCOUNT_VALUE_USD - Whole-account value in USD: the venue's account_equity_usd, else the sum
   * of every currency's equity marked to USD.
   */
  PORTFOLIO_METRIC_ACCOUNT_VALUE_USD = 3,
  /** PORTFOLIO_METRIC_CURRENCY_EQUITY_USD - One currency's equity marked to USD. Requires currency. */
  PORTFOLIO_METRIC_CURRENCY_EQUITY_USD = 4,
  UNRECOGNIZED = -1,
}

export function portfolioMetricFromJSON(object: any): PortfolioMetric {
  switch (object) {
    case 0:
    case 'PORTFOLIO_METRIC_UNSPECIFIED':
      return PortfolioMetric.PORTFOLIO_METRIC_UNSPECIFIED
    case 1:
    case 'PORTFOLIO_METRIC_EQUITY':
      return PortfolioMetric.PORTFOLIO_METRIC_EQUITY
    case 2:
    case 'PORTFOLIO_METRIC_TOTAL_EQUITY_USD':
      return PortfolioMetric.PORTFOLIO_METRIC_TOTAL_EQUITY_USD
    case 3:
    case 'PORTFOLIO_METRIC_ACCOUNT_VALUE_USD':
      return PortfolioMetric.PORTFOLIO_METRIC_ACCOUNT_VALUE_USD
    case 4:
    case 'PORTFOLIO_METRIC_CURRENCY_EQUITY_USD':
      return PortfolioMetric.PORTFOLIO_METRIC_CURRENCY_EQUITY_USD
    case -1:
    case 'UNRECOGNIZED':
    default:
      return PortfolioMetric.UNRECOGNIZED
  }
}

export function portfolioMetricToJSON(object: PortfolioMetric): string {
  switch (object) {
    case PortfolioMetric.PORTFOLIO_METRIC_UNSPECIFIED:
      return 'PORTFOLIO_METRIC_UNSPECIFIED'
    case PortfolioMetric.PORTFOLIO_METRIC_EQUITY:
      return 'PORTFOLIO_METRIC_EQUITY'
    case PortfolioMetric.PORTFOLIO_METRIC_TOTAL_EQUITY_USD:
      return 'PORTFOLIO_METRIC_TOTAL_EQUITY_USD'
    case PortfolioMetric.PORTFOLIO_METRIC_ACCOUNT_VALUE_USD:
      return 'PORTFOLIO_METRIC_ACCOUNT_VALUE_USD'
    case PortfolioMetric.PORTFOLIO_METRIC_CURRENCY_EQUITY_USD:
      return 'PORTFOLIO_METRIC_CURRENCY_EQUITY_USD'
    case PortfolioMetric.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum PositionMetric {
  POSITION_METRIC_UNSPECIFIED = 0,
  POSITION_METRIC_QUANTITY = 1,
  POSITION_METRIC_MARK_PRICE = 2,
  POSITION_METRIC_UNREALIZED_PNL = 3,
  POSITION_METRIC_REALIZED_PNL = 4,
  POSITION_METRIC_DAILY_UNREALIZED_PNL = 5,
  POSITION_METRIC_INITIAL_MARGIN = 6,
  POSITION_METRIC_MAINTENANCE_MARGIN = 7,
  POSITION_METRIC_DELTA = 8,
  POSITION_METRIC_GAMMA = 9,
  POSITION_METRIC_VEGA = 10,
  POSITION_METRIC_THETA = 11,
  POSITION_METRIC_RHO = 12,
  POSITION_METRIC_DELTA_USD = 13,
  POSITION_METRIC_GAMMA_USD = 14,
  POSITION_METRIC_VEGA_USD = 15,
  POSITION_METRIC_THETA_USD = 16,
  POSITION_METRIC_UNREALIZED_PNL_USD = 17,
  POSITION_METRIC_REALIZED_PNL_USD = 18,
  POSITION_METRIC_DAILY_UNREALIZED_PNL_USD = 19,
  POSITION_METRIC_INITIAL_MARGIN_USD = 20,
  POSITION_METRIC_MAINTENANCE_MARGIN_USD = 21,
  UNRECOGNIZED = -1,
}

export function positionMetricFromJSON(object: any): PositionMetric {
  switch (object) {
    case 0:
    case 'POSITION_METRIC_UNSPECIFIED':
      return PositionMetric.POSITION_METRIC_UNSPECIFIED
    case 1:
    case 'POSITION_METRIC_QUANTITY':
      return PositionMetric.POSITION_METRIC_QUANTITY
    case 2:
    case 'POSITION_METRIC_MARK_PRICE':
      return PositionMetric.POSITION_METRIC_MARK_PRICE
    case 3:
    case 'POSITION_METRIC_UNREALIZED_PNL':
      return PositionMetric.POSITION_METRIC_UNREALIZED_PNL
    case 4:
    case 'POSITION_METRIC_REALIZED_PNL':
      return PositionMetric.POSITION_METRIC_REALIZED_PNL
    case 5:
    case 'POSITION_METRIC_DAILY_UNREALIZED_PNL':
      return PositionMetric.POSITION_METRIC_DAILY_UNREALIZED_PNL
    case 6:
    case 'POSITION_METRIC_INITIAL_MARGIN':
      return PositionMetric.POSITION_METRIC_INITIAL_MARGIN
    case 7:
    case 'POSITION_METRIC_MAINTENANCE_MARGIN':
      return PositionMetric.POSITION_METRIC_MAINTENANCE_MARGIN
    case 8:
    case 'POSITION_METRIC_DELTA':
      return PositionMetric.POSITION_METRIC_DELTA
    case 9:
    case 'POSITION_METRIC_GAMMA':
      return PositionMetric.POSITION_METRIC_GAMMA
    case 10:
    case 'POSITION_METRIC_VEGA':
      return PositionMetric.POSITION_METRIC_VEGA
    case 11:
    case 'POSITION_METRIC_THETA':
      return PositionMetric.POSITION_METRIC_THETA
    case 12:
    case 'POSITION_METRIC_RHO':
      return PositionMetric.POSITION_METRIC_RHO
    case 13:
    case 'POSITION_METRIC_DELTA_USD':
      return PositionMetric.POSITION_METRIC_DELTA_USD
    case 14:
    case 'POSITION_METRIC_GAMMA_USD':
      return PositionMetric.POSITION_METRIC_GAMMA_USD
    case 15:
    case 'POSITION_METRIC_VEGA_USD':
      return PositionMetric.POSITION_METRIC_VEGA_USD
    case 16:
    case 'POSITION_METRIC_THETA_USD':
      return PositionMetric.POSITION_METRIC_THETA_USD
    case 17:
    case 'POSITION_METRIC_UNREALIZED_PNL_USD':
      return PositionMetric.POSITION_METRIC_UNREALIZED_PNL_USD
    case 18:
    case 'POSITION_METRIC_REALIZED_PNL_USD':
      return PositionMetric.POSITION_METRIC_REALIZED_PNL_USD
    case 19:
    case 'POSITION_METRIC_DAILY_UNREALIZED_PNL_USD':
      return PositionMetric.POSITION_METRIC_DAILY_UNREALIZED_PNL_USD
    case 20:
    case 'POSITION_METRIC_INITIAL_MARGIN_USD':
      return PositionMetric.POSITION_METRIC_INITIAL_MARGIN_USD
    case 21:
    case 'POSITION_METRIC_MAINTENANCE_MARGIN_USD':
      return PositionMetric.POSITION_METRIC_MAINTENANCE_MARGIN_USD
    case -1:
    case 'UNRECOGNIZED':
    default:
      return PositionMetric.UNRECOGNIZED
  }
}

export function positionMetricToJSON(object: PositionMetric): string {
  switch (object) {
    case PositionMetric.POSITION_METRIC_UNSPECIFIED:
      return 'POSITION_METRIC_UNSPECIFIED'
    case PositionMetric.POSITION_METRIC_QUANTITY:
      return 'POSITION_METRIC_QUANTITY'
    case PositionMetric.POSITION_METRIC_MARK_PRICE:
      return 'POSITION_METRIC_MARK_PRICE'
    case PositionMetric.POSITION_METRIC_UNREALIZED_PNL:
      return 'POSITION_METRIC_UNREALIZED_PNL'
    case PositionMetric.POSITION_METRIC_REALIZED_PNL:
      return 'POSITION_METRIC_REALIZED_PNL'
    case PositionMetric.POSITION_METRIC_DAILY_UNREALIZED_PNL:
      return 'POSITION_METRIC_DAILY_UNREALIZED_PNL'
    case PositionMetric.POSITION_METRIC_INITIAL_MARGIN:
      return 'POSITION_METRIC_INITIAL_MARGIN'
    case PositionMetric.POSITION_METRIC_MAINTENANCE_MARGIN:
      return 'POSITION_METRIC_MAINTENANCE_MARGIN'
    case PositionMetric.POSITION_METRIC_DELTA:
      return 'POSITION_METRIC_DELTA'
    case PositionMetric.POSITION_METRIC_GAMMA:
      return 'POSITION_METRIC_GAMMA'
    case PositionMetric.POSITION_METRIC_VEGA:
      return 'POSITION_METRIC_VEGA'
    case PositionMetric.POSITION_METRIC_THETA:
      return 'POSITION_METRIC_THETA'
    case PositionMetric.POSITION_METRIC_RHO:
      return 'POSITION_METRIC_RHO'
    case PositionMetric.POSITION_METRIC_DELTA_USD:
      return 'POSITION_METRIC_DELTA_USD'
    case PositionMetric.POSITION_METRIC_GAMMA_USD:
      return 'POSITION_METRIC_GAMMA_USD'
    case PositionMetric.POSITION_METRIC_VEGA_USD:
      return 'POSITION_METRIC_VEGA_USD'
    case PositionMetric.POSITION_METRIC_THETA_USD:
      return 'POSITION_METRIC_THETA_USD'
    case PositionMetric.POSITION_METRIC_UNREALIZED_PNL_USD:
      return 'POSITION_METRIC_UNREALIZED_PNL_USD'
    case PositionMetric.POSITION_METRIC_REALIZED_PNL_USD:
      return 'POSITION_METRIC_REALIZED_PNL_USD'
    case PositionMetric.POSITION_METRIC_DAILY_UNREALIZED_PNL_USD:
      return 'POSITION_METRIC_DAILY_UNREALIZED_PNL_USD'
    case PositionMetric.POSITION_METRIC_INITIAL_MARGIN_USD:
      return 'POSITION_METRIC_INITIAL_MARGIN_USD'
    case PositionMetric.POSITION_METRIC_MAINTENANCE_MARGIN_USD:
      return 'POSITION_METRIC_MAINTENANCE_MARGIN_USD'
    case PositionMetric.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum RiskMetric {
  RISK_METRIC_UNSPECIFIED = 0,
  RISK_METRIC_PNL = 1,
  RISK_METRIC_DELTA = 2,
  RISK_METRIC_GAMMA = 3,
  RISK_METRIC_VEGA = 4,
  RISK_METRIC_THETA = 5,
  RISK_METRIC_RHO = 6,
  RISK_METRIC_VANNA = 7,
  RISK_METRIC_VOLGA = 8,
  RISK_METRIC_WEIGHTED_VEGA = 9,
  UNRECOGNIZED = -1,
}

export function riskMetricFromJSON(object: any): RiskMetric {
  switch (object) {
    case 0:
    case 'RISK_METRIC_UNSPECIFIED':
      return RiskMetric.RISK_METRIC_UNSPECIFIED
    case 1:
    case 'RISK_METRIC_PNL':
      return RiskMetric.RISK_METRIC_PNL
    case 2:
    case 'RISK_METRIC_DELTA':
      return RiskMetric.RISK_METRIC_DELTA
    case 3:
    case 'RISK_METRIC_GAMMA':
      return RiskMetric.RISK_METRIC_GAMMA
    case 4:
    case 'RISK_METRIC_VEGA':
      return RiskMetric.RISK_METRIC_VEGA
    case 5:
    case 'RISK_METRIC_THETA':
      return RiskMetric.RISK_METRIC_THETA
    case 6:
    case 'RISK_METRIC_RHO':
      return RiskMetric.RISK_METRIC_RHO
    case 7:
    case 'RISK_METRIC_VANNA':
      return RiskMetric.RISK_METRIC_VANNA
    case 8:
    case 'RISK_METRIC_VOLGA':
      return RiskMetric.RISK_METRIC_VOLGA
    case 9:
    case 'RISK_METRIC_WEIGHTED_VEGA':
      return RiskMetric.RISK_METRIC_WEIGHTED_VEGA
    case -1:
    case 'UNRECOGNIZED':
    default:
      return RiskMetric.UNRECOGNIZED
  }
}

export function riskMetricToJSON(object: RiskMetric): string {
  switch (object) {
    case RiskMetric.RISK_METRIC_UNSPECIFIED:
      return 'RISK_METRIC_UNSPECIFIED'
    case RiskMetric.RISK_METRIC_PNL:
      return 'RISK_METRIC_PNL'
    case RiskMetric.RISK_METRIC_DELTA:
      return 'RISK_METRIC_DELTA'
    case RiskMetric.RISK_METRIC_GAMMA:
      return 'RISK_METRIC_GAMMA'
    case RiskMetric.RISK_METRIC_VEGA:
      return 'RISK_METRIC_VEGA'
    case RiskMetric.RISK_METRIC_THETA:
      return 'RISK_METRIC_THETA'
    case RiskMetric.RISK_METRIC_RHO:
      return 'RISK_METRIC_RHO'
    case RiskMetric.RISK_METRIC_VANNA:
      return 'RISK_METRIC_VANNA'
    case RiskMetric.RISK_METRIC_VOLGA:
      return 'RISK_METRIC_VOLGA'
    case RiskMetric.RISK_METRIC_WEIGHTED_VEGA:
      return 'RISK_METRIC_WEIGHTED_VEGA'
    case RiskMetric.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum OptionIvSource {
  OPTION_IV_SOURCE_UNSPECIFIED = 0,
  OPTION_IV_SOURCE_BID_IV = 1,
  OPTION_IV_SOURCE_ASK_IV = 2,
  OPTION_IV_SOURCE_MARK_IV = 3,
  OPTION_IV_SOURCE_MID_IV = 4,
  UNRECOGNIZED = -1,
}

export function optionIvSourceFromJSON(object: any): OptionIvSource {
  switch (object) {
    case 0:
    case 'OPTION_IV_SOURCE_UNSPECIFIED':
      return OptionIvSource.OPTION_IV_SOURCE_UNSPECIFIED
    case 1:
    case 'OPTION_IV_SOURCE_BID_IV':
      return OptionIvSource.OPTION_IV_SOURCE_BID_IV
    case 2:
    case 'OPTION_IV_SOURCE_ASK_IV':
      return OptionIvSource.OPTION_IV_SOURCE_ASK_IV
    case 3:
    case 'OPTION_IV_SOURCE_MARK_IV':
      return OptionIvSource.OPTION_IV_SOURCE_MARK_IV
    case 4:
    case 'OPTION_IV_SOURCE_MID_IV':
      return OptionIvSource.OPTION_IV_SOURCE_MID_IV
    case -1:
    case 'UNRECOGNIZED':
    default:
      return OptionIvSource.UNRECOGNIZED
  }
}

export function optionIvSourceToJSON(object: OptionIvSource): string {
  switch (object) {
    case OptionIvSource.OPTION_IV_SOURCE_UNSPECIFIED:
      return 'OPTION_IV_SOURCE_UNSPECIFIED'
    case OptionIvSource.OPTION_IV_SOURCE_BID_IV:
      return 'OPTION_IV_SOURCE_BID_IV'
    case OptionIvSource.OPTION_IV_SOURCE_ASK_IV:
      return 'OPTION_IV_SOURCE_ASK_IV'
    case OptionIvSource.OPTION_IV_SOURCE_MARK_IV:
      return 'OPTION_IV_SOURCE_MARK_IV'
    case OptionIvSource.OPTION_IV_SOURCE_MID_IV:
      return 'OPTION_IV_SOURCE_MID_IV'
    case OptionIvSource.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum AlertScopeKind {
  ALERT_SCOPE_KIND_UNSPECIFIED = 0,
  ALERT_SCOPE_KIND_ACCOUNT = 1,
  ALERT_SCOPE_KIND_USER = 2,
  UNRECOGNIZED = -1,
}

export function alertScopeKindFromJSON(object: any): AlertScopeKind {
  switch (object) {
    case 0:
    case 'ALERT_SCOPE_KIND_UNSPECIFIED':
      return AlertScopeKind.ALERT_SCOPE_KIND_UNSPECIFIED
    case 1:
    case 'ALERT_SCOPE_KIND_ACCOUNT':
      return AlertScopeKind.ALERT_SCOPE_KIND_ACCOUNT
    case 2:
    case 'ALERT_SCOPE_KIND_USER':
      return AlertScopeKind.ALERT_SCOPE_KIND_USER
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AlertScopeKind.UNRECOGNIZED
  }
}

export function alertScopeKindToJSON(object: AlertScopeKind): string {
  switch (object) {
    case AlertScopeKind.ALERT_SCOPE_KIND_UNSPECIFIED:
      return 'ALERT_SCOPE_KIND_UNSPECIFIED'
    case AlertScopeKind.ALERT_SCOPE_KIND_ACCOUNT:
      return 'ALERT_SCOPE_KIND_ACCOUNT'
    case AlertScopeKind.ALERT_SCOPE_KIND_USER:
      return 'ALERT_SCOPE_KIND_USER'
    case AlertScopeKind.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum AlertRegistrationStatus {
  ALERT_REGISTRATION_STATUS_UNSPECIFIED = 0,
  ALERT_REGISTRATION_STATUS_ARMED = 1,
  ALERT_REGISTRATION_STATUS_FIRED = 2,
  ALERT_REGISTRATION_STATUS_EXPIRED = 3,
  ALERT_REGISTRATION_STATUS_DEREGISTERED = 4,
  UNRECOGNIZED = -1,
}

export function alertRegistrationStatusFromJSON(object: any): AlertRegistrationStatus {
  switch (object) {
    case 0:
    case 'ALERT_REGISTRATION_STATUS_UNSPECIFIED':
      return AlertRegistrationStatus.ALERT_REGISTRATION_STATUS_UNSPECIFIED
    case 1:
    case 'ALERT_REGISTRATION_STATUS_ARMED':
      return AlertRegistrationStatus.ALERT_REGISTRATION_STATUS_ARMED
    case 2:
    case 'ALERT_REGISTRATION_STATUS_FIRED':
      return AlertRegistrationStatus.ALERT_REGISTRATION_STATUS_FIRED
    case 3:
    case 'ALERT_REGISTRATION_STATUS_EXPIRED':
      return AlertRegistrationStatus.ALERT_REGISTRATION_STATUS_EXPIRED
    case 4:
    case 'ALERT_REGISTRATION_STATUS_DEREGISTERED':
      return AlertRegistrationStatus.ALERT_REGISTRATION_STATUS_DEREGISTERED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AlertRegistrationStatus.UNRECOGNIZED
  }
}

export function alertRegistrationStatusToJSON(object: AlertRegistrationStatus): string {
  switch (object) {
    case AlertRegistrationStatus.ALERT_REGISTRATION_STATUS_UNSPECIFIED:
      return 'ALERT_REGISTRATION_STATUS_UNSPECIFIED'
    case AlertRegistrationStatus.ALERT_REGISTRATION_STATUS_ARMED:
      return 'ALERT_REGISTRATION_STATUS_ARMED'
    case AlertRegistrationStatus.ALERT_REGISTRATION_STATUS_FIRED:
      return 'ALERT_REGISTRATION_STATUS_FIRED'
    case AlertRegistrationStatus.ALERT_REGISTRATION_STATUS_EXPIRED:
      return 'ALERT_REGISTRATION_STATUS_EXPIRED'
    case AlertRegistrationStatus.ALERT_REGISTRATION_STATUS_DEREGISTERED:
      return 'ALERT_REGISTRATION_STATUS_DEREGISTERED'
    case AlertRegistrationStatus.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum ConfirmAlertStatus {
  CONFIRM_ALERT_STATUS_UNSPECIFIED = 0,
  CONFIRM_ALERT_STATUS_ARMED = 1,
  CONFIRM_ALERT_STATUS_ALREADY_FIRED = 2,
  CONFIRM_ALERT_STATUS_EXPIRED = 3,
  CONFIRM_ALERT_STATUS_DEREGISTERED = 4,
  CONFIRM_ALERT_STATUS_UNKNOWN = 5,
  UNRECOGNIZED = -1,
}

export function confirmAlertStatusFromJSON(object: any): ConfirmAlertStatus {
  switch (object) {
    case 0:
    case 'CONFIRM_ALERT_STATUS_UNSPECIFIED':
      return ConfirmAlertStatus.CONFIRM_ALERT_STATUS_UNSPECIFIED
    case 1:
    case 'CONFIRM_ALERT_STATUS_ARMED':
      return ConfirmAlertStatus.CONFIRM_ALERT_STATUS_ARMED
    case 2:
    case 'CONFIRM_ALERT_STATUS_ALREADY_FIRED':
      return ConfirmAlertStatus.CONFIRM_ALERT_STATUS_ALREADY_FIRED
    case 3:
    case 'CONFIRM_ALERT_STATUS_EXPIRED':
      return ConfirmAlertStatus.CONFIRM_ALERT_STATUS_EXPIRED
    case 4:
    case 'CONFIRM_ALERT_STATUS_DEREGISTERED':
      return ConfirmAlertStatus.CONFIRM_ALERT_STATUS_DEREGISTERED
    case 5:
    case 'CONFIRM_ALERT_STATUS_UNKNOWN':
      return ConfirmAlertStatus.CONFIRM_ALERT_STATUS_UNKNOWN
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ConfirmAlertStatus.UNRECOGNIZED
  }
}

export function confirmAlertStatusToJSON(object: ConfirmAlertStatus): string {
  switch (object) {
    case ConfirmAlertStatus.CONFIRM_ALERT_STATUS_UNSPECIFIED:
      return 'CONFIRM_ALERT_STATUS_UNSPECIFIED'
    case ConfirmAlertStatus.CONFIRM_ALERT_STATUS_ARMED:
      return 'CONFIRM_ALERT_STATUS_ARMED'
    case ConfirmAlertStatus.CONFIRM_ALERT_STATUS_ALREADY_FIRED:
      return 'CONFIRM_ALERT_STATUS_ALREADY_FIRED'
    case ConfirmAlertStatus.CONFIRM_ALERT_STATUS_EXPIRED:
      return 'CONFIRM_ALERT_STATUS_EXPIRED'
    case ConfirmAlertStatus.CONFIRM_ALERT_STATUS_DEREGISTERED:
      return 'CONFIRM_ALERT_STATUS_DEREGISTERED'
    case ConfirmAlertStatus.CONFIRM_ALERT_STATUS_UNKNOWN:
      return 'CONFIRM_ALERT_STATUS_UNKNOWN'
    case ConfirmAlertStatus.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum AlertFireReason {
  ALERT_FIRE_REASON_UNSPECIFIED = 0,
  ALERT_FIRE_REASON_SATISFIED = 1,
  ALERT_FIRE_REASON_EXPIRED = 2,
  UNRECOGNIZED = -1,
}

export function alertFireReasonFromJSON(object: any): AlertFireReason {
  switch (object) {
    case 0:
    case 'ALERT_FIRE_REASON_UNSPECIFIED':
      return AlertFireReason.ALERT_FIRE_REASON_UNSPECIFIED
    case 1:
    case 'ALERT_FIRE_REASON_SATISFIED':
      return AlertFireReason.ALERT_FIRE_REASON_SATISFIED
    case 2:
    case 'ALERT_FIRE_REASON_EXPIRED':
      return AlertFireReason.ALERT_FIRE_REASON_EXPIRED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AlertFireReason.UNRECOGNIZED
  }
}

export function alertFireReasonToJSON(object: AlertFireReason): string {
  switch (object) {
    case AlertFireReason.ALERT_FIRE_REASON_UNSPECIFIED:
      return 'ALERT_FIRE_REASON_UNSPECIFIED'
    case AlertFireReason.ALERT_FIRE_REASON_SATISFIED:
      return 'ALERT_FIRE_REASON_SATISFIED'
    case AlertFireReason.ALERT_FIRE_REASON_EXPIRED:
      return 'ALERT_FIRE_REASON_EXPIRED'
    case AlertFireReason.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum TriggerConditionNodeKind {
  TRIGGER_CONDITION_NODE_KIND_UNSPECIFIED = 0,
  TRIGGER_CONDITION_NODE_KIND_AND = 1,
  TRIGGER_CONDITION_NODE_KIND_OR = 2,
  TRIGGER_CONDITION_NODE_KIND_SCHEDULE = 3,
  TRIGGER_CONDITION_NODE_KIND_PRICE = 4,
  TRIGGER_CONDITION_NODE_KIND_ACTION_EVENT = 5,
  TRIGGER_CONDITION_NODE_KIND_TECHNICAL_INDICATOR = 6,
  TRIGGER_CONDITION_NODE_KIND_RETURN = 7,
  TRIGGER_CONDITION_NODE_KIND_CANDLE = 8,
  TRIGGER_CONDITION_NODE_KIND_PORTFOLIO_METRIC = 9,
  TRIGGER_CONDITION_NODE_KIND_POSITION_METRIC = 10,
  TRIGGER_CONDITION_NODE_KIND_OPTION_IV = 11,
  TRIGGER_CONDITION_NODE_KIND_DB_NEWS = 12,
  TRIGGER_CONDITION_NODE_KIND_RISK_METRIC = 13,
  TRIGGER_CONDITION_NODE_KIND_POLYMARKET = 14,
  UNRECOGNIZED = -1,
}

export function triggerConditionNodeKindFromJSON(object: any): TriggerConditionNodeKind {
  switch (object) {
    case 0:
    case 'TRIGGER_CONDITION_NODE_KIND_UNSPECIFIED':
      return TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_UNSPECIFIED
    case 1:
    case 'TRIGGER_CONDITION_NODE_KIND_AND':
      return TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_AND
    case 2:
    case 'TRIGGER_CONDITION_NODE_KIND_OR':
      return TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_OR
    case 3:
    case 'TRIGGER_CONDITION_NODE_KIND_SCHEDULE':
      return TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_SCHEDULE
    case 4:
    case 'TRIGGER_CONDITION_NODE_KIND_PRICE':
      return TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_PRICE
    case 5:
    case 'TRIGGER_CONDITION_NODE_KIND_ACTION_EVENT':
      return TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_ACTION_EVENT
    case 6:
    case 'TRIGGER_CONDITION_NODE_KIND_TECHNICAL_INDICATOR':
      return TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_TECHNICAL_INDICATOR
    case 7:
    case 'TRIGGER_CONDITION_NODE_KIND_RETURN':
      return TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_RETURN
    case 8:
    case 'TRIGGER_CONDITION_NODE_KIND_CANDLE':
      return TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_CANDLE
    case 9:
    case 'TRIGGER_CONDITION_NODE_KIND_PORTFOLIO_METRIC':
      return TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_PORTFOLIO_METRIC
    case 10:
    case 'TRIGGER_CONDITION_NODE_KIND_POSITION_METRIC':
      return TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_POSITION_METRIC
    case 11:
    case 'TRIGGER_CONDITION_NODE_KIND_OPTION_IV':
      return TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_OPTION_IV
    case 12:
    case 'TRIGGER_CONDITION_NODE_KIND_DB_NEWS':
      return TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_DB_NEWS
    case 13:
    case 'TRIGGER_CONDITION_NODE_KIND_RISK_METRIC':
      return TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_RISK_METRIC
    case 14:
    case 'TRIGGER_CONDITION_NODE_KIND_POLYMARKET':
      return TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_POLYMARKET
    case -1:
    case 'UNRECOGNIZED':
    default:
      return TriggerConditionNodeKind.UNRECOGNIZED
  }
}

export function triggerConditionNodeKindToJSON(object: TriggerConditionNodeKind): string {
  switch (object) {
    case TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_UNSPECIFIED:
      return 'TRIGGER_CONDITION_NODE_KIND_UNSPECIFIED'
    case TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_AND:
      return 'TRIGGER_CONDITION_NODE_KIND_AND'
    case TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_OR:
      return 'TRIGGER_CONDITION_NODE_KIND_OR'
    case TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_SCHEDULE:
      return 'TRIGGER_CONDITION_NODE_KIND_SCHEDULE'
    case TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_PRICE:
      return 'TRIGGER_CONDITION_NODE_KIND_PRICE'
    case TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_ACTION_EVENT:
      return 'TRIGGER_CONDITION_NODE_KIND_ACTION_EVENT'
    case TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_TECHNICAL_INDICATOR:
      return 'TRIGGER_CONDITION_NODE_KIND_TECHNICAL_INDICATOR'
    case TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_RETURN:
      return 'TRIGGER_CONDITION_NODE_KIND_RETURN'
    case TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_CANDLE:
      return 'TRIGGER_CONDITION_NODE_KIND_CANDLE'
    case TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_PORTFOLIO_METRIC:
      return 'TRIGGER_CONDITION_NODE_KIND_PORTFOLIO_METRIC'
    case TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_POSITION_METRIC:
      return 'TRIGGER_CONDITION_NODE_KIND_POSITION_METRIC'
    case TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_OPTION_IV:
      return 'TRIGGER_CONDITION_NODE_KIND_OPTION_IV'
    case TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_DB_NEWS:
      return 'TRIGGER_CONDITION_NODE_KIND_DB_NEWS'
    case TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_RISK_METRIC:
      return 'TRIGGER_CONDITION_NODE_KIND_RISK_METRIC'
    case TriggerConditionNodeKind.TRIGGER_CONDITION_NODE_KIND_POLYMARKET:
      return 'TRIGGER_CONDITION_NODE_KIND_POLYMARKET'
    case TriggerConditionNodeKind.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum TriggerConditionEvaluationState {
  TRIGGER_CONDITION_EVALUATION_STATE_UNSPECIFIED = 0,
  TRIGGER_CONDITION_EVALUATION_STATE_WAITING = 1,
  TRIGGER_CONDITION_EVALUATION_STATE_UNSATISFIED = 2,
  TRIGGER_CONDITION_EVALUATION_STATE_SATISFIED = 3,
  TRIGGER_CONDITION_EVALUATION_STATE_STALE = 4,
  TRIGGER_CONDITION_EVALUATION_STATE_MISSING = 5,
  TRIGGER_CONDITION_EVALUATION_STATE_FIRED = 6,
  TRIGGER_CONDITION_EVALUATION_STATE_EXPIRED = 7,
  TRIGGER_CONDITION_EVALUATION_STATE_DEREGISTERED = 8,
  UNRECOGNIZED = -1,
}

export function triggerConditionEvaluationStateFromJSON(
  object: any
): TriggerConditionEvaluationState {
  switch (object) {
    case 0:
    case 'TRIGGER_CONDITION_EVALUATION_STATE_UNSPECIFIED':
      return TriggerConditionEvaluationState.TRIGGER_CONDITION_EVALUATION_STATE_UNSPECIFIED
    case 1:
    case 'TRIGGER_CONDITION_EVALUATION_STATE_WAITING':
      return TriggerConditionEvaluationState.TRIGGER_CONDITION_EVALUATION_STATE_WAITING
    case 2:
    case 'TRIGGER_CONDITION_EVALUATION_STATE_UNSATISFIED':
      return TriggerConditionEvaluationState.TRIGGER_CONDITION_EVALUATION_STATE_UNSATISFIED
    case 3:
    case 'TRIGGER_CONDITION_EVALUATION_STATE_SATISFIED':
      return TriggerConditionEvaluationState.TRIGGER_CONDITION_EVALUATION_STATE_SATISFIED
    case 4:
    case 'TRIGGER_CONDITION_EVALUATION_STATE_STALE':
      return TriggerConditionEvaluationState.TRIGGER_CONDITION_EVALUATION_STATE_STALE
    case 5:
    case 'TRIGGER_CONDITION_EVALUATION_STATE_MISSING':
      return TriggerConditionEvaluationState.TRIGGER_CONDITION_EVALUATION_STATE_MISSING
    case 6:
    case 'TRIGGER_CONDITION_EVALUATION_STATE_FIRED':
      return TriggerConditionEvaluationState.TRIGGER_CONDITION_EVALUATION_STATE_FIRED
    case 7:
    case 'TRIGGER_CONDITION_EVALUATION_STATE_EXPIRED':
      return TriggerConditionEvaluationState.TRIGGER_CONDITION_EVALUATION_STATE_EXPIRED
    case 8:
    case 'TRIGGER_CONDITION_EVALUATION_STATE_DEREGISTERED':
      return TriggerConditionEvaluationState.TRIGGER_CONDITION_EVALUATION_STATE_DEREGISTERED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return TriggerConditionEvaluationState.UNRECOGNIZED
  }
}

export function triggerConditionEvaluationStateToJSON(
  object: TriggerConditionEvaluationState
): string {
  switch (object) {
    case TriggerConditionEvaluationState.TRIGGER_CONDITION_EVALUATION_STATE_UNSPECIFIED:
      return 'TRIGGER_CONDITION_EVALUATION_STATE_UNSPECIFIED'
    case TriggerConditionEvaluationState.TRIGGER_CONDITION_EVALUATION_STATE_WAITING:
      return 'TRIGGER_CONDITION_EVALUATION_STATE_WAITING'
    case TriggerConditionEvaluationState.TRIGGER_CONDITION_EVALUATION_STATE_UNSATISFIED:
      return 'TRIGGER_CONDITION_EVALUATION_STATE_UNSATISFIED'
    case TriggerConditionEvaluationState.TRIGGER_CONDITION_EVALUATION_STATE_SATISFIED:
      return 'TRIGGER_CONDITION_EVALUATION_STATE_SATISFIED'
    case TriggerConditionEvaluationState.TRIGGER_CONDITION_EVALUATION_STATE_STALE:
      return 'TRIGGER_CONDITION_EVALUATION_STATE_STALE'
    case TriggerConditionEvaluationState.TRIGGER_CONDITION_EVALUATION_STATE_MISSING:
      return 'TRIGGER_CONDITION_EVALUATION_STATE_MISSING'
    case TriggerConditionEvaluationState.TRIGGER_CONDITION_EVALUATION_STATE_FIRED:
      return 'TRIGGER_CONDITION_EVALUATION_STATE_FIRED'
    case TriggerConditionEvaluationState.TRIGGER_CONDITION_EVALUATION_STATE_EXPIRED:
      return 'TRIGGER_CONDITION_EVALUATION_STATE_EXPIRED'
    case TriggerConditionEvaluationState.TRIGGER_CONDITION_EVALUATION_STATE_DEREGISTERED:
      return 'TRIGGER_CONDITION_EVALUATION_STATE_DEREGISTERED'
    case TriggerConditionEvaluationState.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum TriggerConditionFreshness {
  TRIGGER_CONDITION_FRESHNESS_UNSPECIFIED = 0,
  TRIGGER_CONDITION_FRESHNESS_FRESH = 1,
  TRIGGER_CONDITION_FRESHNESS_STALE = 2,
  TRIGGER_CONDITION_FRESHNESS_MISSING = 3,
  TRIGGER_CONDITION_FRESHNESS_NOT_APPLICABLE = 4,
  UNRECOGNIZED = -1,
}

export function triggerConditionFreshnessFromJSON(object: any): TriggerConditionFreshness {
  switch (object) {
    case 0:
    case 'TRIGGER_CONDITION_FRESHNESS_UNSPECIFIED':
      return TriggerConditionFreshness.TRIGGER_CONDITION_FRESHNESS_UNSPECIFIED
    case 1:
    case 'TRIGGER_CONDITION_FRESHNESS_FRESH':
      return TriggerConditionFreshness.TRIGGER_CONDITION_FRESHNESS_FRESH
    case 2:
    case 'TRIGGER_CONDITION_FRESHNESS_STALE':
      return TriggerConditionFreshness.TRIGGER_CONDITION_FRESHNESS_STALE
    case 3:
    case 'TRIGGER_CONDITION_FRESHNESS_MISSING':
      return TriggerConditionFreshness.TRIGGER_CONDITION_FRESHNESS_MISSING
    case 4:
    case 'TRIGGER_CONDITION_FRESHNESS_NOT_APPLICABLE':
      return TriggerConditionFreshness.TRIGGER_CONDITION_FRESHNESS_NOT_APPLICABLE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return TriggerConditionFreshness.UNRECOGNIZED
  }
}

export function triggerConditionFreshnessToJSON(object: TriggerConditionFreshness): string {
  switch (object) {
    case TriggerConditionFreshness.TRIGGER_CONDITION_FRESHNESS_UNSPECIFIED:
      return 'TRIGGER_CONDITION_FRESHNESS_UNSPECIFIED'
    case TriggerConditionFreshness.TRIGGER_CONDITION_FRESHNESS_FRESH:
      return 'TRIGGER_CONDITION_FRESHNESS_FRESH'
    case TriggerConditionFreshness.TRIGGER_CONDITION_FRESHNESS_STALE:
      return 'TRIGGER_CONDITION_FRESHNESS_STALE'
    case TriggerConditionFreshness.TRIGGER_CONDITION_FRESHNESS_MISSING:
      return 'TRIGGER_CONDITION_FRESHNESS_MISSING'
    case TriggerConditionFreshness.TRIGGER_CONDITION_FRESHNESS_NOT_APPLICABLE:
      return 'TRIGGER_CONDITION_FRESHNESS_NOT_APPLICABLE'
    case TriggerConditionFreshness.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Decimal string convention for this package:
 * - Plain decimal fields are price or quantity units in the documented
 *   denomination; they are not floating-point JSON numbers.
 * - Fields whose name ends in `_percent` or whose unit enum is `PERCENT` use
 *   percentage points, not fractions: "50" means 50%; "0.5" means 0.5%.
 * - Signed fields say so explicitly.
 */
export interface Trigger {
  condition: Condition | undefined
  /** Absolute Unix ms after which this trigger is no longer valid. */
  expiryMs?: string | undefined
}

export interface Condition {
  price?: PriceCondition | undefined
  schedule?: ScheduleCondition | undefined
  actionEvent?: ActionEventCondition | undefined
  andCondition?: AndCondition | undefined
  orCondition?: OrCondition | undefined
  technicalIndicator?: TechnicalIndicatorCondition | undefined
  returns?: ReturnCondition | undefined
  candle?: CandleCondition | undefined
  portfolioMetric?: PortfolioMetricCondition | undefined
  positionStats?: PositionMetricCondition | undefined
  optionIv?: OptionIvCondition | undefined
  dbNews?: DbNewsCondition | undefined
  riskMetric?: RiskMetricCondition | undefined
  polymarket?: PolymarketCondition | undefined
}

/**
 * And/Or trees are canonicalized by alert-service for deterministic trigger
 * keys. Tree-depth is capped by validator config.
 */
export interface AndCondition {
  conditions: Condition[]
}

export interface OrCondition {
  conditions: Condition[]
}

/** Non-option only. Resolved option instrument → `UNSUPPORTED_STRUCTURE`. */
export interface PriceCondition {
  instrument: TriggerInstrumentRef | undefined
  source: PriceReference
  operator: ComparisonOperator
  /**
   * Absolute frozen decimal threshold. Exactly one of `value` or `relative`
   * must be set. Kept as a scalar for wire compatibility with existing alerts.
   */
  value: string
  /**
   * Relative threshold such as "source price drops 5% from current mark".
   * The registration path must resolve this to an absolute threshold using the
   * current `anchor` price before arming the alert.
   */
  relative?: RelativePriceTrigger | undefined
}

export interface RelativePriceTrigger {
  anchor: PriceReference
  /**
   * Signed decimal offset. With PERCENT, "5" means +5% and "-5" means -5%.
   * With BPS, "50" means 50 basis points.
   */
  offset: string
  offsetUnit: PriceOffsetUnit
}

export interface TriggerInstrumentRef {
  /**
   * For ACCOUNT-scope triggers, exchange/trade_venue may be inferred from the
   * account when omitted. USER-scope alert UX must supply explicit routing.
   */
  symbol: string
  exchange: Exchange
  tradeVenue: TradeVenue
  venueSymbol: string
}

export interface TriggerOptionInstrumentRef {
  symbol: string
  exchange: Exchange
  tradeVenue: TradeVenue
  underlying: string
  strikePrice?: string | undefined
  expiryMs?: string | undefined
  optionType?: OptionType | undefined
}

export interface ScheduleCondition {
  /**
   * Absolute Unix ms. Validators reject zero, negative, and materially past
   * timestamps at registration.
   */
  fireAtMs?: string | undefined
  delaySeconds?: string | undefined
}

export interface ActionEventCondition {
  eventType: ActionEventType
  partialFillThresholdPercent?: string | undefined
  /**
   * Required by the trigger validators. Account scope supplies the account_id;
   * this target makes the watched action explicit instead of "any account event".
   */
  target: ActionEventTarget | undefined
}

export interface ActionEventTarget {
  orderId?: string | undefined
  algoId?: string | undefined
  symbol?: string | undefined
}

export interface TechnicalIndicatorCondition {
  left: TechnicalIndicatorSpec | undefined
  operator: ComparisonOperator
  threshold?: string | undefined
  right?: TechnicalIndicatorSpec | undefined
  maxStalenessMs?: string | undefined
}

export interface TechnicalIndicatorSpec {
  indicatorType: TechnicalIndicatorType
  instrument: TriggerInstrumentRef | undefined
  source: PriceReference
  periodCount: number
  timeframeSeconds: ChartTimeframe
}

export interface ReturnCondition {
  instrument: TriggerInstrumentRef | undefined
  source: PriceReference
  windowMs: string
  operator: ComparisonOperator
  /** Percentage points. "5" means +5%; "-2.5" means -2.5%. */
  valuePercent: string
  timeframeSeconds: ChartTimeframe
  maxStalenessMs?: string | undefined
}

export interface CandleCondition {
  instrument: TriggerInstrumentRef | undefined
  timeframeSeconds: ChartTimeframe
  field: CandleField
  operator: ComparisonOperator
  value: string
  /**
   * Defaults to closed-candle semantics when unset/false. Present for forward
   * compatibility if a caller later wants explicit in-progress candle checks.
   */
  allowOpenCandle: boolean
  maxStalenessMs?: string | undefined
}

export interface PortfolioMetricCondition {
  /** Empty means the enclosing ACCOUNT scope id. */
  accountId: string
  metric: PortfolioMetric
  operator: ComparisonOperator
  value: string
  maxStalenessMs?: string | undefined
  /**
   * Settlement currency the metric reads (e.g. "BTC"). Required for
   * CURRENCY_EQUITY_USD; for EQUITY it selects the row, and without it the
   * legacy first-matching-row behaviour applies. Ignored by ACCOUNT_VALUE_USD.
   */
  currency?: string | undefined
}

export interface PositionMetricCondition {
  /** Empty means the enclosing ACCOUNT scope id. */
  accountId: string
  scope: PositionMetricScope | undefined
  metric: PositionMetric
  operator: ComparisonOperator
  value: string
  maxStalenessMs?: string | undefined
}

export interface PositionMetricScope {
  symbol?: string | undefined
  underlying?: string | undefined
  positionGroupId?: string | undefined
  allPositions?: boolean | undefined
}

export interface RiskMetricCondition {
  /** Empty means the enclosing ACCOUNT scope id. */
  accountId: string
  asset: string
  metric: RiskMetric
  operator: ComparisonOperator
  value: string
  maxStalenessMs?: string | undefined
}

export interface OptionIvCondition {
  instrument: TriggerOptionInstrumentRef | undefined
  source: OptionIvSource
  operator: ComparisonOperator
  /** Percentage points. "50" means 50% IV. */
  valuePercent: string
  maxStalenessMs?: string | undefined
}

export interface DbNewsCondition {
  eeType: string[]
  newsType: string[]
  coins: string[]
  tags: string[]
  textContains: string[]
  /**
   * Optional Unix ms lower bound. When set, events older than this do not
   * satisfy the condition. For schedule+news "at/after" behavior, prefer an
   * explicit AND with ScheduleCondition plus this field set by the creator.
   */
  eventNotBeforeMs?: string | undefined
}

/**
 * Data-only prediction-market probability trigger (ENG-530). Watches the YES
 * outcome probability of one Polymarket token; the FE market picker resolves a
 * market to its token_id up-front, so the condition carries token_id directly
 * (no account-derived trade_venue, unlike PriceCondition).
 */
export interface PolymarketCondition {
  tokenId: string
  operator: ComparisonOperator
  /**
   * Probability threshold in [0,1] as a decimal string, same unit as the
   * PolymarketSignal yes_mid (FE renders ×100 as a percentage).
   */
  threshold: string
}

export interface AlertScope {
  kind: AlertScopeKind
  id: string
}

export interface RegisterAlertRequest {
  scope: AlertScope | undefined
  /**
   * Caller-stable id for this scoped subscriber. Trigger-algo should use its
   * algo id so restart registration is idempotent.
   */
  registrationId: string
  trigger: Trigger | undefined
}

export interface RegisterAlertResponse {
  triggerId: string
  registrationId: string
  status: AlertRegistrationStatus
  alreadyFired: boolean
  resolvedDescriptor: ResolvedAlertDescriptor | undefined
  error?: string | undefined
}

export interface DeregisterAlertRequest {
  scope: AlertScope | undefined
  registrationId: string
  triggerId: string
}

export interface DeregisterAlertResponse {
  success: boolean
  registrationId: string
  triggerId: string
  status: AlertRegistrationStatus
  error?: string | undefined
}

export interface ConfirmAlertRequest {
  scope: AlertScope | undefined
  registrationId: string
  triggerId: string
}

export interface ConfirmAlertResponse {
  triggerId: string
  registrationId: string
  status: ConfirmAlertStatus
  fireEvent?: AlertFireEvent | undefined
  error?: string | undefined
}

export interface AlertFireEvent {
  triggerId: string
  registrationId: string
  scope: AlertScope | undefined
  trigger: Trigger | undefined
  firedAtMs: string
  reason: AlertFireReason
  resolvedDescriptor: ResolvedAlertDescriptor | undefined
}

export interface TriggerValue {
  decimalValue: string
  textValue: string
  unit: string
  sourceTsMs: string
  observedAtMs: string
}

export interface TriggerConditionNodeSnapshot {
  path: string
  kind: TriggerConditionNodeKind
  state: TriggerConditionEvaluationState
  freshness: TriggerConditionFreshness
  operator: ComparisonOperator
  currentValue: TriggerValue | undefined
  targetValue: TriggerValue | undefined
  latched: boolean
  lastTransitionMs: string
  staleAfterMs: string
  label: string
  children: TriggerConditionNodeSnapshot[]
  detail?: string | undefined
}

export interface TriggerEvaluationSnapshot {
  accountId: string
  registrationId: string
  triggerId: string
  registrationStatus: AlertRegistrationStatus
  terminalReason: AlertFireReason
  updatedAtMs: string
  root: TriggerConditionNodeSnapshot | undefined
  resolvedDescriptor: ResolvedAlertDescriptor | undefined
  error?: string | undefined
}

/**
 * Canonical descriptor resolved by alerts-service before hashing. For price
 * conditions this includes account-derived trade_venue/exchange, so price
 * trigger ids are never based on raw Condition alone.
 */
export interface ResolvedAlertDescriptor {
  price?: ResolvedPriceDescriptor | undefined
  schedule?: ResolvedScheduleDescriptor | undefined
  actionEvent?: ResolvedActionEventDescriptor | undefined
  andCondition?: ResolvedCompositeDescriptor | undefined
  orCondition?: ResolvedCompositeDescriptor | undefined
  technicalIndicator?: ResolvedTechnicalIndicatorDescriptor | undefined
  returns?: ResolvedReturnDescriptor | undefined
  candle?: ResolvedCandleDescriptor | undefined
  portfolioMetric?: ResolvedPortfolioMetricDescriptor | undefined
  positionMetric?: ResolvedPositionMetricDescriptor | undefined
  optionIv?: ResolvedOptionIvDescriptor | undefined
  dbNews?: ResolvedDbNewsDescriptor | undefined
  riskMetric?: ResolvedRiskMetricDescriptor | undefined
  polymarket?: ResolvedPolymarketDescriptor | undefined
}

export interface ResolvedPriceDescriptor {
  tradeVenue: TradeVenue
  exchange: Exchange
  symbol: string
  source: PriceReference
  operator: ComparisonOperator
  normalizedThreshold: string
}

export interface ResolvedScheduleDescriptor {
  fireAtMs: string
}

export interface ResolvedActionEventDescriptor {
  accountId: string
  eventType: ActionEventType
  partialFillThresholdPercent?: string | undefined
  target: ActionEventTarget | undefined
}

export interface ResolvedCompositeDescriptor {
  children: ResolvedAlertDescriptor[]
}

export interface ResolvedTechnicalIndicatorDescriptor {
  left: ResolvedTechnicalIndicatorSpec | undefined
  operator: ComparisonOperator
  normalizedThreshold?: string | undefined
  right?: ResolvedTechnicalIndicatorSpec | undefined
  maxStalenessMs?: string | undefined
}

export interface ResolvedTechnicalIndicatorSpec {
  indicatorType: TechnicalIndicatorType
  tradeVenue: TradeVenue
  exchange: Exchange
  symbol: string
  source: PriceReference
  periodCount: number
  timeframeSeconds: ChartTimeframe
}

export interface ResolvedReturnDescriptor {
  tradeVenue: TradeVenue
  exchange: Exchange
  symbol: string
  source: PriceReference
  windowMs: string
  operator: ComparisonOperator
  normalizedThresholdPercent: string
  timeframeSeconds: ChartTimeframe
  maxStalenessMs?: string | undefined
}

export interface ResolvedCandleDescriptor {
  tradeVenue: TradeVenue
  exchange: Exchange
  symbol: string
  timeframeSeconds: ChartTimeframe
  field: CandleField
  operator: ComparisonOperator
  normalizedThreshold: string
  allowOpenCandle: boolean
  maxStalenessMs?: string | undefined
}

export interface ResolvedPortfolioMetricDescriptor {
  accountId: string
  metric: PortfolioMetric
  operator: ComparisonOperator
  normalizedThreshold: string
  maxStalenessMs?: string | undefined
  /** Upper-cased PortfolioMetricCondition.currency. */
  currency?: string | undefined
}

export interface ResolvedPositionMetricDescriptor {
  accountId: string
  scope: PositionMetricScope | undefined
  metric: PositionMetric
  operator: ComparisonOperator
  normalizedThreshold: string
  maxStalenessMs?: string | undefined
}

export interface ResolvedRiskMetricDescriptor {
  accountId: string
  asset: string
  metric: RiskMetric
  operator: ComparisonOperator
  normalizedThreshold: string
  maxStalenessMs?: string | undefined
}

export interface ResolvedOptionIvDescriptor {
  instrument: TriggerOptionInstrumentRef | undefined
  source: OptionIvSource
  operator: ComparisonOperator
  normalizedThresholdPercent: string
  maxStalenessMs?: string | undefined
}

export interface ResolvedDbNewsDescriptor {
  eeType: string[]
  newsType: string[]
  coins: string[]
  tags: string[]
  textContains: string[]
  eventNotBeforeMs?: string | undefined
}

export interface ResolvedPolymarketDescriptor {
  tokenId: string
  operator: ComparisonOperator
  normalizedThreshold: string
}

function createBaseTrigger(): Trigger {
  return { condition: undefined, expiryMs: undefined }
}

export const Trigger: MessageFns<Trigger> = {
  encode(message: Trigger, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.condition !== undefined) {
      Condition.encode(message.condition, writer.uint32(10).fork()).join()
    }
    if (message.expiryMs !== undefined) {
      writer.uint32(16).int64(message.expiryMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Trigger {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTrigger()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.condition = Condition.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.expiryMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Trigger {
    return {
      condition: isSet(object.condition) ? Condition.fromJSON(object.condition) : undefined,
      expiryMs: isSet(object.expiryMs)
        ? globalThis.String(object.expiryMs)
        : isSet(object.expiry_ms)
          ? globalThis.String(object.expiry_ms)
          : undefined,
    }
  },

  toJSON(message: Trigger): unknown {
    const obj: any = {}
    if (message.condition !== undefined) {
      obj.condition = Condition.toJSON(message.condition)
    }
    if (message.expiryMs !== undefined) {
      obj.expiryMs = message.expiryMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Trigger>, I>>(base?: I): Trigger {
    return Trigger.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Trigger>, I>>(object: I): Trigger {
    const message = createBaseTrigger()
    message.condition =
      object.condition !== undefined && object.condition !== null
        ? Condition.fromPartial(object.condition)
        : undefined
    message.expiryMs = object.expiryMs ?? undefined
    return message
  },
}

function createBaseCondition(): Condition {
  return {
    price: undefined,
    schedule: undefined,
    actionEvent: undefined,
    andCondition: undefined,
    orCondition: undefined,
    technicalIndicator: undefined,
    returns: undefined,
    candle: undefined,
    portfolioMetric: undefined,
    positionStats: undefined,
    optionIv: undefined,
    dbNews: undefined,
    riskMetric: undefined,
    polymarket: undefined,
  }
}

export const Condition: MessageFns<Condition> = {
  encode(message: Condition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.price !== undefined) {
      PriceCondition.encode(message.price, writer.uint32(10).fork()).join()
    }
    if (message.schedule !== undefined) {
      ScheduleCondition.encode(message.schedule, writer.uint32(18).fork()).join()
    }
    if (message.actionEvent !== undefined) {
      ActionEventCondition.encode(message.actionEvent, writer.uint32(58).fork()).join()
    }
    if (message.andCondition !== undefined) {
      AndCondition.encode(message.andCondition, writer.uint32(66).fork()).join()
    }
    if (message.orCondition !== undefined) {
      OrCondition.encode(message.orCondition, writer.uint32(74).fork()).join()
    }
    if (message.technicalIndicator !== undefined) {
      TechnicalIndicatorCondition.encode(
        message.technicalIndicator,
        writer.uint32(90).fork()
      ).join()
    }
    if (message.returns !== undefined) {
      ReturnCondition.encode(message.returns, writer.uint32(98).fork()).join()
    }
    if (message.candle !== undefined) {
      CandleCondition.encode(message.candle, writer.uint32(106).fork()).join()
    }
    if (message.portfolioMetric !== undefined) {
      PortfolioMetricCondition.encode(message.portfolioMetric, writer.uint32(114).fork()).join()
    }
    if (message.positionStats !== undefined) {
      PositionMetricCondition.encode(message.positionStats, writer.uint32(122).fork()).join()
    }
    if (message.optionIv !== undefined) {
      OptionIvCondition.encode(message.optionIv, writer.uint32(130).fork()).join()
    }
    if (message.dbNews !== undefined) {
      DbNewsCondition.encode(message.dbNews, writer.uint32(138).fork()).join()
    }
    if (message.riskMetric !== undefined) {
      RiskMetricCondition.encode(message.riskMetric, writer.uint32(146).fork()).join()
    }
    if (message.polymarket !== undefined) {
      PolymarketCondition.encode(message.polymarket, writer.uint32(154).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Condition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCondition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.price = PriceCondition.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.schedule = ScheduleCondition.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.actionEvent = ActionEventCondition.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.andCondition = AndCondition.decode(reader, reader.uint32())
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.orCondition = OrCondition.decode(reader, reader.uint32())
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.technicalIndicator = TechnicalIndicatorCondition.decode(reader, reader.uint32())
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.returns = ReturnCondition.decode(reader, reader.uint32())
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.candle = CandleCondition.decode(reader, reader.uint32())
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.portfolioMetric = PortfolioMetricCondition.decode(reader, reader.uint32())
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.positionStats = PositionMetricCondition.decode(reader, reader.uint32())
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.optionIv = OptionIvCondition.decode(reader, reader.uint32())
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.dbNews = DbNewsCondition.decode(reader, reader.uint32())
          continue
        }
        case 18: {
          if (tag !== 146) {
            break
          }

          message.riskMetric = RiskMetricCondition.decode(reader, reader.uint32())
          continue
        }
        case 19: {
          if (tag !== 154) {
            break
          }

          message.polymarket = PolymarketCondition.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Condition {
    return {
      price: isSet(object.price) ? PriceCondition.fromJSON(object.price) : undefined,
      schedule: isSet(object.schedule) ? ScheduleCondition.fromJSON(object.schedule) : undefined,
      actionEvent: isSet(object.actionEvent)
        ? ActionEventCondition.fromJSON(object.actionEvent)
        : isSet(object.action_event)
          ? ActionEventCondition.fromJSON(object.action_event)
          : undefined,
      andCondition: isSet(object.andCondition)
        ? AndCondition.fromJSON(object.andCondition)
        : isSet(object.and_condition)
          ? AndCondition.fromJSON(object.and_condition)
          : undefined,
      orCondition: isSet(object.orCondition)
        ? OrCondition.fromJSON(object.orCondition)
        : isSet(object.or_condition)
          ? OrCondition.fromJSON(object.or_condition)
          : undefined,
      technicalIndicator: isSet(object.technicalIndicator)
        ? TechnicalIndicatorCondition.fromJSON(object.technicalIndicator)
        : isSet(object.technical_indicator)
          ? TechnicalIndicatorCondition.fromJSON(object.technical_indicator)
          : undefined,
      returns: isSet(object.returns) ? ReturnCondition.fromJSON(object.returns) : undefined,
      candle: isSet(object.candle) ? CandleCondition.fromJSON(object.candle) : undefined,
      portfolioMetric: isSet(object.portfolioMetric)
        ? PortfolioMetricCondition.fromJSON(object.portfolioMetric)
        : isSet(object.portfolio_metric)
          ? PortfolioMetricCondition.fromJSON(object.portfolio_metric)
          : undefined,
      positionStats: isSet(object.positionStats)
        ? PositionMetricCondition.fromJSON(object.positionStats)
        : isSet(object.position_stats)
          ? PositionMetricCondition.fromJSON(object.position_stats)
          : undefined,
      optionIv: isSet(object.optionIv)
        ? OptionIvCondition.fromJSON(object.optionIv)
        : isSet(object.option_iv)
          ? OptionIvCondition.fromJSON(object.option_iv)
          : undefined,
      dbNews: isSet(object.dbNews)
        ? DbNewsCondition.fromJSON(object.dbNews)
        : isSet(object.db_news)
          ? DbNewsCondition.fromJSON(object.db_news)
          : undefined,
      riskMetric: isSet(object.riskMetric)
        ? RiskMetricCondition.fromJSON(object.riskMetric)
        : isSet(object.risk_metric)
          ? RiskMetricCondition.fromJSON(object.risk_metric)
          : undefined,
      polymarket: isSet(object.polymarket)
        ? PolymarketCondition.fromJSON(object.polymarket)
        : undefined,
    }
  },

  toJSON(message: Condition): unknown {
    const obj: any = {}
    if (message.price !== undefined) {
      obj.price = PriceCondition.toJSON(message.price)
    }
    if (message.schedule !== undefined) {
      obj.schedule = ScheduleCondition.toJSON(message.schedule)
    }
    if (message.actionEvent !== undefined) {
      obj.actionEvent = ActionEventCondition.toJSON(message.actionEvent)
    }
    if (message.andCondition !== undefined) {
      obj.andCondition = AndCondition.toJSON(message.andCondition)
    }
    if (message.orCondition !== undefined) {
      obj.orCondition = OrCondition.toJSON(message.orCondition)
    }
    if (message.technicalIndicator !== undefined) {
      obj.technicalIndicator = TechnicalIndicatorCondition.toJSON(message.technicalIndicator)
    }
    if (message.returns !== undefined) {
      obj.returns = ReturnCondition.toJSON(message.returns)
    }
    if (message.candle !== undefined) {
      obj.candle = CandleCondition.toJSON(message.candle)
    }
    if (message.portfolioMetric !== undefined) {
      obj.portfolioMetric = PortfolioMetricCondition.toJSON(message.portfolioMetric)
    }
    if (message.positionStats !== undefined) {
      obj.positionStats = PositionMetricCondition.toJSON(message.positionStats)
    }
    if (message.optionIv !== undefined) {
      obj.optionIv = OptionIvCondition.toJSON(message.optionIv)
    }
    if (message.dbNews !== undefined) {
      obj.dbNews = DbNewsCondition.toJSON(message.dbNews)
    }
    if (message.riskMetric !== undefined) {
      obj.riskMetric = RiskMetricCondition.toJSON(message.riskMetric)
    }
    if (message.polymarket !== undefined) {
      obj.polymarket = PolymarketCondition.toJSON(message.polymarket)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Condition>, I>>(base?: I): Condition {
    return Condition.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Condition>, I>>(object: I): Condition {
    const message = createBaseCondition()
    message.price =
      object.price !== undefined && object.price !== null
        ? PriceCondition.fromPartial(object.price)
        : undefined
    message.schedule =
      object.schedule !== undefined && object.schedule !== null
        ? ScheduleCondition.fromPartial(object.schedule)
        : undefined
    message.actionEvent =
      object.actionEvent !== undefined && object.actionEvent !== null
        ? ActionEventCondition.fromPartial(object.actionEvent)
        : undefined
    message.andCondition =
      object.andCondition !== undefined && object.andCondition !== null
        ? AndCondition.fromPartial(object.andCondition)
        : undefined
    message.orCondition =
      object.orCondition !== undefined && object.orCondition !== null
        ? OrCondition.fromPartial(object.orCondition)
        : undefined
    message.technicalIndicator =
      object.technicalIndicator !== undefined && object.technicalIndicator !== null
        ? TechnicalIndicatorCondition.fromPartial(object.technicalIndicator)
        : undefined
    message.returns =
      object.returns !== undefined && object.returns !== null
        ? ReturnCondition.fromPartial(object.returns)
        : undefined
    message.candle =
      object.candle !== undefined && object.candle !== null
        ? CandleCondition.fromPartial(object.candle)
        : undefined
    message.portfolioMetric =
      object.portfolioMetric !== undefined && object.portfolioMetric !== null
        ? PortfolioMetricCondition.fromPartial(object.portfolioMetric)
        : undefined
    message.positionStats =
      object.positionStats !== undefined && object.positionStats !== null
        ? PositionMetricCondition.fromPartial(object.positionStats)
        : undefined
    message.optionIv =
      object.optionIv !== undefined && object.optionIv !== null
        ? OptionIvCondition.fromPartial(object.optionIv)
        : undefined
    message.dbNews =
      object.dbNews !== undefined && object.dbNews !== null
        ? DbNewsCondition.fromPartial(object.dbNews)
        : undefined
    message.riskMetric =
      object.riskMetric !== undefined && object.riskMetric !== null
        ? RiskMetricCondition.fromPartial(object.riskMetric)
        : undefined
    message.polymarket =
      object.polymarket !== undefined && object.polymarket !== null
        ? PolymarketCondition.fromPartial(object.polymarket)
        : undefined
    return message
  },
}

function createBaseAndCondition(): AndCondition {
  return { conditions: [] }
}

export const AndCondition: MessageFns<AndCondition> = {
  encode(message: AndCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.conditions) {
      Condition.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AndCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAndCondition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.conditions.push(Condition.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AndCondition {
    return {
      conditions: globalThis.Array.isArray(object?.conditions)
        ? object.conditions.map((e: any) => Condition.fromJSON(e))
        : [],
    }
  },

  toJSON(message: AndCondition): unknown {
    const obj: any = {}
    if (message.conditions?.length) {
      obj.conditions = message.conditions.map((e) => Condition.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AndCondition>, I>>(base?: I): AndCondition {
    return AndCondition.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AndCondition>, I>>(object: I): AndCondition {
    const message = createBaseAndCondition()
    message.conditions = object.conditions?.map((e) => Condition.fromPartial(e)) || []
    return message
  },
}

function createBaseOrCondition(): OrCondition {
  return { conditions: [] }
}

export const OrCondition: MessageFns<OrCondition> = {
  encode(message: OrCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.conditions) {
      Condition.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrCondition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.conditions.push(Condition.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OrCondition {
    return {
      conditions: globalThis.Array.isArray(object?.conditions)
        ? object.conditions.map((e: any) => Condition.fromJSON(e))
        : [],
    }
  },

  toJSON(message: OrCondition): unknown {
    const obj: any = {}
    if (message.conditions?.length) {
      obj.conditions = message.conditions.map((e) => Condition.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OrCondition>, I>>(base?: I): OrCondition {
    return OrCondition.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OrCondition>, I>>(object: I): OrCondition {
    const message = createBaseOrCondition()
    message.conditions = object.conditions?.map((e) => Condition.fromPartial(e)) || []
    return message
  },
}

function createBasePriceCondition(): PriceCondition {
  return { instrument: undefined, source: 0, operator: 0, value: '', relative: undefined }
}

export const PriceCondition: MessageFns<PriceCondition> = {
  encode(message: PriceCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.instrument !== undefined) {
      TriggerInstrumentRef.encode(message.instrument, writer.uint32(10).fork()).join()
    }
    if (message.source !== 0) {
      writer.uint32(16).int32(message.source)
    }
    if (message.operator !== 0) {
      writer.uint32(24).int32(message.operator)
    }
    if (message.value !== '') {
      writer.uint32(34).string(message.value)
    }
    if (message.relative !== undefined) {
      RelativePriceTrigger.encode(message.relative, writer.uint32(42).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PriceCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePriceCondition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.instrument = TriggerInstrumentRef.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.source = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.operator = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.value = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.relative = RelativePriceTrigger.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PriceCondition {
    return {
      instrument: isSet(object.instrument)
        ? TriggerInstrumentRef.fromJSON(object.instrument)
        : undefined,
      source: isSet(object.source) ? priceReferenceFromJSON(object.source) : 0,
      operator: isSet(object.operator) ? comparisonOperatorFromJSON(object.operator) : 0,
      value: isSet(object.value) ? globalThis.String(object.value) : '',
      relative: isSet(object.relative) ? RelativePriceTrigger.fromJSON(object.relative) : undefined,
    }
  },

  toJSON(message: PriceCondition): unknown {
    const obj: any = {}
    if (message.instrument !== undefined) {
      obj.instrument = TriggerInstrumentRef.toJSON(message.instrument)
    }
    if (message.source !== 0) {
      obj.source = priceReferenceToJSON(message.source)
    }
    if (message.operator !== 0) {
      obj.operator = comparisonOperatorToJSON(message.operator)
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    if (message.relative !== undefined) {
      obj.relative = RelativePriceTrigger.toJSON(message.relative)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PriceCondition>, I>>(base?: I): PriceCondition {
    return PriceCondition.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PriceCondition>, I>>(object: I): PriceCondition {
    const message = createBasePriceCondition()
    message.instrument =
      object.instrument !== undefined && object.instrument !== null
        ? TriggerInstrumentRef.fromPartial(object.instrument)
        : undefined
    message.source = object.source ?? 0
    message.operator = object.operator ?? 0
    message.value = object.value ?? ''
    message.relative =
      object.relative !== undefined && object.relative !== null
        ? RelativePriceTrigger.fromPartial(object.relative)
        : undefined
    return message
  },
}

function createBaseRelativePriceTrigger(): RelativePriceTrigger {
  return { anchor: 0, offset: '', offsetUnit: 0 }
}

export const RelativePriceTrigger: MessageFns<RelativePriceTrigger> = {
  encode(message: RelativePriceTrigger, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.anchor !== 0) {
      writer.uint32(8).int32(message.anchor)
    }
    if (message.offset !== '') {
      writer.uint32(18).string(message.offset)
    }
    if (message.offsetUnit !== 0) {
      writer.uint32(24).int32(message.offsetUnit)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RelativePriceTrigger {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRelativePriceTrigger()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.anchor = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.offset = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.offsetUnit = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RelativePriceTrigger {
    return {
      anchor: isSet(object.anchor) ? priceReferenceFromJSON(object.anchor) : 0,
      offset: isSet(object.offset) ? globalThis.String(object.offset) : '',
      offsetUnit: isSet(object.offsetUnit)
        ? priceOffsetUnitFromJSON(object.offsetUnit)
        : isSet(object.offset_unit)
          ? priceOffsetUnitFromJSON(object.offset_unit)
          : 0,
    }
  },

  toJSON(message: RelativePriceTrigger): unknown {
    const obj: any = {}
    if (message.anchor !== 0) {
      obj.anchor = priceReferenceToJSON(message.anchor)
    }
    if (message.offset !== '') {
      obj.offset = message.offset
    }
    if (message.offsetUnit !== 0) {
      obj.offsetUnit = priceOffsetUnitToJSON(message.offsetUnit)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RelativePriceTrigger>, I>>(base?: I): RelativePriceTrigger {
    return RelativePriceTrigger.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RelativePriceTrigger>, I>>(
    object: I
  ): RelativePriceTrigger {
    const message = createBaseRelativePriceTrigger()
    message.anchor = object.anchor ?? 0
    message.offset = object.offset ?? ''
    message.offsetUnit = object.offsetUnit ?? 0
    return message
  },
}

function createBaseTriggerInstrumentRef(): TriggerInstrumentRef {
  return { symbol: '', exchange: 0, tradeVenue: 0, venueSymbol: '' }
}

export const TriggerInstrumentRef: MessageFns<TriggerInstrumentRef> = {
  encode(message: TriggerInstrumentRef, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(24).int32(message.tradeVenue)
    }
    if (message.venueSymbol !== '') {
      writer.uint32(34).string(message.venueSymbol)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TriggerInstrumentRef {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTriggerInstrumentRef()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.venueSymbol = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TriggerInstrumentRef {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      venueSymbol: isSet(object.venueSymbol)
        ? globalThis.String(object.venueSymbol)
        : isSet(object.venue_symbol)
          ? globalThis.String(object.venue_symbol)
          : '',
    }
  },

  toJSON(message: TriggerInstrumentRef): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.venueSymbol !== '') {
      obj.venueSymbol = message.venueSymbol
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TriggerInstrumentRef>, I>>(base?: I): TriggerInstrumentRef {
    return TriggerInstrumentRef.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TriggerInstrumentRef>, I>>(
    object: I
  ): TriggerInstrumentRef {
    const message = createBaseTriggerInstrumentRef()
    message.symbol = object.symbol ?? ''
    message.exchange = object.exchange ?? 0
    message.tradeVenue = object.tradeVenue ?? 0
    message.venueSymbol = object.venueSymbol ?? ''
    return message
  },
}

function createBaseTriggerOptionInstrumentRef(): TriggerOptionInstrumentRef {
  return {
    symbol: '',
    exchange: 0,
    tradeVenue: 0,
    underlying: '',
    strikePrice: undefined,
    expiryMs: undefined,
    optionType: undefined,
  }
}

export const TriggerOptionInstrumentRef: MessageFns<TriggerOptionInstrumentRef> = {
  encode(
    message: TriggerOptionInstrumentRef,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(24).int32(message.tradeVenue)
    }
    if (message.underlying !== '') {
      writer.uint32(34).string(message.underlying)
    }
    if (message.strikePrice !== undefined) {
      writer.uint32(42).string(message.strikePrice)
    }
    if (message.expiryMs !== undefined) {
      writer.uint32(48).int64(message.expiryMs)
    }
    if (message.optionType !== undefined) {
      writer.uint32(56).int32(message.optionType)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TriggerOptionInstrumentRef {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTriggerOptionInstrumentRef()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.strikePrice = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.expiryMs = reader.int64().toString()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.optionType = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TriggerOptionInstrumentRef {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      strikePrice: isSet(object.strikePrice)
        ? globalThis.String(object.strikePrice)
        : isSet(object.strike_price)
          ? globalThis.String(object.strike_price)
          : undefined,
      expiryMs: isSet(object.expiryMs)
        ? globalThis.String(object.expiryMs)
        : isSet(object.expiry_ms)
          ? globalThis.String(object.expiry_ms)
          : undefined,
      optionType: isSet(object.optionType)
        ? optionTypeFromJSON(object.optionType)
        : isSet(object.option_type)
          ? optionTypeFromJSON(object.option_type)
          : undefined,
    }
  },

  toJSON(message: TriggerOptionInstrumentRef): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.strikePrice !== undefined) {
      obj.strikePrice = message.strikePrice
    }
    if (message.expiryMs !== undefined) {
      obj.expiryMs = message.expiryMs
    }
    if (message.optionType !== undefined) {
      obj.optionType = optionTypeToJSON(message.optionType)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TriggerOptionInstrumentRef>, I>>(
    base?: I
  ): TriggerOptionInstrumentRef {
    return TriggerOptionInstrumentRef.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TriggerOptionInstrumentRef>, I>>(
    object: I
  ): TriggerOptionInstrumentRef {
    const message = createBaseTriggerOptionInstrumentRef()
    message.symbol = object.symbol ?? ''
    message.exchange = object.exchange ?? 0
    message.tradeVenue = object.tradeVenue ?? 0
    message.underlying = object.underlying ?? ''
    message.strikePrice = object.strikePrice ?? undefined
    message.expiryMs = object.expiryMs ?? undefined
    message.optionType = object.optionType ?? undefined
    return message
  },
}

function createBaseScheduleCondition(): ScheduleCondition {
  return { fireAtMs: undefined, delaySeconds: undefined }
}

export const ScheduleCondition: MessageFns<ScheduleCondition> = {
  encode(message: ScheduleCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fireAtMs !== undefined) {
      writer.uint32(8).int64(message.fireAtMs)
    }
    if (message.delaySeconds !== undefined) {
      writer.uint32(16).int64(message.delaySeconds)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScheduleCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseScheduleCondition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.fireAtMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.delaySeconds = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ScheduleCondition {
    return {
      fireAtMs: isSet(object.fireAtMs)
        ? globalThis.String(object.fireAtMs)
        : isSet(object.fire_at_ms)
          ? globalThis.String(object.fire_at_ms)
          : undefined,
      delaySeconds: isSet(object.delaySeconds)
        ? globalThis.String(object.delaySeconds)
        : isSet(object.delay_seconds)
          ? globalThis.String(object.delay_seconds)
          : undefined,
    }
  },

  toJSON(message: ScheduleCondition): unknown {
    const obj: any = {}
    if (message.fireAtMs !== undefined) {
      obj.fireAtMs = message.fireAtMs
    }
    if (message.delaySeconds !== undefined) {
      obj.delaySeconds = message.delaySeconds
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ScheduleCondition>, I>>(base?: I): ScheduleCondition {
    return ScheduleCondition.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ScheduleCondition>, I>>(object: I): ScheduleCondition {
    const message = createBaseScheduleCondition()
    message.fireAtMs = object.fireAtMs ?? undefined
    message.delaySeconds = object.delaySeconds ?? undefined
    return message
  },
}

function createBaseActionEventCondition(): ActionEventCondition {
  return { eventType: 0, partialFillThresholdPercent: undefined, target: undefined }
}

export const ActionEventCondition: MessageFns<ActionEventCondition> = {
  encode(message: ActionEventCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.eventType !== 0) {
      writer.uint32(8).int32(message.eventType)
    }
    if (message.partialFillThresholdPercent !== undefined) {
      writer.uint32(18).string(message.partialFillThresholdPercent)
    }
    if (message.target !== undefined) {
      ActionEventTarget.encode(message.target, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ActionEventCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseActionEventCondition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.eventType = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.partialFillThresholdPercent = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.target = ActionEventTarget.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ActionEventCondition {
    return {
      eventType: isSet(object.eventType)
        ? actionEventTypeFromJSON(object.eventType)
        : isSet(object.event_type)
          ? actionEventTypeFromJSON(object.event_type)
          : 0,
      partialFillThresholdPercent: isSet(object.partialFillThresholdPercent)
        ? globalThis.String(object.partialFillThresholdPercent)
        : isSet(object.partial_fill_threshold_percent)
          ? globalThis.String(object.partial_fill_threshold_percent)
          : undefined,
      target: isSet(object.target) ? ActionEventTarget.fromJSON(object.target) : undefined,
    }
  },

  toJSON(message: ActionEventCondition): unknown {
    const obj: any = {}
    if (message.eventType !== 0) {
      obj.eventType = actionEventTypeToJSON(message.eventType)
    }
    if (message.partialFillThresholdPercent !== undefined) {
      obj.partialFillThresholdPercent = message.partialFillThresholdPercent
    }
    if (message.target !== undefined) {
      obj.target = ActionEventTarget.toJSON(message.target)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ActionEventCondition>, I>>(base?: I): ActionEventCondition {
    return ActionEventCondition.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ActionEventCondition>, I>>(
    object: I
  ): ActionEventCondition {
    const message = createBaseActionEventCondition()
    message.eventType = object.eventType ?? 0
    message.partialFillThresholdPercent = object.partialFillThresholdPercent ?? undefined
    message.target =
      object.target !== undefined && object.target !== null
        ? ActionEventTarget.fromPartial(object.target)
        : undefined
    return message
  },
}

function createBaseActionEventTarget(): ActionEventTarget {
  return { orderId: undefined, algoId: undefined, symbol: undefined }
}

export const ActionEventTarget: MessageFns<ActionEventTarget> = {
  encode(message: ActionEventTarget, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orderId !== undefined) {
      writer.uint32(10).string(message.orderId)
    }
    if (message.algoId !== undefined) {
      writer.uint32(18).string(message.algoId)
    }
    if (message.symbol !== undefined) {
      writer.uint32(34).string(message.symbol)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ActionEventTarget {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseActionEventTarget()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.orderId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.algoId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.symbol = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ActionEventTarget {
    return {
      orderId: isSet(object.orderId)
        ? globalThis.String(object.orderId)
        : isSet(object.order_id)
          ? globalThis.String(object.order_id)
          : undefined,
      algoId: isSet(object.algoId)
        ? globalThis.String(object.algoId)
        : isSet(object.algo_id)
          ? globalThis.String(object.algo_id)
          : undefined,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : undefined,
    }
  },

  toJSON(message: ActionEventTarget): unknown {
    const obj: any = {}
    if (message.orderId !== undefined) {
      obj.orderId = message.orderId
    }
    if (message.algoId !== undefined) {
      obj.algoId = message.algoId
    }
    if (message.symbol !== undefined) {
      obj.symbol = message.symbol
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ActionEventTarget>, I>>(base?: I): ActionEventTarget {
    return ActionEventTarget.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ActionEventTarget>, I>>(object: I): ActionEventTarget {
    const message = createBaseActionEventTarget()
    message.orderId = object.orderId ?? undefined
    message.algoId = object.algoId ?? undefined
    message.symbol = object.symbol ?? undefined
    return message
  },
}

function createBaseTechnicalIndicatorCondition(): TechnicalIndicatorCondition {
  return {
    left: undefined,
    operator: 0,
    threshold: undefined,
    right: undefined,
    maxStalenessMs: undefined,
  }
}

export const TechnicalIndicatorCondition: MessageFns<TechnicalIndicatorCondition> = {
  encode(
    message: TechnicalIndicatorCondition,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.left !== undefined) {
      TechnicalIndicatorSpec.encode(message.left, writer.uint32(10).fork()).join()
    }
    if (message.operator !== 0) {
      writer.uint32(16).int32(message.operator)
    }
    if (message.threshold !== undefined) {
      writer.uint32(26).string(message.threshold)
    }
    if (message.right !== undefined) {
      TechnicalIndicatorSpec.encode(message.right, writer.uint32(34).fork()).join()
    }
    if (message.maxStalenessMs !== undefined) {
      writer.uint32(40).int64(message.maxStalenessMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TechnicalIndicatorCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTechnicalIndicatorCondition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.left = TechnicalIndicatorSpec.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.operator = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.threshold = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.right = TechnicalIndicatorSpec.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.maxStalenessMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TechnicalIndicatorCondition {
    return {
      left: isSet(object.left) ? TechnicalIndicatorSpec.fromJSON(object.left) : undefined,
      operator: isSet(object.operator) ? comparisonOperatorFromJSON(object.operator) : 0,
      threshold: isSet(object.threshold) ? globalThis.String(object.threshold) : undefined,
      right: isSet(object.right) ? TechnicalIndicatorSpec.fromJSON(object.right) : undefined,
      maxStalenessMs: isSet(object.maxStalenessMs)
        ? globalThis.String(object.maxStalenessMs)
        : isSet(object.max_staleness_ms)
          ? globalThis.String(object.max_staleness_ms)
          : undefined,
    }
  },

  toJSON(message: TechnicalIndicatorCondition): unknown {
    const obj: any = {}
    if (message.left !== undefined) {
      obj.left = TechnicalIndicatorSpec.toJSON(message.left)
    }
    if (message.operator !== 0) {
      obj.operator = comparisonOperatorToJSON(message.operator)
    }
    if (message.threshold !== undefined) {
      obj.threshold = message.threshold
    }
    if (message.right !== undefined) {
      obj.right = TechnicalIndicatorSpec.toJSON(message.right)
    }
    if (message.maxStalenessMs !== undefined) {
      obj.maxStalenessMs = message.maxStalenessMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TechnicalIndicatorCondition>, I>>(
    base?: I
  ): TechnicalIndicatorCondition {
    return TechnicalIndicatorCondition.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TechnicalIndicatorCondition>, I>>(
    object: I
  ): TechnicalIndicatorCondition {
    const message = createBaseTechnicalIndicatorCondition()
    message.left =
      object.left !== undefined && object.left !== null
        ? TechnicalIndicatorSpec.fromPartial(object.left)
        : undefined
    message.operator = object.operator ?? 0
    message.threshold = object.threshold ?? undefined
    message.right =
      object.right !== undefined && object.right !== null
        ? TechnicalIndicatorSpec.fromPartial(object.right)
        : undefined
    message.maxStalenessMs = object.maxStalenessMs ?? undefined
    return message
  },
}

function createBaseTechnicalIndicatorSpec(): TechnicalIndicatorSpec {
  return { indicatorType: 0, instrument: undefined, source: 0, periodCount: 0, timeframeSeconds: 0 }
}

export const TechnicalIndicatorSpec: MessageFns<TechnicalIndicatorSpec> = {
  encode(message: TechnicalIndicatorSpec, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.indicatorType !== 0) {
      writer.uint32(8).int32(message.indicatorType)
    }
    if (message.instrument !== undefined) {
      TriggerInstrumentRef.encode(message.instrument, writer.uint32(18).fork()).join()
    }
    if (message.source !== 0) {
      writer.uint32(24).int32(message.source)
    }
    if (message.periodCount !== 0) {
      writer.uint32(32).int32(message.periodCount)
    }
    if (message.timeframeSeconds !== 0) {
      writer.uint32(40).int32(message.timeframeSeconds)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TechnicalIndicatorSpec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTechnicalIndicatorSpec()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.indicatorType = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.instrument = TriggerInstrumentRef.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.source = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.periodCount = reader.int32()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.timeframeSeconds = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TechnicalIndicatorSpec {
    return {
      indicatorType: isSet(object.indicatorType)
        ? technicalIndicatorTypeFromJSON(object.indicatorType)
        : isSet(object.indicator_type)
          ? technicalIndicatorTypeFromJSON(object.indicator_type)
          : 0,
      instrument: isSet(object.instrument)
        ? TriggerInstrumentRef.fromJSON(object.instrument)
        : undefined,
      source: isSet(object.source) ? priceReferenceFromJSON(object.source) : 0,
      periodCount: isSet(object.periodCount)
        ? globalThis.Number(object.periodCount)
        : isSet(object.period_count)
          ? globalThis.Number(object.period_count)
          : 0,
      timeframeSeconds: isSet(object.timeframeSeconds)
        ? chartTimeframeFromJSON(object.timeframeSeconds)
        : isSet(object.timeframe_seconds)
          ? chartTimeframeFromJSON(object.timeframe_seconds)
          : 0,
    }
  },

  toJSON(message: TechnicalIndicatorSpec): unknown {
    const obj: any = {}
    if (message.indicatorType !== 0) {
      obj.indicatorType = technicalIndicatorTypeToJSON(message.indicatorType)
    }
    if (message.instrument !== undefined) {
      obj.instrument = TriggerInstrumentRef.toJSON(message.instrument)
    }
    if (message.source !== 0) {
      obj.source = priceReferenceToJSON(message.source)
    }
    if (message.periodCount !== 0) {
      obj.periodCount = Math.round(message.periodCount)
    }
    if (message.timeframeSeconds !== 0) {
      obj.timeframeSeconds = chartTimeframeToJSON(message.timeframeSeconds)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TechnicalIndicatorSpec>, I>>(
    base?: I
  ): TechnicalIndicatorSpec {
    return TechnicalIndicatorSpec.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TechnicalIndicatorSpec>, I>>(
    object: I
  ): TechnicalIndicatorSpec {
    const message = createBaseTechnicalIndicatorSpec()
    message.indicatorType = object.indicatorType ?? 0
    message.instrument =
      object.instrument !== undefined && object.instrument !== null
        ? TriggerInstrumentRef.fromPartial(object.instrument)
        : undefined
    message.source = object.source ?? 0
    message.periodCount = object.periodCount ?? 0
    message.timeframeSeconds = object.timeframeSeconds ?? 0
    return message
  },
}

function createBaseReturnCondition(): ReturnCondition {
  return {
    instrument: undefined,
    source: 0,
    windowMs: '0',
    operator: 0,
    valuePercent: '',
    timeframeSeconds: 0,
    maxStalenessMs: undefined,
  }
}

export const ReturnCondition: MessageFns<ReturnCondition> = {
  encode(message: ReturnCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.instrument !== undefined) {
      TriggerInstrumentRef.encode(message.instrument, writer.uint32(10).fork()).join()
    }
    if (message.source !== 0) {
      writer.uint32(16).int32(message.source)
    }
    if (message.windowMs !== '0') {
      writer.uint32(24).int64(message.windowMs)
    }
    if (message.operator !== 0) {
      writer.uint32(32).int32(message.operator)
    }
    if (message.valuePercent !== '') {
      writer.uint32(42).string(message.valuePercent)
    }
    if (message.timeframeSeconds !== 0) {
      writer.uint32(48).int32(message.timeframeSeconds)
    }
    if (message.maxStalenessMs !== undefined) {
      writer.uint32(56).int64(message.maxStalenessMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReturnCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseReturnCondition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.instrument = TriggerInstrumentRef.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.source = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.windowMs = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.operator = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.valuePercent = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.timeframeSeconds = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.maxStalenessMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ReturnCondition {
    return {
      instrument: isSet(object.instrument)
        ? TriggerInstrumentRef.fromJSON(object.instrument)
        : undefined,
      source: isSet(object.source) ? priceReferenceFromJSON(object.source) : 0,
      windowMs: isSet(object.windowMs)
        ? globalThis.String(object.windowMs)
        : isSet(object.window_ms)
          ? globalThis.String(object.window_ms)
          : '0',
      operator: isSet(object.operator) ? comparisonOperatorFromJSON(object.operator) : 0,
      valuePercent: isSet(object.valuePercent)
        ? globalThis.String(object.valuePercent)
        : isSet(object.value_percent)
          ? globalThis.String(object.value_percent)
          : '',
      timeframeSeconds: isSet(object.timeframeSeconds)
        ? chartTimeframeFromJSON(object.timeframeSeconds)
        : isSet(object.timeframe_seconds)
          ? chartTimeframeFromJSON(object.timeframe_seconds)
          : 0,
      maxStalenessMs: isSet(object.maxStalenessMs)
        ? globalThis.String(object.maxStalenessMs)
        : isSet(object.max_staleness_ms)
          ? globalThis.String(object.max_staleness_ms)
          : undefined,
    }
  },

  toJSON(message: ReturnCondition): unknown {
    const obj: any = {}
    if (message.instrument !== undefined) {
      obj.instrument = TriggerInstrumentRef.toJSON(message.instrument)
    }
    if (message.source !== 0) {
      obj.source = priceReferenceToJSON(message.source)
    }
    if (message.windowMs !== '0') {
      obj.windowMs = message.windowMs
    }
    if (message.operator !== 0) {
      obj.operator = comparisonOperatorToJSON(message.operator)
    }
    if (message.valuePercent !== '') {
      obj.valuePercent = message.valuePercent
    }
    if (message.timeframeSeconds !== 0) {
      obj.timeframeSeconds = chartTimeframeToJSON(message.timeframeSeconds)
    }
    if (message.maxStalenessMs !== undefined) {
      obj.maxStalenessMs = message.maxStalenessMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ReturnCondition>, I>>(base?: I): ReturnCondition {
    return ReturnCondition.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ReturnCondition>, I>>(object: I): ReturnCondition {
    const message = createBaseReturnCondition()
    message.instrument =
      object.instrument !== undefined && object.instrument !== null
        ? TriggerInstrumentRef.fromPartial(object.instrument)
        : undefined
    message.source = object.source ?? 0
    message.windowMs = object.windowMs ?? '0'
    message.operator = object.operator ?? 0
    message.valuePercent = object.valuePercent ?? ''
    message.timeframeSeconds = object.timeframeSeconds ?? 0
    message.maxStalenessMs = object.maxStalenessMs ?? undefined
    return message
  },
}

function createBaseCandleCondition(): CandleCondition {
  return {
    instrument: undefined,
    timeframeSeconds: 0,
    field: 0,
    operator: 0,
    value: '',
    allowOpenCandle: false,
    maxStalenessMs: undefined,
  }
}

export const CandleCondition: MessageFns<CandleCondition> = {
  encode(message: CandleCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.instrument !== undefined) {
      TriggerInstrumentRef.encode(message.instrument, writer.uint32(10).fork()).join()
    }
    if (message.timeframeSeconds !== 0) {
      writer.uint32(16).int32(message.timeframeSeconds)
    }
    if (message.field !== 0) {
      writer.uint32(24).int32(message.field)
    }
    if (message.operator !== 0) {
      writer.uint32(32).int32(message.operator)
    }
    if (message.value !== '') {
      writer.uint32(42).string(message.value)
    }
    if (message.allowOpenCandle !== false) {
      writer.uint32(48).bool(message.allowOpenCandle)
    }
    if (message.maxStalenessMs !== undefined) {
      writer.uint32(56).int64(message.maxStalenessMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CandleCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCandleCondition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.instrument = TriggerInstrumentRef.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.timeframeSeconds = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.field = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.operator = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.value = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.allowOpenCandle = reader.bool()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.maxStalenessMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CandleCondition {
    return {
      instrument: isSet(object.instrument)
        ? TriggerInstrumentRef.fromJSON(object.instrument)
        : undefined,
      timeframeSeconds: isSet(object.timeframeSeconds)
        ? chartTimeframeFromJSON(object.timeframeSeconds)
        : isSet(object.timeframe_seconds)
          ? chartTimeframeFromJSON(object.timeframe_seconds)
          : 0,
      field: isSet(object.field) ? candleFieldFromJSON(object.field) : 0,
      operator: isSet(object.operator) ? comparisonOperatorFromJSON(object.operator) : 0,
      value: isSet(object.value) ? globalThis.String(object.value) : '',
      allowOpenCandle: isSet(object.allowOpenCandle)
        ? globalThis.Boolean(object.allowOpenCandle)
        : isSet(object.allow_open_candle)
          ? globalThis.Boolean(object.allow_open_candle)
          : false,
      maxStalenessMs: isSet(object.maxStalenessMs)
        ? globalThis.String(object.maxStalenessMs)
        : isSet(object.max_staleness_ms)
          ? globalThis.String(object.max_staleness_ms)
          : undefined,
    }
  },

  toJSON(message: CandleCondition): unknown {
    const obj: any = {}
    if (message.instrument !== undefined) {
      obj.instrument = TriggerInstrumentRef.toJSON(message.instrument)
    }
    if (message.timeframeSeconds !== 0) {
      obj.timeframeSeconds = chartTimeframeToJSON(message.timeframeSeconds)
    }
    if (message.field !== 0) {
      obj.field = candleFieldToJSON(message.field)
    }
    if (message.operator !== 0) {
      obj.operator = comparisonOperatorToJSON(message.operator)
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    if (message.allowOpenCandle !== false) {
      obj.allowOpenCandle = message.allowOpenCandle
    }
    if (message.maxStalenessMs !== undefined) {
      obj.maxStalenessMs = message.maxStalenessMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CandleCondition>, I>>(base?: I): CandleCondition {
    return CandleCondition.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CandleCondition>, I>>(object: I): CandleCondition {
    const message = createBaseCandleCondition()
    message.instrument =
      object.instrument !== undefined && object.instrument !== null
        ? TriggerInstrumentRef.fromPartial(object.instrument)
        : undefined
    message.timeframeSeconds = object.timeframeSeconds ?? 0
    message.field = object.field ?? 0
    message.operator = object.operator ?? 0
    message.value = object.value ?? ''
    message.allowOpenCandle = object.allowOpenCandle ?? false
    message.maxStalenessMs = object.maxStalenessMs ?? undefined
    return message
  },
}

function createBasePortfolioMetricCondition(): PortfolioMetricCondition {
  return {
    accountId: '',
    metric: 0,
    operator: 0,
    value: '',
    maxStalenessMs: undefined,
    currency: undefined,
  }
}

export const PortfolioMetricCondition: MessageFns<PortfolioMetricCondition> = {
  encode(
    message: PortfolioMetricCondition,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.metric !== 0) {
      writer.uint32(16).int32(message.metric)
    }
    if (message.operator !== 0) {
      writer.uint32(24).int32(message.operator)
    }
    if (message.value !== '') {
      writer.uint32(34).string(message.value)
    }
    if (message.maxStalenessMs !== undefined) {
      writer.uint32(40).int64(message.maxStalenessMs)
    }
    if (message.currency !== undefined) {
      writer.uint32(50).string(message.currency)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortfolioMetricCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePortfolioMetricCondition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.metric = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.operator = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.value = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.maxStalenessMs = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.currency = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PortfolioMetricCondition {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      metric: isSet(object.metric) ? portfolioMetricFromJSON(object.metric) : 0,
      operator: isSet(object.operator) ? comparisonOperatorFromJSON(object.operator) : 0,
      value: isSet(object.value) ? globalThis.String(object.value) : '',
      maxStalenessMs: isSet(object.maxStalenessMs)
        ? globalThis.String(object.maxStalenessMs)
        : isSet(object.max_staleness_ms)
          ? globalThis.String(object.max_staleness_ms)
          : undefined,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : undefined,
    }
  },

  toJSON(message: PortfolioMetricCondition): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.metric !== 0) {
      obj.metric = portfolioMetricToJSON(message.metric)
    }
    if (message.operator !== 0) {
      obj.operator = comparisonOperatorToJSON(message.operator)
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    if (message.maxStalenessMs !== undefined) {
      obj.maxStalenessMs = message.maxStalenessMs
    }
    if (message.currency !== undefined) {
      obj.currency = message.currency
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PortfolioMetricCondition>, I>>(
    base?: I
  ): PortfolioMetricCondition {
    return PortfolioMetricCondition.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PortfolioMetricCondition>, I>>(
    object: I
  ): PortfolioMetricCondition {
    const message = createBasePortfolioMetricCondition()
    message.accountId = object.accountId ?? ''
    message.metric = object.metric ?? 0
    message.operator = object.operator ?? 0
    message.value = object.value ?? ''
    message.maxStalenessMs = object.maxStalenessMs ?? undefined
    message.currency = object.currency ?? undefined
    return message
  },
}

function createBasePositionMetricCondition(): PositionMetricCondition {
  return {
    accountId: '',
    scope: undefined,
    metric: 0,
    operator: 0,
    value: '',
    maxStalenessMs: undefined,
  }
}

export const PositionMetricCondition: MessageFns<PositionMetricCondition> = {
  encode(
    message: PositionMetricCondition,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.scope !== undefined) {
      PositionMetricScope.encode(message.scope, writer.uint32(18).fork()).join()
    }
    if (message.metric !== 0) {
      writer.uint32(24).int32(message.metric)
    }
    if (message.operator !== 0) {
      writer.uint32(32).int32(message.operator)
    }
    if (message.value !== '') {
      writer.uint32(42).string(message.value)
    }
    if (message.maxStalenessMs !== undefined) {
      writer.uint32(48).int64(message.maxStalenessMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PositionMetricCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePositionMetricCondition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.scope = PositionMetricScope.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.metric = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.operator = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.value = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.maxStalenessMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PositionMetricCondition {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      scope: isSet(object.scope) ? PositionMetricScope.fromJSON(object.scope) : undefined,
      metric: isSet(object.metric) ? positionMetricFromJSON(object.metric) : 0,
      operator: isSet(object.operator) ? comparisonOperatorFromJSON(object.operator) : 0,
      value: isSet(object.value) ? globalThis.String(object.value) : '',
      maxStalenessMs: isSet(object.maxStalenessMs)
        ? globalThis.String(object.maxStalenessMs)
        : isSet(object.max_staleness_ms)
          ? globalThis.String(object.max_staleness_ms)
          : undefined,
    }
  },

  toJSON(message: PositionMetricCondition): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.scope !== undefined) {
      obj.scope = PositionMetricScope.toJSON(message.scope)
    }
    if (message.metric !== 0) {
      obj.metric = positionMetricToJSON(message.metric)
    }
    if (message.operator !== 0) {
      obj.operator = comparisonOperatorToJSON(message.operator)
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    if (message.maxStalenessMs !== undefined) {
      obj.maxStalenessMs = message.maxStalenessMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PositionMetricCondition>, I>>(
    base?: I
  ): PositionMetricCondition {
    return PositionMetricCondition.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PositionMetricCondition>, I>>(
    object: I
  ): PositionMetricCondition {
    const message = createBasePositionMetricCondition()
    message.accountId = object.accountId ?? ''
    message.scope =
      object.scope !== undefined && object.scope !== null
        ? PositionMetricScope.fromPartial(object.scope)
        : undefined
    message.metric = object.metric ?? 0
    message.operator = object.operator ?? 0
    message.value = object.value ?? ''
    message.maxStalenessMs = object.maxStalenessMs ?? undefined
    return message
  },
}

function createBasePositionMetricScope(): PositionMetricScope {
  return {
    symbol: undefined,
    underlying: undefined,
    positionGroupId: undefined,
    allPositions: undefined,
  }
}

export const PositionMetricScope: MessageFns<PositionMetricScope> = {
  encode(message: PositionMetricScope, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== undefined) {
      writer.uint32(10).string(message.symbol)
    }
    if (message.underlying !== undefined) {
      writer.uint32(18).string(message.underlying)
    }
    if (message.positionGroupId !== undefined) {
      writer.uint32(26).string(message.positionGroupId)
    }
    if (message.allPositions !== undefined) {
      writer.uint32(32).bool(message.allPositions)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PositionMetricScope {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePositionMetricScope()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.positionGroupId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.allPositions = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PositionMetricScope {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : undefined,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : undefined,
      positionGroupId: isSet(object.positionGroupId)
        ? globalThis.String(object.positionGroupId)
        : isSet(object.position_group_id)
          ? globalThis.String(object.position_group_id)
          : undefined,
      allPositions: isSet(object.allPositions)
        ? globalThis.Boolean(object.allPositions)
        : isSet(object.all_positions)
          ? globalThis.Boolean(object.all_positions)
          : undefined,
    }
  },

  toJSON(message: PositionMetricScope): unknown {
    const obj: any = {}
    if (message.symbol !== undefined) {
      obj.symbol = message.symbol
    }
    if (message.underlying !== undefined) {
      obj.underlying = message.underlying
    }
    if (message.positionGroupId !== undefined) {
      obj.positionGroupId = message.positionGroupId
    }
    if (message.allPositions !== undefined) {
      obj.allPositions = message.allPositions
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PositionMetricScope>, I>>(base?: I): PositionMetricScope {
    return PositionMetricScope.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PositionMetricScope>, I>>(
    object: I
  ): PositionMetricScope {
    const message = createBasePositionMetricScope()
    message.symbol = object.symbol ?? undefined
    message.underlying = object.underlying ?? undefined
    message.positionGroupId = object.positionGroupId ?? undefined
    message.allPositions = object.allPositions ?? undefined
    return message
  },
}

function createBaseRiskMetricCondition(): RiskMetricCondition {
  return { accountId: '', asset: '', metric: 0, operator: 0, value: '', maxStalenessMs: undefined }
}

export const RiskMetricCondition: MessageFns<RiskMetricCondition> = {
  encode(message: RiskMetricCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.asset !== '') {
      writer.uint32(18).string(message.asset)
    }
    if (message.metric !== 0) {
      writer.uint32(24).int32(message.metric)
    }
    if (message.operator !== 0) {
      writer.uint32(32).int32(message.operator)
    }
    if (message.value !== '') {
      writer.uint32(42).string(message.value)
    }
    if (message.maxStalenessMs !== undefined) {
      writer.uint32(48).int64(message.maxStalenessMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RiskMetricCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRiskMetricCondition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.asset = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.metric = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.operator = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.value = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.maxStalenessMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RiskMetricCondition {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      asset: isSet(object.asset) ? globalThis.String(object.asset) : '',
      metric: isSet(object.metric) ? riskMetricFromJSON(object.metric) : 0,
      operator: isSet(object.operator) ? comparisonOperatorFromJSON(object.operator) : 0,
      value: isSet(object.value) ? globalThis.String(object.value) : '',
      maxStalenessMs: isSet(object.maxStalenessMs)
        ? globalThis.String(object.maxStalenessMs)
        : isSet(object.max_staleness_ms)
          ? globalThis.String(object.max_staleness_ms)
          : undefined,
    }
  },

  toJSON(message: RiskMetricCondition): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.asset !== '') {
      obj.asset = message.asset
    }
    if (message.metric !== 0) {
      obj.metric = riskMetricToJSON(message.metric)
    }
    if (message.operator !== 0) {
      obj.operator = comparisonOperatorToJSON(message.operator)
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    if (message.maxStalenessMs !== undefined) {
      obj.maxStalenessMs = message.maxStalenessMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RiskMetricCondition>, I>>(base?: I): RiskMetricCondition {
    return RiskMetricCondition.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RiskMetricCondition>, I>>(
    object: I
  ): RiskMetricCondition {
    const message = createBaseRiskMetricCondition()
    message.accountId = object.accountId ?? ''
    message.asset = object.asset ?? ''
    message.metric = object.metric ?? 0
    message.operator = object.operator ?? 0
    message.value = object.value ?? ''
    message.maxStalenessMs = object.maxStalenessMs ?? undefined
    return message
  },
}

function createBaseOptionIvCondition(): OptionIvCondition {
  return {
    instrument: undefined,
    source: 0,
    operator: 0,
    valuePercent: '',
    maxStalenessMs: undefined,
  }
}

export const OptionIvCondition: MessageFns<OptionIvCondition> = {
  encode(message: OptionIvCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.instrument !== undefined) {
      TriggerOptionInstrumentRef.encode(message.instrument, writer.uint32(10).fork()).join()
    }
    if (message.source !== 0) {
      writer.uint32(16).int32(message.source)
    }
    if (message.operator !== 0) {
      writer.uint32(24).int32(message.operator)
    }
    if (message.valuePercent !== '') {
      writer.uint32(34).string(message.valuePercent)
    }
    if (message.maxStalenessMs !== undefined) {
      writer.uint32(40).int64(message.maxStalenessMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionIvCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionIvCondition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.instrument = TriggerOptionInstrumentRef.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.source = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.operator = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.valuePercent = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.maxStalenessMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionIvCondition {
    return {
      instrument: isSet(object.instrument)
        ? TriggerOptionInstrumentRef.fromJSON(object.instrument)
        : undefined,
      source: isSet(object.source) ? optionIvSourceFromJSON(object.source) : 0,
      operator: isSet(object.operator) ? comparisonOperatorFromJSON(object.operator) : 0,
      valuePercent: isSet(object.valuePercent)
        ? globalThis.String(object.valuePercent)
        : isSet(object.value_percent)
          ? globalThis.String(object.value_percent)
          : '',
      maxStalenessMs: isSet(object.maxStalenessMs)
        ? globalThis.String(object.maxStalenessMs)
        : isSet(object.max_staleness_ms)
          ? globalThis.String(object.max_staleness_ms)
          : undefined,
    }
  },

  toJSON(message: OptionIvCondition): unknown {
    const obj: any = {}
    if (message.instrument !== undefined) {
      obj.instrument = TriggerOptionInstrumentRef.toJSON(message.instrument)
    }
    if (message.source !== 0) {
      obj.source = optionIvSourceToJSON(message.source)
    }
    if (message.operator !== 0) {
      obj.operator = comparisonOperatorToJSON(message.operator)
    }
    if (message.valuePercent !== '') {
      obj.valuePercent = message.valuePercent
    }
    if (message.maxStalenessMs !== undefined) {
      obj.maxStalenessMs = message.maxStalenessMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionIvCondition>, I>>(base?: I): OptionIvCondition {
    return OptionIvCondition.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionIvCondition>, I>>(object: I): OptionIvCondition {
    const message = createBaseOptionIvCondition()
    message.instrument =
      object.instrument !== undefined && object.instrument !== null
        ? TriggerOptionInstrumentRef.fromPartial(object.instrument)
        : undefined
    message.source = object.source ?? 0
    message.operator = object.operator ?? 0
    message.valuePercent = object.valuePercent ?? ''
    message.maxStalenessMs = object.maxStalenessMs ?? undefined
    return message
  },
}

function createBaseDbNewsCondition(): DbNewsCondition {
  return {
    eeType: [],
    newsType: [],
    coins: [],
    tags: [],
    textContains: [],
    eventNotBeforeMs: undefined,
  }
}

export const DbNewsCondition: MessageFns<DbNewsCondition> = {
  encode(message: DbNewsCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.eeType) {
      writer.uint32(10).string(v!)
    }
    for (const v of message.newsType) {
      writer.uint32(18).string(v!)
    }
    for (const v of message.coins) {
      writer.uint32(26).string(v!)
    }
    for (const v of message.tags) {
      writer.uint32(34).string(v!)
    }
    for (const v of message.textContains) {
      writer.uint32(42).string(v!)
    }
    if (message.eventNotBeforeMs !== undefined) {
      writer.uint32(48).int64(message.eventNotBeforeMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DbNewsCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDbNewsCondition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.eeType.push(reader.string())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.newsType.push(reader.string())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.coins.push(reader.string())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.tags.push(reader.string())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.textContains.push(reader.string())
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.eventNotBeforeMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DbNewsCondition {
    return {
      eeType: globalThis.Array.isArray(object?.eeType)
        ? object.eeType.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ee_type)
          ? object.ee_type.map((e: any) => globalThis.String(e))
          : [],
      newsType: globalThis.Array.isArray(object?.newsType)
        ? object.newsType.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.news_type)
          ? object.news_type.map((e: any) => globalThis.String(e))
          : [],
      coins: globalThis.Array.isArray(object?.coins)
        ? object.coins.map((e: any) => globalThis.String(e))
        : [],
      tags: globalThis.Array.isArray(object?.tags)
        ? object.tags.map((e: any) => globalThis.String(e))
        : [],
      textContains: globalThis.Array.isArray(object?.textContains)
        ? object.textContains.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.text_contains)
          ? object.text_contains.map((e: any) => globalThis.String(e))
          : [],
      eventNotBeforeMs: isSet(object.eventNotBeforeMs)
        ? globalThis.String(object.eventNotBeforeMs)
        : isSet(object.event_not_before_ms)
          ? globalThis.String(object.event_not_before_ms)
          : undefined,
    }
  },

  toJSON(message: DbNewsCondition): unknown {
    const obj: any = {}
    if (message.eeType?.length) {
      obj.eeType = message.eeType
    }
    if (message.newsType?.length) {
      obj.newsType = message.newsType
    }
    if (message.coins?.length) {
      obj.coins = message.coins
    }
    if (message.tags?.length) {
      obj.tags = message.tags
    }
    if (message.textContains?.length) {
      obj.textContains = message.textContains
    }
    if (message.eventNotBeforeMs !== undefined) {
      obj.eventNotBeforeMs = message.eventNotBeforeMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DbNewsCondition>, I>>(base?: I): DbNewsCondition {
    return DbNewsCondition.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DbNewsCondition>, I>>(object: I): DbNewsCondition {
    const message = createBaseDbNewsCondition()
    message.eeType = object.eeType?.map((e) => e) || []
    message.newsType = object.newsType?.map((e) => e) || []
    message.coins = object.coins?.map((e) => e) || []
    message.tags = object.tags?.map((e) => e) || []
    message.textContains = object.textContains?.map((e) => e) || []
    message.eventNotBeforeMs = object.eventNotBeforeMs ?? undefined
    return message
  },
}

function createBasePolymarketCondition(): PolymarketCondition {
  return { tokenId: '', operator: 0, threshold: '' }
}

export const PolymarketCondition: MessageFns<PolymarketCondition> = {
  encode(message: PolymarketCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tokenId !== '') {
      writer.uint32(10).string(message.tokenId)
    }
    if (message.operator !== 0) {
      writer.uint32(16).int32(message.operator)
    }
    if (message.threshold !== '') {
      writer.uint32(26).string(message.threshold)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PolymarketCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePolymarketCondition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.tokenId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.operator = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.threshold = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PolymarketCondition {
    return {
      tokenId: isSet(object.tokenId)
        ? globalThis.String(object.tokenId)
        : isSet(object.token_id)
          ? globalThis.String(object.token_id)
          : '',
      operator: isSet(object.operator) ? comparisonOperatorFromJSON(object.operator) : 0,
      threshold: isSet(object.threshold) ? globalThis.String(object.threshold) : '',
    }
  },

  toJSON(message: PolymarketCondition): unknown {
    const obj: any = {}
    if (message.tokenId !== '') {
      obj.tokenId = message.tokenId
    }
    if (message.operator !== 0) {
      obj.operator = comparisonOperatorToJSON(message.operator)
    }
    if (message.threshold !== '') {
      obj.threshold = message.threshold
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PolymarketCondition>, I>>(base?: I): PolymarketCondition {
    return PolymarketCondition.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PolymarketCondition>, I>>(
    object: I
  ): PolymarketCondition {
    const message = createBasePolymarketCondition()
    message.tokenId = object.tokenId ?? ''
    message.operator = object.operator ?? 0
    message.threshold = object.threshold ?? ''
    return message
  },
}

function createBaseAlertScope(): AlertScope {
  return { kind: 0, id: '' }
}

export const AlertScope: MessageFns<AlertScope> = {
  encode(message: AlertScope, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind)
    }
    if (message.id !== '') {
      writer.uint32(18).string(message.id)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AlertScope {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAlertScope()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.kind = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.id = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AlertScope {
    return {
      kind: isSet(object.kind) ? alertScopeKindFromJSON(object.kind) : 0,
      id: isSet(object.id) ? globalThis.String(object.id) : '',
    }
  },

  toJSON(message: AlertScope): unknown {
    const obj: any = {}
    if (message.kind !== 0) {
      obj.kind = alertScopeKindToJSON(message.kind)
    }
    if (message.id !== '') {
      obj.id = message.id
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AlertScope>, I>>(base?: I): AlertScope {
    return AlertScope.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AlertScope>, I>>(object: I): AlertScope {
    const message = createBaseAlertScope()
    message.kind = object.kind ?? 0
    message.id = object.id ?? ''
    return message
  },
}

function createBaseRegisterAlertRequest(): RegisterAlertRequest {
  return { scope: undefined, registrationId: '', trigger: undefined }
}

export const RegisterAlertRequest: MessageFns<RegisterAlertRequest> = {
  encode(message: RegisterAlertRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.scope !== undefined) {
      AlertScope.encode(message.scope, writer.uint32(10).fork()).join()
    }
    if (message.registrationId !== '') {
      writer.uint32(18).string(message.registrationId)
    }
    if (message.trigger !== undefined) {
      Trigger.encode(message.trigger, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RegisterAlertRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRegisterAlertRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.scope = AlertScope.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.registrationId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.trigger = Trigger.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RegisterAlertRequest {
    return {
      scope: isSet(object.scope) ? AlertScope.fromJSON(object.scope) : undefined,
      registrationId: isSet(object.registrationId)
        ? globalThis.String(object.registrationId)
        : isSet(object.registration_id)
          ? globalThis.String(object.registration_id)
          : '',
      trigger: isSet(object.trigger) ? Trigger.fromJSON(object.trigger) : undefined,
    }
  },

  toJSON(message: RegisterAlertRequest): unknown {
    const obj: any = {}
    if (message.scope !== undefined) {
      obj.scope = AlertScope.toJSON(message.scope)
    }
    if (message.registrationId !== '') {
      obj.registrationId = message.registrationId
    }
    if (message.trigger !== undefined) {
      obj.trigger = Trigger.toJSON(message.trigger)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RegisterAlertRequest>, I>>(base?: I): RegisterAlertRequest {
    return RegisterAlertRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RegisterAlertRequest>, I>>(
    object: I
  ): RegisterAlertRequest {
    const message = createBaseRegisterAlertRequest()
    message.scope =
      object.scope !== undefined && object.scope !== null
        ? AlertScope.fromPartial(object.scope)
        : undefined
    message.registrationId = object.registrationId ?? ''
    message.trigger =
      object.trigger !== undefined && object.trigger !== null
        ? Trigger.fromPartial(object.trigger)
        : undefined
    return message
  },
}

function createBaseRegisterAlertResponse(): RegisterAlertResponse {
  return {
    triggerId: '',
    registrationId: '',
    status: 0,
    alreadyFired: false,
    resolvedDescriptor: undefined,
    error: undefined,
  }
}

export const RegisterAlertResponse: MessageFns<RegisterAlertResponse> = {
  encode(message: RegisterAlertResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.triggerId !== '') {
      writer.uint32(10).string(message.triggerId)
    }
    if (message.registrationId !== '') {
      writer.uint32(18).string(message.registrationId)
    }
    if (message.status !== 0) {
      writer.uint32(24).int32(message.status)
    }
    if (message.alreadyFired !== false) {
      writer.uint32(32).bool(message.alreadyFired)
    }
    if (message.resolvedDescriptor !== undefined) {
      ResolvedAlertDescriptor.encode(message.resolvedDescriptor, writer.uint32(42).fork()).join()
    }
    if (message.error !== undefined) {
      writer.uint32(50).string(message.error)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RegisterAlertResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRegisterAlertResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.triggerId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.registrationId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.status = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.alreadyFired = reader.bool()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.resolvedDescriptor = ResolvedAlertDescriptor.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.error = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RegisterAlertResponse {
    return {
      triggerId: isSet(object.triggerId)
        ? globalThis.String(object.triggerId)
        : isSet(object.trigger_id)
          ? globalThis.String(object.trigger_id)
          : '',
      registrationId: isSet(object.registrationId)
        ? globalThis.String(object.registrationId)
        : isSet(object.registration_id)
          ? globalThis.String(object.registration_id)
          : '',
      status: isSet(object.status) ? alertRegistrationStatusFromJSON(object.status) : 0,
      alreadyFired: isSet(object.alreadyFired)
        ? globalThis.Boolean(object.alreadyFired)
        : isSet(object.already_fired)
          ? globalThis.Boolean(object.already_fired)
          : false,
      resolvedDescriptor: isSet(object.resolvedDescriptor)
        ? ResolvedAlertDescriptor.fromJSON(object.resolvedDescriptor)
        : isSet(object.resolved_descriptor)
          ? ResolvedAlertDescriptor.fromJSON(object.resolved_descriptor)
          : undefined,
      error: isSet(object.error) ? globalThis.String(object.error) : undefined,
    }
  },

  toJSON(message: RegisterAlertResponse): unknown {
    const obj: any = {}
    if (message.triggerId !== '') {
      obj.triggerId = message.triggerId
    }
    if (message.registrationId !== '') {
      obj.registrationId = message.registrationId
    }
    if (message.status !== 0) {
      obj.status = alertRegistrationStatusToJSON(message.status)
    }
    if (message.alreadyFired !== false) {
      obj.alreadyFired = message.alreadyFired
    }
    if (message.resolvedDescriptor !== undefined) {
      obj.resolvedDescriptor = ResolvedAlertDescriptor.toJSON(message.resolvedDescriptor)
    }
    if (message.error !== undefined) {
      obj.error = message.error
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RegisterAlertResponse>, I>>(base?: I): RegisterAlertResponse {
    return RegisterAlertResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RegisterAlertResponse>, I>>(
    object: I
  ): RegisterAlertResponse {
    const message = createBaseRegisterAlertResponse()
    message.triggerId = object.triggerId ?? ''
    message.registrationId = object.registrationId ?? ''
    message.status = object.status ?? 0
    message.alreadyFired = object.alreadyFired ?? false
    message.resolvedDescriptor =
      object.resolvedDescriptor !== undefined && object.resolvedDescriptor !== null
        ? ResolvedAlertDescriptor.fromPartial(object.resolvedDescriptor)
        : undefined
    message.error = object.error ?? undefined
    return message
  },
}

function createBaseDeregisterAlertRequest(): DeregisterAlertRequest {
  return { scope: undefined, registrationId: '', triggerId: '' }
}

export const DeregisterAlertRequest: MessageFns<DeregisterAlertRequest> = {
  encode(message: DeregisterAlertRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.scope !== undefined) {
      AlertScope.encode(message.scope, writer.uint32(10).fork()).join()
    }
    if (message.registrationId !== '') {
      writer.uint32(18).string(message.registrationId)
    }
    if (message.triggerId !== '') {
      writer.uint32(26).string(message.triggerId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeregisterAlertRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeregisterAlertRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.scope = AlertScope.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.registrationId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.triggerId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeregisterAlertRequest {
    return {
      scope: isSet(object.scope) ? AlertScope.fromJSON(object.scope) : undefined,
      registrationId: isSet(object.registrationId)
        ? globalThis.String(object.registrationId)
        : isSet(object.registration_id)
          ? globalThis.String(object.registration_id)
          : '',
      triggerId: isSet(object.triggerId)
        ? globalThis.String(object.triggerId)
        : isSet(object.trigger_id)
          ? globalThis.String(object.trigger_id)
          : '',
    }
  },

  toJSON(message: DeregisterAlertRequest): unknown {
    const obj: any = {}
    if (message.scope !== undefined) {
      obj.scope = AlertScope.toJSON(message.scope)
    }
    if (message.registrationId !== '') {
      obj.registrationId = message.registrationId
    }
    if (message.triggerId !== '') {
      obj.triggerId = message.triggerId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeregisterAlertRequest>, I>>(
    base?: I
  ): DeregisterAlertRequest {
    return DeregisterAlertRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeregisterAlertRequest>, I>>(
    object: I
  ): DeregisterAlertRequest {
    const message = createBaseDeregisterAlertRequest()
    message.scope =
      object.scope !== undefined && object.scope !== null
        ? AlertScope.fromPartial(object.scope)
        : undefined
    message.registrationId = object.registrationId ?? ''
    message.triggerId = object.triggerId ?? ''
    return message
  },
}

function createBaseDeregisterAlertResponse(): DeregisterAlertResponse {
  return { success: false, registrationId: '', triggerId: '', status: 0, error: undefined }
}

export const DeregisterAlertResponse: MessageFns<DeregisterAlertResponse> = {
  encode(
    message: DeregisterAlertResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.registrationId !== '') {
      writer.uint32(18).string(message.registrationId)
    }
    if (message.triggerId !== '') {
      writer.uint32(26).string(message.triggerId)
    }
    if (message.status !== 0) {
      writer.uint32(32).int32(message.status)
    }
    if (message.error !== undefined) {
      writer.uint32(42).string(message.error)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeregisterAlertResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeregisterAlertResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.registrationId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.triggerId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.status = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.error = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeregisterAlertResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      registrationId: isSet(object.registrationId)
        ? globalThis.String(object.registrationId)
        : isSet(object.registration_id)
          ? globalThis.String(object.registration_id)
          : '',
      triggerId: isSet(object.triggerId)
        ? globalThis.String(object.triggerId)
        : isSet(object.trigger_id)
          ? globalThis.String(object.trigger_id)
          : '',
      status: isSet(object.status) ? alertRegistrationStatusFromJSON(object.status) : 0,
      error: isSet(object.error) ? globalThis.String(object.error) : undefined,
    }
  },

  toJSON(message: DeregisterAlertResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.registrationId !== '') {
      obj.registrationId = message.registrationId
    }
    if (message.triggerId !== '') {
      obj.triggerId = message.triggerId
    }
    if (message.status !== 0) {
      obj.status = alertRegistrationStatusToJSON(message.status)
    }
    if (message.error !== undefined) {
      obj.error = message.error
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeregisterAlertResponse>, I>>(
    base?: I
  ): DeregisterAlertResponse {
    return DeregisterAlertResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeregisterAlertResponse>, I>>(
    object: I
  ): DeregisterAlertResponse {
    const message = createBaseDeregisterAlertResponse()
    message.success = object.success ?? false
    message.registrationId = object.registrationId ?? ''
    message.triggerId = object.triggerId ?? ''
    message.status = object.status ?? 0
    message.error = object.error ?? undefined
    return message
  },
}

function createBaseConfirmAlertRequest(): ConfirmAlertRequest {
  return { scope: undefined, registrationId: '', triggerId: '' }
}

export const ConfirmAlertRequest: MessageFns<ConfirmAlertRequest> = {
  encode(message: ConfirmAlertRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.scope !== undefined) {
      AlertScope.encode(message.scope, writer.uint32(10).fork()).join()
    }
    if (message.registrationId !== '') {
      writer.uint32(18).string(message.registrationId)
    }
    if (message.triggerId !== '') {
      writer.uint32(26).string(message.triggerId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfirmAlertRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseConfirmAlertRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.scope = AlertScope.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.registrationId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.triggerId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ConfirmAlertRequest {
    return {
      scope: isSet(object.scope) ? AlertScope.fromJSON(object.scope) : undefined,
      registrationId: isSet(object.registrationId)
        ? globalThis.String(object.registrationId)
        : isSet(object.registration_id)
          ? globalThis.String(object.registration_id)
          : '',
      triggerId: isSet(object.triggerId)
        ? globalThis.String(object.triggerId)
        : isSet(object.trigger_id)
          ? globalThis.String(object.trigger_id)
          : '',
    }
  },

  toJSON(message: ConfirmAlertRequest): unknown {
    const obj: any = {}
    if (message.scope !== undefined) {
      obj.scope = AlertScope.toJSON(message.scope)
    }
    if (message.registrationId !== '') {
      obj.registrationId = message.registrationId
    }
    if (message.triggerId !== '') {
      obj.triggerId = message.triggerId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ConfirmAlertRequest>, I>>(base?: I): ConfirmAlertRequest {
    return ConfirmAlertRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ConfirmAlertRequest>, I>>(
    object: I
  ): ConfirmAlertRequest {
    const message = createBaseConfirmAlertRequest()
    message.scope =
      object.scope !== undefined && object.scope !== null
        ? AlertScope.fromPartial(object.scope)
        : undefined
    message.registrationId = object.registrationId ?? ''
    message.triggerId = object.triggerId ?? ''
    return message
  },
}

function createBaseConfirmAlertResponse(): ConfirmAlertResponse {
  return { triggerId: '', registrationId: '', status: 0, fireEvent: undefined, error: undefined }
}

export const ConfirmAlertResponse: MessageFns<ConfirmAlertResponse> = {
  encode(message: ConfirmAlertResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.triggerId !== '') {
      writer.uint32(10).string(message.triggerId)
    }
    if (message.registrationId !== '') {
      writer.uint32(18).string(message.registrationId)
    }
    if (message.status !== 0) {
      writer.uint32(24).int32(message.status)
    }
    if (message.fireEvent !== undefined) {
      AlertFireEvent.encode(message.fireEvent, writer.uint32(34).fork()).join()
    }
    if (message.error !== undefined) {
      writer.uint32(42).string(message.error)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfirmAlertResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseConfirmAlertResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.triggerId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.registrationId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.status = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.fireEvent = AlertFireEvent.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.error = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ConfirmAlertResponse {
    return {
      triggerId: isSet(object.triggerId)
        ? globalThis.String(object.triggerId)
        : isSet(object.trigger_id)
          ? globalThis.String(object.trigger_id)
          : '',
      registrationId: isSet(object.registrationId)
        ? globalThis.String(object.registrationId)
        : isSet(object.registration_id)
          ? globalThis.String(object.registration_id)
          : '',
      status: isSet(object.status) ? confirmAlertStatusFromJSON(object.status) : 0,
      fireEvent: isSet(object.fireEvent)
        ? AlertFireEvent.fromJSON(object.fireEvent)
        : isSet(object.fire_event)
          ? AlertFireEvent.fromJSON(object.fire_event)
          : undefined,
      error: isSet(object.error) ? globalThis.String(object.error) : undefined,
    }
  },

  toJSON(message: ConfirmAlertResponse): unknown {
    const obj: any = {}
    if (message.triggerId !== '') {
      obj.triggerId = message.triggerId
    }
    if (message.registrationId !== '') {
      obj.registrationId = message.registrationId
    }
    if (message.status !== 0) {
      obj.status = confirmAlertStatusToJSON(message.status)
    }
    if (message.fireEvent !== undefined) {
      obj.fireEvent = AlertFireEvent.toJSON(message.fireEvent)
    }
    if (message.error !== undefined) {
      obj.error = message.error
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ConfirmAlertResponse>, I>>(base?: I): ConfirmAlertResponse {
    return ConfirmAlertResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ConfirmAlertResponse>, I>>(
    object: I
  ): ConfirmAlertResponse {
    const message = createBaseConfirmAlertResponse()
    message.triggerId = object.triggerId ?? ''
    message.registrationId = object.registrationId ?? ''
    message.status = object.status ?? 0
    message.fireEvent =
      object.fireEvent !== undefined && object.fireEvent !== null
        ? AlertFireEvent.fromPartial(object.fireEvent)
        : undefined
    message.error = object.error ?? undefined
    return message
  },
}

function createBaseAlertFireEvent(): AlertFireEvent {
  return {
    triggerId: '',
    registrationId: '',
    scope: undefined,
    trigger: undefined,
    firedAtMs: '0',
    reason: 0,
    resolvedDescriptor: undefined,
  }
}

export const AlertFireEvent: MessageFns<AlertFireEvent> = {
  encode(message: AlertFireEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.triggerId !== '') {
      writer.uint32(10).string(message.triggerId)
    }
    if (message.registrationId !== '') {
      writer.uint32(18).string(message.registrationId)
    }
    if (message.scope !== undefined) {
      AlertScope.encode(message.scope, writer.uint32(26).fork()).join()
    }
    if (message.trigger !== undefined) {
      Trigger.encode(message.trigger, writer.uint32(34).fork()).join()
    }
    if (message.firedAtMs !== '0') {
      writer.uint32(40).int64(message.firedAtMs)
    }
    if (message.reason !== 0) {
      writer.uint32(48).int32(message.reason)
    }
    if (message.resolvedDescriptor !== undefined) {
      ResolvedAlertDescriptor.encode(message.resolvedDescriptor, writer.uint32(58).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AlertFireEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAlertFireEvent()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.triggerId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.registrationId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.scope = AlertScope.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.trigger = Trigger.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.firedAtMs = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.reason = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.resolvedDescriptor = ResolvedAlertDescriptor.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AlertFireEvent {
    return {
      triggerId: isSet(object.triggerId)
        ? globalThis.String(object.triggerId)
        : isSet(object.trigger_id)
          ? globalThis.String(object.trigger_id)
          : '',
      registrationId: isSet(object.registrationId)
        ? globalThis.String(object.registrationId)
        : isSet(object.registration_id)
          ? globalThis.String(object.registration_id)
          : '',
      scope: isSet(object.scope) ? AlertScope.fromJSON(object.scope) : undefined,
      trigger: isSet(object.trigger) ? Trigger.fromJSON(object.trigger) : undefined,
      firedAtMs: isSet(object.firedAtMs)
        ? globalThis.String(object.firedAtMs)
        : isSet(object.fired_at_ms)
          ? globalThis.String(object.fired_at_ms)
          : '0',
      reason: isSet(object.reason) ? alertFireReasonFromJSON(object.reason) : 0,
      resolvedDescriptor: isSet(object.resolvedDescriptor)
        ? ResolvedAlertDescriptor.fromJSON(object.resolvedDescriptor)
        : isSet(object.resolved_descriptor)
          ? ResolvedAlertDescriptor.fromJSON(object.resolved_descriptor)
          : undefined,
    }
  },

  toJSON(message: AlertFireEvent): unknown {
    const obj: any = {}
    if (message.triggerId !== '') {
      obj.triggerId = message.triggerId
    }
    if (message.registrationId !== '') {
      obj.registrationId = message.registrationId
    }
    if (message.scope !== undefined) {
      obj.scope = AlertScope.toJSON(message.scope)
    }
    if (message.trigger !== undefined) {
      obj.trigger = Trigger.toJSON(message.trigger)
    }
    if (message.firedAtMs !== '0') {
      obj.firedAtMs = message.firedAtMs
    }
    if (message.reason !== 0) {
      obj.reason = alertFireReasonToJSON(message.reason)
    }
    if (message.resolvedDescriptor !== undefined) {
      obj.resolvedDescriptor = ResolvedAlertDescriptor.toJSON(message.resolvedDescriptor)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AlertFireEvent>, I>>(base?: I): AlertFireEvent {
    return AlertFireEvent.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AlertFireEvent>, I>>(object: I): AlertFireEvent {
    const message = createBaseAlertFireEvent()
    message.triggerId = object.triggerId ?? ''
    message.registrationId = object.registrationId ?? ''
    message.scope =
      object.scope !== undefined && object.scope !== null
        ? AlertScope.fromPartial(object.scope)
        : undefined
    message.trigger =
      object.trigger !== undefined && object.trigger !== null
        ? Trigger.fromPartial(object.trigger)
        : undefined
    message.firedAtMs = object.firedAtMs ?? '0'
    message.reason = object.reason ?? 0
    message.resolvedDescriptor =
      object.resolvedDescriptor !== undefined && object.resolvedDescriptor !== null
        ? ResolvedAlertDescriptor.fromPartial(object.resolvedDescriptor)
        : undefined
    return message
  },
}

function createBaseTriggerValue(): TriggerValue {
  return { decimalValue: '', textValue: '', unit: '', sourceTsMs: '0', observedAtMs: '0' }
}

export const TriggerValue: MessageFns<TriggerValue> = {
  encode(message: TriggerValue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.decimalValue !== '') {
      writer.uint32(10).string(message.decimalValue)
    }
    if (message.textValue !== '') {
      writer.uint32(18).string(message.textValue)
    }
    if (message.unit !== '') {
      writer.uint32(26).string(message.unit)
    }
    if (message.sourceTsMs !== '0') {
      writer.uint32(32).int64(message.sourceTsMs)
    }
    if (message.observedAtMs !== '0') {
      writer.uint32(40).int64(message.observedAtMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TriggerValue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTriggerValue()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.decimalValue = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.textValue = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.unit = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.sourceTsMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.observedAtMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TriggerValue {
    return {
      decimalValue: isSet(object.decimalValue)
        ? globalThis.String(object.decimalValue)
        : isSet(object.decimal_value)
          ? globalThis.String(object.decimal_value)
          : '',
      textValue: isSet(object.textValue)
        ? globalThis.String(object.textValue)
        : isSet(object.text_value)
          ? globalThis.String(object.text_value)
          : '',
      unit: isSet(object.unit) ? globalThis.String(object.unit) : '',
      sourceTsMs: isSet(object.sourceTsMs)
        ? globalThis.String(object.sourceTsMs)
        : isSet(object.source_ts_ms)
          ? globalThis.String(object.source_ts_ms)
          : '0',
      observedAtMs: isSet(object.observedAtMs)
        ? globalThis.String(object.observedAtMs)
        : isSet(object.observed_at_ms)
          ? globalThis.String(object.observed_at_ms)
          : '0',
    }
  },

  toJSON(message: TriggerValue): unknown {
    const obj: any = {}
    if (message.decimalValue !== '') {
      obj.decimalValue = message.decimalValue
    }
    if (message.textValue !== '') {
      obj.textValue = message.textValue
    }
    if (message.unit !== '') {
      obj.unit = message.unit
    }
    if (message.sourceTsMs !== '0') {
      obj.sourceTsMs = message.sourceTsMs
    }
    if (message.observedAtMs !== '0') {
      obj.observedAtMs = message.observedAtMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TriggerValue>, I>>(base?: I): TriggerValue {
    return TriggerValue.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TriggerValue>, I>>(object: I): TriggerValue {
    const message = createBaseTriggerValue()
    message.decimalValue = object.decimalValue ?? ''
    message.textValue = object.textValue ?? ''
    message.unit = object.unit ?? ''
    message.sourceTsMs = object.sourceTsMs ?? '0'
    message.observedAtMs = object.observedAtMs ?? '0'
    return message
  },
}

function createBaseTriggerConditionNodeSnapshot(): TriggerConditionNodeSnapshot {
  return {
    path: '',
    kind: 0,
    state: 0,
    freshness: 0,
    operator: 0,
    currentValue: undefined,
    targetValue: undefined,
    latched: false,
    lastTransitionMs: '0',
    staleAfterMs: '0',
    label: '',
    children: [],
    detail: undefined,
  }
}

export const TriggerConditionNodeSnapshot: MessageFns<TriggerConditionNodeSnapshot> = {
  encode(
    message: TriggerConditionNodeSnapshot,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.path !== '') {
      writer.uint32(10).string(message.path)
    }
    if (message.kind !== 0) {
      writer.uint32(16).int32(message.kind)
    }
    if (message.state !== 0) {
      writer.uint32(24).int32(message.state)
    }
    if (message.freshness !== 0) {
      writer.uint32(32).int32(message.freshness)
    }
    if (message.operator !== 0) {
      writer.uint32(40).int32(message.operator)
    }
    if (message.currentValue !== undefined) {
      TriggerValue.encode(message.currentValue, writer.uint32(50).fork()).join()
    }
    if (message.targetValue !== undefined) {
      TriggerValue.encode(message.targetValue, writer.uint32(58).fork()).join()
    }
    if (message.latched !== false) {
      writer.uint32(64).bool(message.latched)
    }
    if (message.lastTransitionMs !== '0') {
      writer.uint32(72).int64(message.lastTransitionMs)
    }
    if (message.staleAfterMs !== '0') {
      writer.uint32(80).int64(message.staleAfterMs)
    }
    if (message.label !== '') {
      writer.uint32(90).string(message.label)
    }
    for (const v of message.children) {
      TriggerConditionNodeSnapshot.encode(v!, writer.uint32(98).fork()).join()
    }
    if (message.detail !== undefined) {
      writer.uint32(106).string(message.detail)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TriggerConditionNodeSnapshot {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTriggerConditionNodeSnapshot()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.path = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.kind = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.state = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.freshness = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.operator = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.currentValue = TriggerValue.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.targetValue = TriggerValue.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.latched = reader.bool()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.lastTransitionMs = reader.int64().toString()
          continue
        }
        case 10: {
          if (tag !== 80) {
            break
          }

          message.staleAfterMs = reader.int64().toString()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.label = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.children.push(TriggerConditionNodeSnapshot.decode(reader, reader.uint32()))
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.detail = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TriggerConditionNodeSnapshot {
    return {
      path: isSet(object.path) ? globalThis.String(object.path) : '',
      kind: isSet(object.kind) ? triggerConditionNodeKindFromJSON(object.kind) : 0,
      state: isSet(object.state) ? triggerConditionEvaluationStateFromJSON(object.state) : 0,
      freshness: isSet(object.freshness) ? triggerConditionFreshnessFromJSON(object.freshness) : 0,
      operator: isSet(object.operator) ? comparisonOperatorFromJSON(object.operator) : 0,
      currentValue: isSet(object.currentValue)
        ? TriggerValue.fromJSON(object.currentValue)
        : isSet(object.current_value)
          ? TriggerValue.fromJSON(object.current_value)
          : undefined,
      targetValue: isSet(object.targetValue)
        ? TriggerValue.fromJSON(object.targetValue)
        : isSet(object.target_value)
          ? TriggerValue.fromJSON(object.target_value)
          : undefined,
      latched: isSet(object.latched) ? globalThis.Boolean(object.latched) : false,
      lastTransitionMs: isSet(object.lastTransitionMs)
        ? globalThis.String(object.lastTransitionMs)
        : isSet(object.last_transition_ms)
          ? globalThis.String(object.last_transition_ms)
          : '0',
      staleAfterMs: isSet(object.staleAfterMs)
        ? globalThis.String(object.staleAfterMs)
        : isSet(object.stale_after_ms)
          ? globalThis.String(object.stale_after_ms)
          : '0',
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      children: globalThis.Array.isArray(object?.children)
        ? object.children.map((e: any) => TriggerConditionNodeSnapshot.fromJSON(e))
        : [],
      detail: isSet(object.detail) ? globalThis.String(object.detail) : undefined,
    }
  },

  toJSON(message: TriggerConditionNodeSnapshot): unknown {
    const obj: any = {}
    if (message.path !== '') {
      obj.path = message.path
    }
    if (message.kind !== 0) {
      obj.kind = triggerConditionNodeKindToJSON(message.kind)
    }
    if (message.state !== 0) {
      obj.state = triggerConditionEvaluationStateToJSON(message.state)
    }
    if (message.freshness !== 0) {
      obj.freshness = triggerConditionFreshnessToJSON(message.freshness)
    }
    if (message.operator !== 0) {
      obj.operator = comparisonOperatorToJSON(message.operator)
    }
    if (message.currentValue !== undefined) {
      obj.currentValue = TriggerValue.toJSON(message.currentValue)
    }
    if (message.targetValue !== undefined) {
      obj.targetValue = TriggerValue.toJSON(message.targetValue)
    }
    if (message.latched !== false) {
      obj.latched = message.latched
    }
    if (message.lastTransitionMs !== '0') {
      obj.lastTransitionMs = message.lastTransitionMs
    }
    if (message.staleAfterMs !== '0') {
      obj.staleAfterMs = message.staleAfterMs
    }
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.children?.length) {
      obj.children = message.children.map((e) => TriggerConditionNodeSnapshot.toJSON(e))
    }
    if (message.detail !== undefined) {
      obj.detail = message.detail
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TriggerConditionNodeSnapshot>, I>>(
    base?: I
  ): TriggerConditionNodeSnapshot {
    return TriggerConditionNodeSnapshot.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TriggerConditionNodeSnapshot>, I>>(
    object: I
  ): TriggerConditionNodeSnapshot {
    const message = createBaseTriggerConditionNodeSnapshot()
    message.path = object.path ?? ''
    message.kind = object.kind ?? 0
    message.state = object.state ?? 0
    message.freshness = object.freshness ?? 0
    message.operator = object.operator ?? 0
    message.currentValue =
      object.currentValue !== undefined && object.currentValue !== null
        ? TriggerValue.fromPartial(object.currentValue)
        : undefined
    message.targetValue =
      object.targetValue !== undefined && object.targetValue !== null
        ? TriggerValue.fromPartial(object.targetValue)
        : undefined
    message.latched = object.latched ?? false
    message.lastTransitionMs = object.lastTransitionMs ?? '0'
    message.staleAfterMs = object.staleAfterMs ?? '0'
    message.label = object.label ?? ''
    message.children =
      object.children?.map((e) => TriggerConditionNodeSnapshot.fromPartial(e)) || []
    message.detail = object.detail ?? undefined
    return message
  },
}

function createBaseTriggerEvaluationSnapshot(): TriggerEvaluationSnapshot {
  return {
    accountId: '',
    registrationId: '',
    triggerId: '',
    registrationStatus: 0,
    terminalReason: 0,
    updatedAtMs: '0',
    root: undefined,
    resolvedDescriptor: undefined,
    error: undefined,
  }
}

export const TriggerEvaluationSnapshot: MessageFns<TriggerEvaluationSnapshot> = {
  encode(
    message: TriggerEvaluationSnapshot,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.registrationId !== '') {
      writer.uint32(18).string(message.registrationId)
    }
    if (message.triggerId !== '') {
      writer.uint32(26).string(message.triggerId)
    }
    if (message.registrationStatus !== 0) {
      writer.uint32(32).int32(message.registrationStatus)
    }
    if (message.terminalReason !== 0) {
      writer.uint32(40).int32(message.terminalReason)
    }
    if (message.updatedAtMs !== '0') {
      writer.uint32(48).int64(message.updatedAtMs)
    }
    if (message.root !== undefined) {
      TriggerConditionNodeSnapshot.encode(message.root, writer.uint32(58).fork()).join()
    }
    if (message.resolvedDescriptor !== undefined) {
      ResolvedAlertDescriptor.encode(message.resolvedDescriptor, writer.uint32(66).fork()).join()
    }
    if (message.error !== undefined) {
      writer.uint32(74).string(message.error)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TriggerEvaluationSnapshot {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTriggerEvaluationSnapshot()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.registrationId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.triggerId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.registrationStatus = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.terminalReason = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.updatedAtMs = reader.int64().toString()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.root = TriggerConditionNodeSnapshot.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.resolvedDescriptor = ResolvedAlertDescriptor.decode(reader, reader.uint32())
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.error = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TriggerEvaluationSnapshot {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      registrationId: isSet(object.registrationId)
        ? globalThis.String(object.registrationId)
        : isSet(object.registration_id)
          ? globalThis.String(object.registration_id)
          : '',
      triggerId: isSet(object.triggerId)
        ? globalThis.String(object.triggerId)
        : isSet(object.trigger_id)
          ? globalThis.String(object.trigger_id)
          : '',
      registrationStatus: isSet(object.registrationStatus)
        ? alertRegistrationStatusFromJSON(object.registrationStatus)
        : isSet(object.registration_status)
          ? alertRegistrationStatusFromJSON(object.registration_status)
          : 0,
      terminalReason: isSet(object.terminalReason)
        ? alertFireReasonFromJSON(object.terminalReason)
        : isSet(object.terminal_reason)
          ? alertFireReasonFromJSON(object.terminal_reason)
          : 0,
      updatedAtMs: isSet(object.updatedAtMs)
        ? globalThis.String(object.updatedAtMs)
        : isSet(object.updated_at_ms)
          ? globalThis.String(object.updated_at_ms)
          : '0',
      root: isSet(object.root) ? TriggerConditionNodeSnapshot.fromJSON(object.root) : undefined,
      resolvedDescriptor: isSet(object.resolvedDescriptor)
        ? ResolvedAlertDescriptor.fromJSON(object.resolvedDescriptor)
        : isSet(object.resolved_descriptor)
          ? ResolvedAlertDescriptor.fromJSON(object.resolved_descriptor)
          : undefined,
      error: isSet(object.error) ? globalThis.String(object.error) : undefined,
    }
  },

  toJSON(message: TriggerEvaluationSnapshot): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.registrationId !== '') {
      obj.registrationId = message.registrationId
    }
    if (message.triggerId !== '') {
      obj.triggerId = message.triggerId
    }
    if (message.registrationStatus !== 0) {
      obj.registrationStatus = alertRegistrationStatusToJSON(message.registrationStatus)
    }
    if (message.terminalReason !== 0) {
      obj.terminalReason = alertFireReasonToJSON(message.terminalReason)
    }
    if (message.updatedAtMs !== '0') {
      obj.updatedAtMs = message.updatedAtMs
    }
    if (message.root !== undefined) {
      obj.root = TriggerConditionNodeSnapshot.toJSON(message.root)
    }
    if (message.resolvedDescriptor !== undefined) {
      obj.resolvedDescriptor = ResolvedAlertDescriptor.toJSON(message.resolvedDescriptor)
    }
    if (message.error !== undefined) {
      obj.error = message.error
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TriggerEvaluationSnapshot>, I>>(
    base?: I
  ): TriggerEvaluationSnapshot {
    return TriggerEvaluationSnapshot.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TriggerEvaluationSnapshot>, I>>(
    object: I
  ): TriggerEvaluationSnapshot {
    const message = createBaseTriggerEvaluationSnapshot()
    message.accountId = object.accountId ?? ''
    message.registrationId = object.registrationId ?? ''
    message.triggerId = object.triggerId ?? ''
    message.registrationStatus = object.registrationStatus ?? 0
    message.terminalReason = object.terminalReason ?? 0
    message.updatedAtMs = object.updatedAtMs ?? '0'
    message.root =
      object.root !== undefined && object.root !== null
        ? TriggerConditionNodeSnapshot.fromPartial(object.root)
        : undefined
    message.resolvedDescriptor =
      object.resolvedDescriptor !== undefined && object.resolvedDescriptor !== null
        ? ResolvedAlertDescriptor.fromPartial(object.resolvedDescriptor)
        : undefined
    message.error = object.error ?? undefined
    return message
  },
}

function createBaseResolvedAlertDescriptor(): ResolvedAlertDescriptor {
  return {
    price: undefined,
    schedule: undefined,
    actionEvent: undefined,
    andCondition: undefined,
    orCondition: undefined,
    technicalIndicator: undefined,
    returns: undefined,
    candle: undefined,
    portfolioMetric: undefined,
    positionMetric: undefined,
    optionIv: undefined,
    dbNews: undefined,
    riskMetric: undefined,
    polymarket: undefined,
  }
}

export const ResolvedAlertDescriptor: MessageFns<ResolvedAlertDescriptor> = {
  encode(
    message: ResolvedAlertDescriptor,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.price !== undefined) {
      ResolvedPriceDescriptor.encode(message.price, writer.uint32(10).fork()).join()
    }
    if (message.schedule !== undefined) {
      ResolvedScheduleDescriptor.encode(message.schedule, writer.uint32(18).fork()).join()
    }
    if (message.actionEvent !== undefined) {
      ResolvedActionEventDescriptor.encode(message.actionEvent, writer.uint32(26).fork()).join()
    }
    if (message.andCondition !== undefined) {
      ResolvedCompositeDescriptor.encode(message.andCondition, writer.uint32(34).fork()).join()
    }
    if (message.orCondition !== undefined) {
      ResolvedCompositeDescriptor.encode(message.orCondition, writer.uint32(42).fork()).join()
    }
    if (message.technicalIndicator !== undefined) {
      ResolvedTechnicalIndicatorDescriptor.encode(
        message.technicalIndicator,
        writer.uint32(50).fork()
      ).join()
    }
    if (message.returns !== undefined) {
      ResolvedReturnDescriptor.encode(message.returns, writer.uint32(58).fork()).join()
    }
    if (message.candle !== undefined) {
      ResolvedCandleDescriptor.encode(message.candle, writer.uint32(66).fork()).join()
    }
    if (message.portfolioMetric !== undefined) {
      ResolvedPortfolioMetricDescriptor.encode(
        message.portfolioMetric,
        writer.uint32(74).fork()
      ).join()
    }
    if (message.positionMetric !== undefined) {
      ResolvedPositionMetricDescriptor.encode(
        message.positionMetric,
        writer.uint32(82).fork()
      ).join()
    }
    if (message.optionIv !== undefined) {
      ResolvedOptionIvDescriptor.encode(message.optionIv, writer.uint32(90).fork()).join()
    }
    if (message.dbNews !== undefined) {
      ResolvedDbNewsDescriptor.encode(message.dbNews, writer.uint32(98).fork()).join()
    }
    if (message.riskMetric !== undefined) {
      ResolvedRiskMetricDescriptor.encode(message.riskMetric, writer.uint32(106).fork()).join()
    }
    if (message.polymarket !== undefined) {
      ResolvedPolymarketDescriptor.encode(message.polymarket, writer.uint32(114).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResolvedAlertDescriptor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResolvedAlertDescriptor()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.price = ResolvedPriceDescriptor.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.schedule = ResolvedScheduleDescriptor.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.actionEvent = ResolvedActionEventDescriptor.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.andCondition = ResolvedCompositeDescriptor.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.orCondition = ResolvedCompositeDescriptor.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.technicalIndicator = ResolvedTechnicalIndicatorDescriptor.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.returns = ResolvedReturnDescriptor.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.candle = ResolvedCandleDescriptor.decode(reader, reader.uint32())
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.portfolioMetric = ResolvedPortfolioMetricDescriptor.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.positionMetric = ResolvedPositionMetricDescriptor.decode(reader, reader.uint32())
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.optionIv = ResolvedOptionIvDescriptor.decode(reader, reader.uint32())
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.dbNews = ResolvedDbNewsDescriptor.decode(reader, reader.uint32())
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.riskMetric = ResolvedRiskMetricDescriptor.decode(reader, reader.uint32())
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.polymarket = ResolvedPolymarketDescriptor.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResolvedAlertDescriptor {
    return {
      price: isSet(object.price) ? ResolvedPriceDescriptor.fromJSON(object.price) : undefined,
      schedule: isSet(object.schedule)
        ? ResolvedScheduleDescriptor.fromJSON(object.schedule)
        : undefined,
      actionEvent: isSet(object.actionEvent)
        ? ResolvedActionEventDescriptor.fromJSON(object.actionEvent)
        : isSet(object.action_event)
          ? ResolvedActionEventDescriptor.fromJSON(object.action_event)
          : undefined,
      andCondition: isSet(object.andCondition)
        ? ResolvedCompositeDescriptor.fromJSON(object.andCondition)
        : isSet(object.and_condition)
          ? ResolvedCompositeDescriptor.fromJSON(object.and_condition)
          : undefined,
      orCondition: isSet(object.orCondition)
        ? ResolvedCompositeDescriptor.fromJSON(object.orCondition)
        : isSet(object.or_condition)
          ? ResolvedCompositeDescriptor.fromJSON(object.or_condition)
          : undefined,
      technicalIndicator: isSet(object.technicalIndicator)
        ? ResolvedTechnicalIndicatorDescriptor.fromJSON(object.technicalIndicator)
        : isSet(object.technical_indicator)
          ? ResolvedTechnicalIndicatorDescriptor.fromJSON(object.technical_indicator)
          : undefined,
      returns: isSet(object.returns)
        ? ResolvedReturnDescriptor.fromJSON(object.returns)
        : undefined,
      candle: isSet(object.candle) ? ResolvedCandleDescriptor.fromJSON(object.candle) : undefined,
      portfolioMetric: isSet(object.portfolioMetric)
        ? ResolvedPortfolioMetricDescriptor.fromJSON(object.portfolioMetric)
        : isSet(object.portfolio_metric)
          ? ResolvedPortfolioMetricDescriptor.fromJSON(object.portfolio_metric)
          : undefined,
      positionMetric: isSet(object.positionMetric)
        ? ResolvedPositionMetricDescriptor.fromJSON(object.positionMetric)
        : isSet(object.position_metric)
          ? ResolvedPositionMetricDescriptor.fromJSON(object.position_metric)
          : undefined,
      optionIv: isSet(object.optionIv)
        ? ResolvedOptionIvDescriptor.fromJSON(object.optionIv)
        : isSet(object.option_iv)
          ? ResolvedOptionIvDescriptor.fromJSON(object.option_iv)
          : undefined,
      dbNews: isSet(object.dbNews)
        ? ResolvedDbNewsDescriptor.fromJSON(object.dbNews)
        : isSet(object.db_news)
          ? ResolvedDbNewsDescriptor.fromJSON(object.db_news)
          : undefined,
      riskMetric: isSet(object.riskMetric)
        ? ResolvedRiskMetricDescriptor.fromJSON(object.riskMetric)
        : isSet(object.risk_metric)
          ? ResolvedRiskMetricDescriptor.fromJSON(object.risk_metric)
          : undefined,
      polymarket: isSet(object.polymarket)
        ? ResolvedPolymarketDescriptor.fromJSON(object.polymarket)
        : undefined,
    }
  },

  toJSON(message: ResolvedAlertDescriptor): unknown {
    const obj: any = {}
    if (message.price !== undefined) {
      obj.price = ResolvedPriceDescriptor.toJSON(message.price)
    }
    if (message.schedule !== undefined) {
      obj.schedule = ResolvedScheduleDescriptor.toJSON(message.schedule)
    }
    if (message.actionEvent !== undefined) {
      obj.actionEvent = ResolvedActionEventDescriptor.toJSON(message.actionEvent)
    }
    if (message.andCondition !== undefined) {
      obj.andCondition = ResolvedCompositeDescriptor.toJSON(message.andCondition)
    }
    if (message.orCondition !== undefined) {
      obj.orCondition = ResolvedCompositeDescriptor.toJSON(message.orCondition)
    }
    if (message.technicalIndicator !== undefined) {
      obj.technicalIndicator = ResolvedTechnicalIndicatorDescriptor.toJSON(
        message.technicalIndicator
      )
    }
    if (message.returns !== undefined) {
      obj.returns = ResolvedReturnDescriptor.toJSON(message.returns)
    }
    if (message.candle !== undefined) {
      obj.candle = ResolvedCandleDescriptor.toJSON(message.candle)
    }
    if (message.portfolioMetric !== undefined) {
      obj.portfolioMetric = ResolvedPortfolioMetricDescriptor.toJSON(message.portfolioMetric)
    }
    if (message.positionMetric !== undefined) {
      obj.positionMetric = ResolvedPositionMetricDescriptor.toJSON(message.positionMetric)
    }
    if (message.optionIv !== undefined) {
      obj.optionIv = ResolvedOptionIvDescriptor.toJSON(message.optionIv)
    }
    if (message.dbNews !== undefined) {
      obj.dbNews = ResolvedDbNewsDescriptor.toJSON(message.dbNews)
    }
    if (message.riskMetric !== undefined) {
      obj.riskMetric = ResolvedRiskMetricDescriptor.toJSON(message.riskMetric)
    }
    if (message.polymarket !== undefined) {
      obj.polymarket = ResolvedPolymarketDescriptor.toJSON(message.polymarket)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResolvedAlertDescriptor>, I>>(
    base?: I
  ): ResolvedAlertDescriptor {
    return ResolvedAlertDescriptor.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResolvedAlertDescriptor>, I>>(
    object: I
  ): ResolvedAlertDescriptor {
    const message = createBaseResolvedAlertDescriptor()
    message.price =
      object.price !== undefined && object.price !== null
        ? ResolvedPriceDescriptor.fromPartial(object.price)
        : undefined
    message.schedule =
      object.schedule !== undefined && object.schedule !== null
        ? ResolvedScheduleDescriptor.fromPartial(object.schedule)
        : undefined
    message.actionEvent =
      object.actionEvent !== undefined && object.actionEvent !== null
        ? ResolvedActionEventDescriptor.fromPartial(object.actionEvent)
        : undefined
    message.andCondition =
      object.andCondition !== undefined && object.andCondition !== null
        ? ResolvedCompositeDescriptor.fromPartial(object.andCondition)
        : undefined
    message.orCondition =
      object.orCondition !== undefined && object.orCondition !== null
        ? ResolvedCompositeDescriptor.fromPartial(object.orCondition)
        : undefined
    message.technicalIndicator =
      object.technicalIndicator !== undefined && object.technicalIndicator !== null
        ? ResolvedTechnicalIndicatorDescriptor.fromPartial(object.technicalIndicator)
        : undefined
    message.returns =
      object.returns !== undefined && object.returns !== null
        ? ResolvedReturnDescriptor.fromPartial(object.returns)
        : undefined
    message.candle =
      object.candle !== undefined && object.candle !== null
        ? ResolvedCandleDescriptor.fromPartial(object.candle)
        : undefined
    message.portfolioMetric =
      object.portfolioMetric !== undefined && object.portfolioMetric !== null
        ? ResolvedPortfolioMetricDescriptor.fromPartial(object.portfolioMetric)
        : undefined
    message.positionMetric =
      object.positionMetric !== undefined && object.positionMetric !== null
        ? ResolvedPositionMetricDescriptor.fromPartial(object.positionMetric)
        : undefined
    message.optionIv =
      object.optionIv !== undefined && object.optionIv !== null
        ? ResolvedOptionIvDescriptor.fromPartial(object.optionIv)
        : undefined
    message.dbNews =
      object.dbNews !== undefined && object.dbNews !== null
        ? ResolvedDbNewsDescriptor.fromPartial(object.dbNews)
        : undefined
    message.riskMetric =
      object.riskMetric !== undefined && object.riskMetric !== null
        ? ResolvedRiskMetricDescriptor.fromPartial(object.riskMetric)
        : undefined
    message.polymarket =
      object.polymarket !== undefined && object.polymarket !== null
        ? ResolvedPolymarketDescriptor.fromPartial(object.polymarket)
        : undefined
    return message
  },
}

function createBaseResolvedPriceDescriptor(): ResolvedPriceDescriptor {
  return { tradeVenue: 0, exchange: 0, symbol: '', source: 0, operator: 0, normalizedThreshold: '' }
}

export const ResolvedPriceDescriptor: MessageFns<ResolvedPriceDescriptor> = {
  encode(
    message: ResolvedPriceDescriptor,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.tradeVenue !== 0) {
      writer.uint32(8).int32(message.tradeVenue)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(26).string(message.symbol)
    }
    if (message.source !== 0) {
      writer.uint32(32).int32(message.source)
    }
    if (message.operator !== 0) {
      writer.uint32(40).int32(message.operator)
    }
    if (message.normalizedThreshold !== '') {
      writer.uint32(50).string(message.normalizedThreshold)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResolvedPriceDescriptor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResolvedPriceDescriptor()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.source = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.operator = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.normalizedThreshold = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResolvedPriceDescriptor {
    return {
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      source: isSet(object.source) ? priceReferenceFromJSON(object.source) : 0,
      operator: isSet(object.operator) ? comparisonOperatorFromJSON(object.operator) : 0,
      normalizedThreshold: isSet(object.normalizedThreshold)
        ? globalThis.String(object.normalizedThreshold)
        : isSet(object.normalized_threshold)
          ? globalThis.String(object.normalized_threshold)
          : '',
    }
  },

  toJSON(message: ResolvedPriceDescriptor): unknown {
    const obj: any = {}
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.source !== 0) {
      obj.source = priceReferenceToJSON(message.source)
    }
    if (message.operator !== 0) {
      obj.operator = comparisonOperatorToJSON(message.operator)
    }
    if (message.normalizedThreshold !== '') {
      obj.normalizedThreshold = message.normalizedThreshold
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResolvedPriceDescriptor>, I>>(
    base?: I
  ): ResolvedPriceDescriptor {
    return ResolvedPriceDescriptor.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResolvedPriceDescriptor>, I>>(
    object: I
  ): ResolvedPriceDescriptor {
    const message = createBaseResolvedPriceDescriptor()
    message.tradeVenue = object.tradeVenue ?? 0
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.source = object.source ?? 0
    message.operator = object.operator ?? 0
    message.normalizedThreshold = object.normalizedThreshold ?? ''
    return message
  },
}

function createBaseResolvedScheduleDescriptor(): ResolvedScheduleDescriptor {
  return { fireAtMs: '0' }
}

export const ResolvedScheduleDescriptor: MessageFns<ResolvedScheduleDescriptor> = {
  encode(
    message: ResolvedScheduleDescriptor,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.fireAtMs !== '0') {
      writer.uint32(8).int64(message.fireAtMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResolvedScheduleDescriptor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResolvedScheduleDescriptor()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.fireAtMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResolvedScheduleDescriptor {
    return {
      fireAtMs: isSet(object.fireAtMs)
        ? globalThis.String(object.fireAtMs)
        : isSet(object.fire_at_ms)
          ? globalThis.String(object.fire_at_ms)
          : '0',
    }
  },

  toJSON(message: ResolvedScheduleDescriptor): unknown {
    const obj: any = {}
    if (message.fireAtMs !== '0') {
      obj.fireAtMs = message.fireAtMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResolvedScheduleDescriptor>, I>>(
    base?: I
  ): ResolvedScheduleDescriptor {
    return ResolvedScheduleDescriptor.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResolvedScheduleDescriptor>, I>>(
    object: I
  ): ResolvedScheduleDescriptor {
    const message = createBaseResolvedScheduleDescriptor()
    message.fireAtMs = object.fireAtMs ?? '0'
    return message
  },
}

function createBaseResolvedActionEventDescriptor(): ResolvedActionEventDescriptor {
  return { accountId: '', eventType: 0, partialFillThresholdPercent: undefined, target: undefined }
}

export const ResolvedActionEventDescriptor: MessageFns<ResolvedActionEventDescriptor> = {
  encode(
    message: ResolvedActionEventDescriptor,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.eventType !== 0) {
      writer.uint32(16).int32(message.eventType)
    }
    if (message.partialFillThresholdPercent !== undefined) {
      writer.uint32(26).string(message.partialFillThresholdPercent)
    }
    if (message.target !== undefined) {
      ActionEventTarget.encode(message.target, writer.uint32(34).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResolvedActionEventDescriptor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResolvedActionEventDescriptor()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.eventType = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.partialFillThresholdPercent = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.target = ActionEventTarget.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResolvedActionEventDescriptor {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      eventType: isSet(object.eventType)
        ? actionEventTypeFromJSON(object.eventType)
        : isSet(object.event_type)
          ? actionEventTypeFromJSON(object.event_type)
          : 0,
      partialFillThresholdPercent: isSet(object.partialFillThresholdPercent)
        ? globalThis.String(object.partialFillThresholdPercent)
        : isSet(object.partial_fill_threshold_percent)
          ? globalThis.String(object.partial_fill_threshold_percent)
          : undefined,
      target: isSet(object.target) ? ActionEventTarget.fromJSON(object.target) : undefined,
    }
  },

  toJSON(message: ResolvedActionEventDescriptor): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.eventType !== 0) {
      obj.eventType = actionEventTypeToJSON(message.eventType)
    }
    if (message.partialFillThresholdPercent !== undefined) {
      obj.partialFillThresholdPercent = message.partialFillThresholdPercent
    }
    if (message.target !== undefined) {
      obj.target = ActionEventTarget.toJSON(message.target)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResolvedActionEventDescriptor>, I>>(
    base?: I
  ): ResolvedActionEventDescriptor {
    return ResolvedActionEventDescriptor.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResolvedActionEventDescriptor>, I>>(
    object: I
  ): ResolvedActionEventDescriptor {
    const message = createBaseResolvedActionEventDescriptor()
    message.accountId = object.accountId ?? ''
    message.eventType = object.eventType ?? 0
    message.partialFillThresholdPercent = object.partialFillThresholdPercent ?? undefined
    message.target =
      object.target !== undefined && object.target !== null
        ? ActionEventTarget.fromPartial(object.target)
        : undefined
    return message
  },
}

function createBaseResolvedCompositeDescriptor(): ResolvedCompositeDescriptor {
  return { children: [] }
}

export const ResolvedCompositeDescriptor: MessageFns<ResolvedCompositeDescriptor> = {
  encode(
    message: ResolvedCompositeDescriptor,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.children) {
      ResolvedAlertDescriptor.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResolvedCompositeDescriptor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResolvedCompositeDescriptor()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.children.push(ResolvedAlertDescriptor.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResolvedCompositeDescriptor {
    return {
      children: globalThis.Array.isArray(object?.children)
        ? object.children.map((e: any) => ResolvedAlertDescriptor.fromJSON(e))
        : [],
    }
  },

  toJSON(message: ResolvedCompositeDescriptor): unknown {
    const obj: any = {}
    if (message.children?.length) {
      obj.children = message.children.map((e) => ResolvedAlertDescriptor.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResolvedCompositeDescriptor>, I>>(
    base?: I
  ): ResolvedCompositeDescriptor {
    return ResolvedCompositeDescriptor.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResolvedCompositeDescriptor>, I>>(
    object: I
  ): ResolvedCompositeDescriptor {
    const message = createBaseResolvedCompositeDescriptor()
    message.children = object.children?.map((e) => ResolvedAlertDescriptor.fromPartial(e)) || []
    return message
  },
}

function createBaseResolvedTechnicalIndicatorDescriptor(): ResolvedTechnicalIndicatorDescriptor {
  return {
    left: undefined,
    operator: 0,
    normalizedThreshold: undefined,
    right: undefined,
    maxStalenessMs: undefined,
  }
}

export const ResolvedTechnicalIndicatorDescriptor: MessageFns<ResolvedTechnicalIndicatorDescriptor> =
  {
    encode(
      message: ResolvedTechnicalIndicatorDescriptor,
      writer: BinaryWriter = new BinaryWriter()
    ): BinaryWriter {
      if (message.left !== undefined) {
        ResolvedTechnicalIndicatorSpec.encode(message.left, writer.uint32(10).fork()).join()
      }
      if (message.operator !== 0) {
        writer.uint32(16).int32(message.operator)
      }
      if (message.normalizedThreshold !== undefined) {
        writer.uint32(26).string(message.normalizedThreshold)
      }
      if (message.right !== undefined) {
        ResolvedTechnicalIndicatorSpec.encode(message.right, writer.uint32(34).fork()).join()
      }
      if (message.maxStalenessMs !== undefined) {
        writer.uint32(40).int64(message.maxStalenessMs)
      }
      return writer
    },

    decode(
      input: BinaryReader | Uint8Array,
      length?: number
    ): ResolvedTechnicalIndicatorDescriptor {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
      const end = length === undefined ? reader.len : reader.pos + length
      const message = createBaseResolvedTechnicalIndicatorDescriptor()
      while (reader.pos < end) {
        const tag = reader.uint32()
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break
            }

            message.left = ResolvedTechnicalIndicatorSpec.decode(reader, reader.uint32())
            continue
          }
          case 2: {
            if (tag !== 16) {
              break
            }

            message.operator = reader.int32() as any
            continue
          }
          case 3: {
            if (tag !== 26) {
              break
            }

            message.normalizedThreshold = reader.string()
            continue
          }
          case 4: {
            if (tag !== 34) {
              break
            }

            message.right = ResolvedTechnicalIndicatorSpec.decode(reader, reader.uint32())
            continue
          }
          case 5: {
            if (tag !== 40) {
              break
            }

            message.maxStalenessMs = reader.int64().toString()
            continue
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break
        }
        reader.skip(tag & 7)
      }
      return message
    },

    fromJSON(object: any): ResolvedTechnicalIndicatorDescriptor {
      return {
        left: isSet(object.left) ? ResolvedTechnicalIndicatorSpec.fromJSON(object.left) : undefined,
        operator: isSet(object.operator) ? comparisonOperatorFromJSON(object.operator) : 0,
        normalizedThreshold: isSet(object.normalizedThreshold)
          ? globalThis.String(object.normalizedThreshold)
          : isSet(object.normalized_threshold)
            ? globalThis.String(object.normalized_threshold)
            : undefined,
        right: isSet(object.right)
          ? ResolvedTechnicalIndicatorSpec.fromJSON(object.right)
          : undefined,
        maxStalenessMs: isSet(object.maxStalenessMs)
          ? globalThis.String(object.maxStalenessMs)
          : isSet(object.max_staleness_ms)
            ? globalThis.String(object.max_staleness_ms)
            : undefined,
      }
    },

    toJSON(message: ResolvedTechnicalIndicatorDescriptor): unknown {
      const obj: any = {}
      if (message.left !== undefined) {
        obj.left = ResolvedTechnicalIndicatorSpec.toJSON(message.left)
      }
      if (message.operator !== 0) {
        obj.operator = comparisonOperatorToJSON(message.operator)
      }
      if (message.normalizedThreshold !== undefined) {
        obj.normalizedThreshold = message.normalizedThreshold
      }
      if (message.right !== undefined) {
        obj.right = ResolvedTechnicalIndicatorSpec.toJSON(message.right)
      }
      if (message.maxStalenessMs !== undefined) {
        obj.maxStalenessMs = message.maxStalenessMs
      }
      return obj
    },

    create<I extends Exact<DeepPartial<ResolvedTechnicalIndicatorDescriptor>, I>>(
      base?: I
    ): ResolvedTechnicalIndicatorDescriptor {
      return ResolvedTechnicalIndicatorDescriptor.fromPartial(base ?? ({} as any))
    },
    fromPartial<I extends Exact<DeepPartial<ResolvedTechnicalIndicatorDescriptor>, I>>(
      object: I
    ): ResolvedTechnicalIndicatorDescriptor {
      const message = createBaseResolvedTechnicalIndicatorDescriptor()
      message.left =
        object.left !== undefined && object.left !== null
          ? ResolvedTechnicalIndicatorSpec.fromPartial(object.left)
          : undefined
      message.operator = object.operator ?? 0
      message.normalizedThreshold = object.normalizedThreshold ?? undefined
      message.right =
        object.right !== undefined && object.right !== null
          ? ResolvedTechnicalIndicatorSpec.fromPartial(object.right)
          : undefined
      message.maxStalenessMs = object.maxStalenessMs ?? undefined
      return message
    },
  }

function createBaseResolvedTechnicalIndicatorSpec(): ResolvedTechnicalIndicatorSpec {
  return {
    indicatorType: 0,
    tradeVenue: 0,
    exchange: 0,
    symbol: '',
    source: 0,
    periodCount: 0,
    timeframeSeconds: 0,
  }
}

export const ResolvedTechnicalIndicatorSpec: MessageFns<ResolvedTechnicalIndicatorSpec> = {
  encode(
    message: ResolvedTechnicalIndicatorSpec,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.indicatorType !== 0) {
      writer.uint32(8).int32(message.indicatorType)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(16).int32(message.tradeVenue)
    }
    if (message.exchange !== 0) {
      writer.uint32(24).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(34).string(message.symbol)
    }
    if (message.source !== 0) {
      writer.uint32(40).int32(message.source)
    }
    if (message.periodCount !== 0) {
      writer.uint32(48).int32(message.periodCount)
    }
    if (message.timeframeSeconds !== 0) {
      writer.uint32(56).int32(message.timeframeSeconds)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResolvedTechnicalIndicatorSpec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResolvedTechnicalIndicatorSpec()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.indicatorType = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.source = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.periodCount = reader.int32()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.timeframeSeconds = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResolvedTechnicalIndicatorSpec {
    return {
      indicatorType: isSet(object.indicatorType)
        ? technicalIndicatorTypeFromJSON(object.indicatorType)
        : isSet(object.indicator_type)
          ? technicalIndicatorTypeFromJSON(object.indicator_type)
          : 0,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      source: isSet(object.source) ? priceReferenceFromJSON(object.source) : 0,
      periodCount: isSet(object.periodCount)
        ? globalThis.Number(object.periodCount)
        : isSet(object.period_count)
          ? globalThis.Number(object.period_count)
          : 0,
      timeframeSeconds: isSet(object.timeframeSeconds)
        ? chartTimeframeFromJSON(object.timeframeSeconds)
        : isSet(object.timeframe_seconds)
          ? chartTimeframeFromJSON(object.timeframe_seconds)
          : 0,
    }
  },

  toJSON(message: ResolvedTechnicalIndicatorSpec): unknown {
    const obj: any = {}
    if (message.indicatorType !== 0) {
      obj.indicatorType = technicalIndicatorTypeToJSON(message.indicatorType)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.source !== 0) {
      obj.source = priceReferenceToJSON(message.source)
    }
    if (message.periodCount !== 0) {
      obj.periodCount = Math.round(message.periodCount)
    }
    if (message.timeframeSeconds !== 0) {
      obj.timeframeSeconds = chartTimeframeToJSON(message.timeframeSeconds)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResolvedTechnicalIndicatorSpec>, I>>(
    base?: I
  ): ResolvedTechnicalIndicatorSpec {
    return ResolvedTechnicalIndicatorSpec.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResolvedTechnicalIndicatorSpec>, I>>(
    object: I
  ): ResolvedTechnicalIndicatorSpec {
    const message = createBaseResolvedTechnicalIndicatorSpec()
    message.indicatorType = object.indicatorType ?? 0
    message.tradeVenue = object.tradeVenue ?? 0
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.source = object.source ?? 0
    message.periodCount = object.periodCount ?? 0
    message.timeframeSeconds = object.timeframeSeconds ?? 0
    return message
  },
}

function createBaseResolvedReturnDescriptor(): ResolvedReturnDescriptor {
  return {
    tradeVenue: 0,
    exchange: 0,
    symbol: '',
    source: 0,
    windowMs: '0',
    operator: 0,
    normalizedThresholdPercent: '',
    timeframeSeconds: 0,
    maxStalenessMs: undefined,
  }
}

export const ResolvedReturnDescriptor: MessageFns<ResolvedReturnDescriptor> = {
  encode(
    message: ResolvedReturnDescriptor,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.tradeVenue !== 0) {
      writer.uint32(8).int32(message.tradeVenue)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(26).string(message.symbol)
    }
    if (message.source !== 0) {
      writer.uint32(32).int32(message.source)
    }
    if (message.windowMs !== '0') {
      writer.uint32(40).int64(message.windowMs)
    }
    if (message.operator !== 0) {
      writer.uint32(48).int32(message.operator)
    }
    if (message.normalizedThresholdPercent !== '') {
      writer.uint32(58).string(message.normalizedThresholdPercent)
    }
    if (message.timeframeSeconds !== 0) {
      writer.uint32(64).int32(message.timeframeSeconds)
    }
    if (message.maxStalenessMs !== undefined) {
      writer.uint32(72).int64(message.maxStalenessMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResolvedReturnDescriptor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResolvedReturnDescriptor()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.source = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.windowMs = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.operator = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.normalizedThresholdPercent = reader.string()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.timeframeSeconds = reader.int32() as any
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.maxStalenessMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResolvedReturnDescriptor {
    return {
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      source: isSet(object.source) ? priceReferenceFromJSON(object.source) : 0,
      windowMs: isSet(object.windowMs)
        ? globalThis.String(object.windowMs)
        : isSet(object.window_ms)
          ? globalThis.String(object.window_ms)
          : '0',
      operator: isSet(object.operator) ? comparisonOperatorFromJSON(object.operator) : 0,
      normalizedThresholdPercent: isSet(object.normalizedThresholdPercent)
        ? globalThis.String(object.normalizedThresholdPercent)
        : isSet(object.normalized_threshold_percent)
          ? globalThis.String(object.normalized_threshold_percent)
          : '',
      timeframeSeconds: isSet(object.timeframeSeconds)
        ? chartTimeframeFromJSON(object.timeframeSeconds)
        : isSet(object.timeframe_seconds)
          ? chartTimeframeFromJSON(object.timeframe_seconds)
          : 0,
      maxStalenessMs: isSet(object.maxStalenessMs)
        ? globalThis.String(object.maxStalenessMs)
        : isSet(object.max_staleness_ms)
          ? globalThis.String(object.max_staleness_ms)
          : undefined,
    }
  },

  toJSON(message: ResolvedReturnDescriptor): unknown {
    const obj: any = {}
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.source !== 0) {
      obj.source = priceReferenceToJSON(message.source)
    }
    if (message.windowMs !== '0') {
      obj.windowMs = message.windowMs
    }
    if (message.operator !== 0) {
      obj.operator = comparisonOperatorToJSON(message.operator)
    }
    if (message.normalizedThresholdPercent !== '') {
      obj.normalizedThresholdPercent = message.normalizedThresholdPercent
    }
    if (message.timeframeSeconds !== 0) {
      obj.timeframeSeconds = chartTimeframeToJSON(message.timeframeSeconds)
    }
    if (message.maxStalenessMs !== undefined) {
      obj.maxStalenessMs = message.maxStalenessMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResolvedReturnDescriptor>, I>>(
    base?: I
  ): ResolvedReturnDescriptor {
    return ResolvedReturnDescriptor.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResolvedReturnDescriptor>, I>>(
    object: I
  ): ResolvedReturnDescriptor {
    const message = createBaseResolvedReturnDescriptor()
    message.tradeVenue = object.tradeVenue ?? 0
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.source = object.source ?? 0
    message.windowMs = object.windowMs ?? '0'
    message.operator = object.operator ?? 0
    message.normalizedThresholdPercent = object.normalizedThresholdPercent ?? ''
    message.timeframeSeconds = object.timeframeSeconds ?? 0
    message.maxStalenessMs = object.maxStalenessMs ?? undefined
    return message
  },
}

function createBaseResolvedCandleDescriptor(): ResolvedCandleDescriptor {
  return {
    tradeVenue: 0,
    exchange: 0,
    symbol: '',
    timeframeSeconds: 0,
    field: 0,
    operator: 0,
    normalizedThreshold: '',
    allowOpenCandle: false,
    maxStalenessMs: undefined,
  }
}

export const ResolvedCandleDescriptor: MessageFns<ResolvedCandleDescriptor> = {
  encode(
    message: ResolvedCandleDescriptor,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.tradeVenue !== 0) {
      writer.uint32(8).int32(message.tradeVenue)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(26).string(message.symbol)
    }
    if (message.timeframeSeconds !== 0) {
      writer.uint32(32).int32(message.timeframeSeconds)
    }
    if (message.field !== 0) {
      writer.uint32(40).int32(message.field)
    }
    if (message.operator !== 0) {
      writer.uint32(48).int32(message.operator)
    }
    if (message.normalizedThreshold !== '') {
      writer.uint32(58).string(message.normalizedThreshold)
    }
    if (message.allowOpenCandle !== false) {
      writer.uint32(64).bool(message.allowOpenCandle)
    }
    if (message.maxStalenessMs !== undefined) {
      writer.uint32(72).int64(message.maxStalenessMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResolvedCandleDescriptor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResolvedCandleDescriptor()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.timeframeSeconds = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.field = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.operator = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.normalizedThreshold = reader.string()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.allowOpenCandle = reader.bool()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.maxStalenessMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResolvedCandleDescriptor {
    return {
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      timeframeSeconds: isSet(object.timeframeSeconds)
        ? chartTimeframeFromJSON(object.timeframeSeconds)
        : isSet(object.timeframe_seconds)
          ? chartTimeframeFromJSON(object.timeframe_seconds)
          : 0,
      field: isSet(object.field) ? candleFieldFromJSON(object.field) : 0,
      operator: isSet(object.operator) ? comparisonOperatorFromJSON(object.operator) : 0,
      normalizedThreshold: isSet(object.normalizedThreshold)
        ? globalThis.String(object.normalizedThreshold)
        : isSet(object.normalized_threshold)
          ? globalThis.String(object.normalized_threshold)
          : '',
      allowOpenCandle: isSet(object.allowOpenCandle)
        ? globalThis.Boolean(object.allowOpenCandle)
        : isSet(object.allow_open_candle)
          ? globalThis.Boolean(object.allow_open_candle)
          : false,
      maxStalenessMs: isSet(object.maxStalenessMs)
        ? globalThis.String(object.maxStalenessMs)
        : isSet(object.max_staleness_ms)
          ? globalThis.String(object.max_staleness_ms)
          : undefined,
    }
  },

  toJSON(message: ResolvedCandleDescriptor): unknown {
    const obj: any = {}
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.timeframeSeconds !== 0) {
      obj.timeframeSeconds = chartTimeframeToJSON(message.timeframeSeconds)
    }
    if (message.field !== 0) {
      obj.field = candleFieldToJSON(message.field)
    }
    if (message.operator !== 0) {
      obj.operator = comparisonOperatorToJSON(message.operator)
    }
    if (message.normalizedThreshold !== '') {
      obj.normalizedThreshold = message.normalizedThreshold
    }
    if (message.allowOpenCandle !== false) {
      obj.allowOpenCandle = message.allowOpenCandle
    }
    if (message.maxStalenessMs !== undefined) {
      obj.maxStalenessMs = message.maxStalenessMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResolvedCandleDescriptor>, I>>(
    base?: I
  ): ResolvedCandleDescriptor {
    return ResolvedCandleDescriptor.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResolvedCandleDescriptor>, I>>(
    object: I
  ): ResolvedCandleDescriptor {
    const message = createBaseResolvedCandleDescriptor()
    message.tradeVenue = object.tradeVenue ?? 0
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.timeframeSeconds = object.timeframeSeconds ?? 0
    message.field = object.field ?? 0
    message.operator = object.operator ?? 0
    message.normalizedThreshold = object.normalizedThreshold ?? ''
    message.allowOpenCandle = object.allowOpenCandle ?? false
    message.maxStalenessMs = object.maxStalenessMs ?? undefined
    return message
  },
}

function createBaseResolvedPortfolioMetricDescriptor(): ResolvedPortfolioMetricDescriptor {
  return {
    accountId: '',
    metric: 0,
    operator: 0,
    normalizedThreshold: '',
    maxStalenessMs: undefined,
    currency: undefined,
  }
}

export const ResolvedPortfolioMetricDescriptor: MessageFns<ResolvedPortfolioMetricDescriptor> = {
  encode(
    message: ResolvedPortfolioMetricDescriptor,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.metric !== 0) {
      writer.uint32(16).int32(message.metric)
    }
    if (message.operator !== 0) {
      writer.uint32(24).int32(message.operator)
    }
    if (message.normalizedThreshold !== '') {
      writer.uint32(34).string(message.normalizedThreshold)
    }
    if (message.maxStalenessMs !== undefined) {
      writer.uint32(40).int64(message.maxStalenessMs)
    }
    if (message.currency !== undefined) {
      writer.uint32(50).string(message.currency)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResolvedPortfolioMetricDescriptor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResolvedPortfolioMetricDescriptor()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.metric = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.operator = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.normalizedThreshold = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.maxStalenessMs = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.currency = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResolvedPortfolioMetricDescriptor {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      metric: isSet(object.metric) ? portfolioMetricFromJSON(object.metric) : 0,
      operator: isSet(object.operator) ? comparisonOperatorFromJSON(object.operator) : 0,
      normalizedThreshold: isSet(object.normalizedThreshold)
        ? globalThis.String(object.normalizedThreshold)
        : isSet(object.normalized_threshold)
          ? globalThis.String(object.normalized_threshold)
          : '',
      maxStalenessMs: isSet(object.maxStalenessMs)
        ? globalThis.String(object.maxStalenessMs)
        : isSet(object.max_staleness_ms)
          ? globalThis.String(object.max_staleness_ms)
          : undefined,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : undefined,
    }
  },

  toJSON(message: ResolvedPortfolioMetricDescriptor): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.metric !== 0) {
      obj.metric = portfolioMetricToJSON(message.metric)
    }
    if (message.operator !== 0) {
      obj.operator = comparisonOperatorToJSON(message.operator)
    }
    if (message.normalizedThreshold !== '') {
      obj.normalizedThreshold = message.normalizedThreshold
    }
    if (message.maxStalenessMs !== undefined) {
      obj.maxStalenessMs = message.maxStalenessMs
    }
    if (message.currency !== undefined) {
      obj.currency = message.currency
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResolvedPortfolioMetricDescriptor>, I>>(
    base?: I
  ): ResolvedPortfolioMetricDescriptor {
    return ResolvedPortfolioMetricDescriptor.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResolvedPortfolioMetricDescriptor>, I>>(
    object: I
  ): ResolvedPortfolioMetricDescriptor {
    const message = createBaseResolvedPortfolioMetricDescriptor()
    message.accountId = object.accountId ?? ''
    message.metric = object.metric ?? 0
    message.operator = object.operator ?? 0
    message.normalizedThreshold = object.normalizedThreshold ?? ''
    message.maxStalenessMs = object.maxStalenessMs ?? undefined
    message.currency = object.currency ?? undefined
    return message
  },
}

function createBaseResolvedPositionMetricDescriptor(): ResolvedPositionMetricDescriptor {
  return {
    accountId: '',
    scope: undefined,
    metric: 0,
    operator: 0,
    normalizedThreshold: '',
    maxStalenessMs: undefined,
  }
}

export const ResolvedPositionMetricDescriptor: MessageFns<ResolvedPositionMetricDescriptor> = {
  encode(
    message: ResolvedPositionMetricDescriptor,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.scope !== undefined) {
      PositionMetricScope.encode(message.scope, writer.uint32(18).fork()).join()
    }
    if (message.metric !== 0) {
      writer.uint32(24).int32(message.metric)
    }
    if (message.operator !== 0) {
      writer.uint32(32).int32(message.operator)
    }
    if (message.normalizedThreshold !== '') {
      writer.uint32(42).string(message.normalizedThreshold)
    }
    if (message.maxStalenessMs !== undefined) {
      writer.uint32(48).int64(message.maxStalenessMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResolvedPositionMetricDescriptor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResolvedPositionMetricDescriptor()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.scope = PositionMetricScope.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.metric = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.operator = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.normalizedThreshold = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.maxStalenessMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResolvedPositionMetricDescriptor {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      scope: isSet(object.scope) ? PositionMetricScope.fromJSON(object.scope) : undefined,
      metric: isSet(object.metric) ? positionMetricFromJSON(object.metric) : 0,
      operator: isSet(object.operator) ? comparisonOperatorFromJSON(object.operator) : 0,
      normalizedThreshold: isSet(object.normalizedThreshold)
        ? globalThis.String(object.normalizedThreshold)
        : isSet(object.normalized_threshold)
          ? globalThis.String(object.normalized_threshold)
          : '',
      maxStalenessMs: isSet(object.maxStalenessMs)
        ? globalThis.String(object.maxStalenessMs)
        : isSet(object.max_staleness_ms)
          ? globalThis.String(object.max_staleness_ms)
          : undefined,
    }
  },

  toJSON(message: ResolvedPositionMetricDescriptor): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.scope !== undefined) {
      obj.scope = PositionMetricScope.toJSON(message.scope)
    }
    if (message.metric !== 0) {
      obj.metric = positionMetricToJSON(message.metric)
    }
    if (message.operator !== 0) {
      obj.operator = comparisonOperatorToJSON(message.operator)
    }
    if (message.normalizedThreshold !== '') {
      obj.normalizedThreshold = message.normalizedThreshold
    }
    if (message.maxStalenessMs !== undefined) {
      obj.maxStalenessMs = message.maxStalenessMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResolvedPositionMetricDescriptor>, I>>(
    base?: I
  ): ResolvedPositionMetricDescriptor {
    return ResolvedPositionMetricDescriptor.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResolvedPositionMetricDescriptor>, I>>(
    object: I
  ): ResolvedPositionMetricDescriptor {
    const message = createBaseResolvedPositionMetricDescriptor()
    message.accountId = object.accountId ?? ''
    message.scope =
      object.scope !== undefined && object.scope !== null
        ? PositionMetricScope.fromPartial(object.scope)
        : undefined
    message.metric = object.metric ?? 0
    message.operator = object.operator ?? 0
    message.normalizedThreshold = object.normalizedThreshold ?? ''
    message.maxStalenessMs = object.maxStalenessMs ?? undefined
    return message
  },
}

function createBaseResolvedRiskMetricDescriptor(): ResolvedRiskMetricDescriptor {
  return {
    accountId: '',
    asset: '',
    metric: 0,
    operator: 0,
    normalizedThreshold: '',
    maxStalenessMs: undefined,
  }
}

export const ResolvedRiskMetricDescriptor: MessageFns<ResolvedRiskMetricDescriptor> = {
  encode(
    message: ResolvedRiskMetricDescriptor,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.asset !== '') {
      writer.uint32(18).string(message.asset)
    }
    if (message.metric !== 0) {
      writer.uint32(24).int32(message.metric)
    }
    if (message.operator !== 0) {
      writer.uint32(32).int32(message.operator)
    }
    if (message.normalizedThreshold !== '') {
      writer.uint32(42).string(message.normalizedThreshold)
    }
    if (message.maxStalenessMs !== undefined) {
      writer.uint32(48).int64(message.maxStalenessMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResolvedRiskMetricDescriptor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResolvedRiskMetricDescriptor()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.asset = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.metric = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.operator = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.normalizedThreshold = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.maxStalenessMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResolvedRiskMetricDescriptor {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      asset: isSet(object.asset) ? globalThis.String(object.asset) : '',
      metric: isSet(object.metric) ? riskMetricFromJSON(object.metric) : 0,
      operator: isSet(object.operator) ? comparisonOperatorFromJSON(object.operator) : 0,
      normalizedThreshold: isSet(object.normalizedThreshold)
        ? globalThis.String(object.normalizedThreshold)
        : isSet(object.normalized_threshold)
          ? globalThis.String(object.normalized_threshold)
          : '',
      maxStalenessMs: isSet(object.maxStalenessMs)
        ? globalThis.String(object.maxStalenessMs)
        : isSet(object.max_staleness_ms)
          ? globalThis.String(object.max_staleness_ms)
          : undefined,
    }
  },

  toJSON(message: ResolvedRiskMetricDescriptor): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.asset !== '') {
      obj.asset = message.asset
    }
    if (message.metric !== 0) {
      obj.metric = riskMetricToJSON(message.metric)
    }
    if (message.operator !== 0) {
      obj.operator = comparisonOperatorToJSON(message.operator)
    }
    if (message.normalizedThreshold !== '') {
      obj.normalizedThreshold = message.normalizedThreshold
    }
    if (message.maxStalenessMs !== undefined) {
      obj.maxStalenessMs = message.maxStalenessMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResolvedRiskMetricDescriptor>, I>>(
    base?: I
  ): ResolvedRiskMetricDescriptor {
    return ResolvedRiskMetricDescriptor.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResolvedRiskMetricDescriptor>, I>>(
    object: I
  ): ResolvedRiskMetricDescriptor {
    const message = createBaseResolvedRiskMetricDescriptor()
    message.accountId = object.accountId ?? ''
    message.asset = object.asset ?? ''
    message.metric = object.metric ?? 0
    message.operator = object.operator ?? 0
    message.normalizedThreshold = object.normalizedThreshold ?? ''
    message.maxStalenessMs = object.maxStalenessMs ?? undefined
    return message
  },
}

function createBaseResolvedOptionIvDescriptor(): ResolvedOptionIvDescriptor {
  return {
    instrument: undefined,
    source: 0,
    operator: 0,
    normalizedThresholdPercent: '',
    maxStalenessMs: undefined,
  }
}

export const ResolvedOptionIvDescriptor: MessageFns<ResolvedOptionIvDescriptor> = {
  encode(
    message: ResolvedOptionIvDescriptor,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.instrument !== undefined) {
      TriggerOptionInstrumentRef.encode(message.instrument, writer.uint32(10).fork()).join()
    }
    if (message.source !== 0) {
      writer.uint32(16).int32(message.source)
    }
    if (message.operator !== 0) {
      writer.uint32(24).int32(message.operator)
    }
    if (message.normalizedThresholdPercent !== '') {
      writer.uint32(34).string(message.normalizedThresholdPercent)
    }
    if (message.maxStalenessMs !== undefined) {
      writer.uint32(40).int64(message.maxStalenessMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResolvedOptionIvDescriptor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResolvedOptionIvDescriptor()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.instrument = TriggerOptionInstrumentRef.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.source = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.operator = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.normalizedThresholdPercent = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.maxStalenessMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResolvedOptionIvDescriptor {
    return {
      instrument: isSet(object.instrument)
        ? TriggerOptionInstrumentRef.fromJSON(object.instrument)
        : undefined,
      source: isSet(object.source) ? optionIvSourceFromJSON(object.source) : 0,
      operator: isSet(object.operator) ? comparisonOperatorFromJSON(object.operator) : 0,
      normalizedThresholdPercent: isSet(object.normalizedThresholdPercent)
        ? globalThis.String(object.normalizedThresholdPercent)
        : isSet(object.normalized_threshold_percent)
          ? globalThis.String(object.normalized_threshold_percent)
          : '',
      maxStalenessMs: isSet(object.maxStalenessMs)
        ? globalThis.String(object.maxStalenessMs)
        : isSet(object.max_staleness_ms)
          ? globalThis.String(object.max_staleness_ms)
          : undefined,
    }
  },

  toJSON(message: ResolvedOptionIvDescriptor): unknown {
    const obj: any = {}
    if (message.instrument !== undefined) {
      obj.instrument = TriggerOptionInstrumentRef.toJSON(message.instrument)
    }
    if (message.source !== 0) {
      obj.source = optionIvSourceToJSON(message.source)
    }
    if (message.operator !== 0) {
      obj.operator = comparisonOperatorToJSON(message.operator)
    }
    if (message.normalizedThresholdPercent !== '') {
      obj.normalizedThresholdPercent = message.normalizedThresholdPercent
    }
    if (message.maxStalenessMs !== undefined) {
      obj.maxStalenessMs = message.maxStalenessMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResolvedOptionIvDescriptor>, I>>(
    base?: I
  ): ResolvedOptionIvDescriptor {
    return ResolvedOptionIvDescriptor.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResolvedOptionIvDescriptor>, I>>(
    object: I
  ): ResolvedOptionIvDescriptor {
    const message = createBaseResolvedOptionIvDescriptor()
    message.instrument =
      object.instrument !== undefined && object.instrument !== null
        ? TriggerOptionInstrumentRef.fromPartial(object.instrument)
        : undefined
    message.source = object.source ?? 0
    message.operator = object.operator ?? 0
    message.normalizedThresholdPercent = object.normalizedThresholdPercent ?? ''
    message.maxStalenessMs = object.maxStalenessMs ?? undefined
    return message
  },
}

function createBaseResolvedDbNewsDescriptor(): ResolvedDbNewsDescriptor {
  return {
    eeType: [],
    newsType: [],
    coins: [],
    tags: [],
    textContains: [],
    eventNotBeforeMs: undefined,
  }
}

export const ResolvedDbNewsDescriptor: MessageFns<ResolvedDbNewsDescriptor> = {
  encode(
    message: ResolvedDbNewsDescriptor,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.eeType) {
      writer.uint32(10).string(v!)
    }
    for (const v of message.newsType) {
      writer.uint32(18).string(v!)
    }
    for (const v of message.coins) {
      writer.uint32(26).string(v!)
    }
    for (const v of message.tags) {
      writer.uint32(34).string(v!)
    }
    for (const v of message.textContains) {
      writer.uint32(42).string(v!)
    }
    if (message.eventNotBeforeMs !== undefined) {
      writer.uint32(48).int64(message.eventNotBeforeMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResolvedDbNewsDescriptor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResolvedDbNewsDescriptor()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.eeType.push(reader.string())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.newsType.push(reader.string())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.coins.push(reader.string())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.tags.push(reader.string())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.textContains.push(reader.string())
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.eventNotBeforeMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResolvedDbNewsDescriptor {
    return {
      eeType: globalThis.Array.isArray(object?.eeType)
        ? object.eeType.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ee_type)
          ? object.ee_type.map((e: any) => globalThis.String(e))
          : [],
      newsType: globalThis.Array.isArray(object?.newsType)
        ? object.newsType.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.news_type)
          ? object.news_type.map((e: any) => globalThis.String(e))
          : [],
      coins: globalThis.Array.isArray(object?.coins)
        ? object.coins.map((e: any) => globalThis.String(e))
        : [],
      tags: globalThis.Array.isArray(object?.tags)
        ? object.tags.map((e: any) => globalThis.String(e))
        : [],
      textContains: globalThis.Array.isArray(object?.textContains)
        ? object.textContains.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.text_contains)
          ? object.text_contains.map((e: any) => globalThis.String(e))
          : [],
      eventNotBeforeMs: isSet(object.eventNotBeforeMs)
        ? globalThis.String(object.eventNotBeforeMs)
        : isSet(object.event_not_before_ms)
          ? globalThis.String(object.event_not_before_ms)
          : undefined,
    }
  },

  toJSON(message: ResolvedDbNewsDescriptor): unknown {
    const obj: any = {}
    if (message.eeType?.length) {
      obj.eeType = message.eeType
    }
    if (message.newsType?.length) {
      obj.newsType = message.newsType
    }
    if (message.coins?.length) {
      obj.coins = message.coins
    }
    if (message.tags?.length) {
      obj.tags = message.tags
    }
    if (message.textContains?.length) {
      obj.textContains = message.textContains
    }
    if (message.eventNotBeforeMs !== undefined) {
      obj.eventNotBeforeMs = message.eventNotBeforeMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResolvedDbNewsDescriptor>, I>>(
    base?: I
  ): ResolvedDbNewsDescriptor {
    return ResolvedDbNewsDescriptor.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResolvedDbNewsDescriptor>, I>>(
    object: I
  ): ResolvedDbNewsDescriptor {
    const message = createBaseResolvedDbNewsDescriptor()
    message.eeType = object.eeType?.map((e) => e) || []
    message.newsType = object.newsType?.map((e) => e) || []
    message.coins = object.coins?.map((e) => e) || []
    message.tags = object.tags?.map((e) => e) || []
    message.textContains = object.textContains?.map((e) => e) || []
    message.eventNotBeforeMs = object.eventNotBeforeMs ?? undefined
    return message
  },
}

function createBaseResolvedPolymarketDescriptor(): ResolvedPolymarketDescriptor {
  return { tokenId: '', operator: 0, normalizedThreshold: '' }
}

export const ResolvedPolymarketDescriptor: MessageFns<ResolvedPolymarketDescriptor> = {
  encode(
    message: ResolvedPolymarketDescriptor,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.tokenId !== '') {
      writer.uint32(10).string(message.tokenId)
    }
    if (message.operator !== 0) {
      writer.uint32(16).int32(message.operator)
    }
    if (message.normalizedThreshold !== '') {
      writer.uint32(26).string(message.normalizedThreshold)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResolvedPolymarketDescriptor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResolvedPolymarketDescriptor()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.tokenId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.operator = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.normalizedThreshold = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResolvedPolymarketDescriptor {
    return {
      tokenId: isSet(object.tokenId)
        ? globalThis.String(object.tokenId)
        : isSet(object.token_id)
          ? globalThis.String(object.token_id)
          : '',
      operator: isSet(object.operator) ? comparisonOperatorFromJSON(object.operator) : 0,
      normalizedThreshold: isSet(object.normalizedThreshold)
        ? globalThis.String(object.normalizedThreshold)
        : isSet(object.normalized_threshold)
          ? globalThis.String(object.normalized_threshold)
          : '',
    }
  },

  toJSON(message: ResolvedPolymarketDescriptor): unknown {
    const obj: any = {}
    if (message.tokenId !== '') {
      obj.tokenId = message.tokenId
    }
    if (message.operator !== 0) {
      obj.operator = comparisonOperatorToJSON(message.operator)
    }
    if (message.normalizedThreshold !== '') {
      obj.normalizedThreshold = message.normalizedThreshold
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResolvedPolymarketDescriptor>, I>>(
    base?: I
  ): ResolvedPolymarketDescriptor {
    return ResolvedPolymarketDescriptor.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResolvedPolymarketDescriptor>, I>>(
    object: I
  ): ResolvedPolymarketDescriptor {
    const message = createBaseResolvedPolymarketDescriptor()
    message.tokenId = object.tokenId ?? ''
    message.operator = object.operator ?? 0
    message.normalizedThreshold = object.normalizedThreshold ?? ''
    return message
  },
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends globalThis.Array<infer U>
    ? globalThis.Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
      ? ReadonlyArray<DeepPartial<U>>
      : T extends {}
        ? { [K in keyof T]?: DeepPartial<T[K]> }
        : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never }

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter
  decode(input: BinaryReader | Uint8Array, length?: number): T
  fromJSON(object: any): T
  toJSON(message: T): unknown
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T
}
